(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46df"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46df"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5WGJt", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !!timeScale; // as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, reverseEase = vars.easeReverse || yoyoEase, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._rEase = reverseEase && (_parseEase(reverseEase) || tween._ease);
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (tween._from) tween.ratio = 1;
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) // from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset. Try splitting into individual properties") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            var easeReverse = vars.easeReverse || vars.yoyoEase;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    easeReverse && (copy.easeReverse = easeReverse);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) time = dur - time;
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) //repeatRefresh functionality
                {
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            if (this._rEase) {
                var inv = time < prevTime;
                if (inv !== this._inv) {
                    var segDur = inv ? prevTime : dur - prevTime;
                    this._inv = inv;
                    if (this._from) this.ratio = 1 - this.ratio;
                    this._invRatio = this.ratio;
                    this._invTime = prevTime;
                    this._invRecip = segDur ? (inv ? -1 : 1) / segDur : 0;
                    this._invScale = inv ? -this.ratio : 1 - this.ratio;
                    this._invEase = inv ? this._rEase : this._ease;
                }
                this.ratio = ratio = this._invRatio + this._invScale * this._invEase((time - this._invTime) * this._invRecip);
            } else this.ratio = ratio = this._ease(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.15.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

/** Keeps track of raw listeners added to the base elements to avoid duplication */ const $dffe428edf3fc024$var$ledger = new WeakMap();
function $dffe428edf3fc024$var$editLedger(wanted, baseElement, callback, setup) {
    if (!wanted && !$dffe428edf3fc024$var$ledger.has(baseElement)) return false;
    const elementMap = $dffe428edf3fc024$var$ledger.get(baseElement) ?? new WeakMap();
    $dffe428edf3fc024$var$ledger.set(baseElement, elementMap);
    const setups = elementMap.get(callback) ?? new Set();
    elementMap.set(callback, setups);
    const existed = setups.has(setup);
    if (wanted) setups.add(setup);
    else setups.delete(setup);
    return existed && wanted;
}
function $dffe428edf3fc024$var$safeClosest(event, selector) {
    let target = event.target;
    if (target instanceof Text) target = target.parentElement;
    // The currentTarget could be an Element or e.g. a ShadowRoot
    if (target instanceof Element && event.currentTarget instanceof Node) {
        // `.closest()` may match ancestors of `currentTarget` but we only need its children
        const closest = target.closest(selector);
        if (closest && event.currentTarget.contains(closest)) return closest;
    }
}
// This type isn't exported as a declaration, so it needs to be duplicated above
function $dffe428edf3fc024$var$delegate(selector, type, callback, options = {}) {
    if (Array.isArray(type)) {
        for (const t of type)$dffe428edf3fc024$var$delegate(selector, t, callback, options);
        return;
    }
    // After the Array.isArray early-return above, `type` is a single event type string.
    // TypeScript doesn't narrow generic union types through Array.isArray, so we cast here.
    const singleType = type;
    const { signal: signal, base: base = document } = options;
    if (signal?.aborted) return;
    // Don't pass `once` to `addEventListener` because it needs to be handled in `delegate-it`
    const { once: once, ...nativeListenerOptions } = options;
    // `document` should never be the base, it's just an easy way to define "global event listeners"
    const baseElement = base instanceof Document ? base.documentElement : base;
    // Handle the regular Element usage
    const capture = Boolean(typeof options === 'object' ? options.capture : options);
    const listenerFunction = (event)=>{
        const delegateTarget = $dffe428edf3fc024$var$safeClosest(event, String(selector));
        if (delegateTarget) {
            const delegateEvent = Object.assign(event, {
                delegateTarget: delegateTarget
            });
            callback.call(baseElement, delegateEvent);
            if (once) {
                baseElement.removeEventListener(singleType, listenerFunction, nativeListenerOptions);
                $dffe428edf3fc024$var$editLedger(false, baseElement, callback, setup);
            }
        }
    };
    const setup = JSON.stringify({
        selector: selector,
        type: singleType,
        capture: capture
    });
    const isAlreadyListening = $dffe428edf3fc024$var$editLedger(true, baseElement, callback, setup);
    if (!isAlreadyListening) baseElement.addEventListener(singleType, listenerFunction, nativeListenerOptions);
    signal?.addEventListener('abort', ()=>{
        $dffe428edf3fc024$var$editLedger(false, baseElement, callback, setup);
    });
}
var $dffe428edf3fc024$export$2e2bcd8739ae039 = $dffe428edf3fc024$var$delegate;



// This type isn't exported as a declaration, so it needs to be duplicated above
async function $c2aeb8a530ca0aae$var$oneEvent(selector, type, options = {}) {
    return new Promise((resolve)=>{
        const { filter: filter, ...delegateOptions } = options;
        if (delegateOptions.signal?.aborted) {
            resolve(undefined);
            return;
        }
        if (filter) {
            const controller = new AbortController();
            delegateOptions.signal?.addEventListener('abort', ()=>{
                controller.abort();
                resolve(undefined);
            });
            (0, $dffe428edf3fc024$export$2e2bcd8739ae039)(selector, type, (event)=>{
                if (filter(event)) {
                    controller.abort();
                    resolve(event);
                }
            }, {
                ...delegateOptions,
                signal: controller.signal
            });
        } else {
            delegateOptions.signal?.addEventListener('abort', ()=>{
                resolve(undefined);
            });
            (0, $dffe428edf3fc024$export$2e2bcd8739ae039)(selector, type, resolve, {
                ...delegateOptions,
                once: true
            });
        }
    });
}
var $c2aeb8a530ca0aae$export$2e2bcd8739ae039 = $c2aeb8a530ca0aae$var$oneEvent;




/**
 * Tokenize input string.
 */ function $602a88b18bfeeda0$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $602a88b18bfeeda0$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $602a88b18bfeeda0$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($602a88b18bfeeda0$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($602a88b18bfeeda0$var$escapeString(prevText), ")[^").concat($602a88b18bfeeda0$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $602a88b18bfeeda0$export$ef7acd7185315e22(str, options) {
    return $602a88b18bfeeda0$export$5b9bad9e403cf3d9($602a88b18bfeeda0$export$98e6a39c04603d36(str, options), options);
}
function $602a88b18bfeeda0$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $602a88b18bfeeda0$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $602a88b18bfeeda0$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $602a88b18bfeeda0$export$71304158c7e35877(str, keys, options);
    return $602a88b18bfeeda0$export$968e97c88708237a(re, keys, options);
}
function $602a88b18bfeeda0$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $602a88b18bfeeda0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $602a88b18bfeeda0$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $602a88b18bfeeda0$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $602a88b18bfeeda0$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $602a88b18bfeeda0$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $602a88b18bfeeda0$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $602a88b18bfeeda0$var$stringToRegexp(path, keys, options) {
    return $602a88b18bfeeda0$export$9a9303716def6456($602a88b18bfeeda0$export$98e6a39c04603d36(path, options), keys, options);
}
function $602a88b18bfeeda0$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($602a88b18bfeeda0$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($602a88b18bfeeda0$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $602a88b18bfeeda0$var$escapeString(encode(token));
        else {
            var prefix = $602a88b18bfeeda0$var$escapeString(encode(token.prefix));
            var suffix = $602a88b18bfeeda0$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $602a88b18bfeeda0$var$flags(options));
}
function $602a88b18bfeeda0$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $602a88b18bfeeda0$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $602a88b18bfeeda0$var$arrayToRegexp(path, keys, options);
    return $602a88b18bfeeda0$var$stringToRegexp(path, keys, options);
}


const $d756dbc053e9c131$export$b04d9b8d414ba5e8 = (t, e)=>String(t).toLowerCase().replace(/[\s/_.]+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "") || e || "", $d756dbc053e9c131$export$dc90482e4ef07afd = ({ hash: t } = {})=>window.location.pathname + window.location.search + (t ? window.location.hash : ""), $d756dbc053e9c131$export$c38a4311235454af = (t, e = {})=>{
    const n = {
        url: t = t || $d756dbc053e9c131$export$dc90482e4ef07afd({
            hash: !0
        }),
        random: Math.random(),
        source: "swup",
        ...e
    };
    window.history.pushState(n, "", t);
}, $d756dbc053e9c131$export$9dd2847e0d2d8b0 = (t = null, e = {})=>{
    t = t || $d756dbc053e9c131$export$dc90482e4ef07afd({
        hash: !0
    });
    const n = {
        ...window.history.state || {},
        url: t,
        random: Math.random(),
        source: "swup",
        ...e
    };
    window.history.replaceState(n, "", t);
}, $d756dbc053e9c131$export$b93d41a1bb659592 = (e, n, o, r)=>{
    const i = new AbortController;
    return r = {
        ...r,
        signal: i.signal
    }, (0, $dffe428edf3fc024$export$2e2bcd8739ae039)(e, n, o, r), {
        destroy: ()=>i.abort()
    };
};
class $d756dbc053e9c131$export$18a2be9195644f38 extends URL {
    constructor(t, e = document.baseURI){
        super(t.toString(), e), Object.setPrototypeOf(this, $d756dbc053e9c131$export$18a2be9195644f38.prototype);
    }
    get url() {
        return this.pathname + this.search;
    }
    static fromElement(t) {
        const e = t.getAttribute("href") || t.getAttribute("xlink:href") || "";
        return new $d756dbc053e9c131$export$18a2be9195644f38(e);
    }
    static fromUrl(t) {
        return new $d756dbc053e9c131$export$18a2be9195644f38(t);
    }
}
const $d756dbc053e9c131$export$81336c211d5ff295 = (t, n)=>{
    Array.isArray(t) && !t.length && (t = "");
    try {
        return (0, $602a88b18bfeeda0$export$4659b591c19bdf3d)(t, n);
    } catch (e) {
        throw new Error(`[swup] Error parsing path "${String(t)}":\n${String(e)}`, {
            cause: e
        });
    }
}, $d756dbc053e9c131$var$l = function(t, e = {}) {
    try {
        const o = this;
        function n(n) {
            const { status: i, url: s } = u;
            return Promise.resolve(u.text()).then(function(n) {
                if (500 === i) throw o.hooks.call("fetch:error", r, {
                    status: i,
                    response: u,
                    url: s
                }), new $d756dbc053e9c131$var$h(`Server error: ${s}`, {
                    status: i,
                    url: s
                });
                if (!n) throw new $d756dbc053e9c131$var$h(`Empty response: ${s}`, {
                    status: i,
                    url: s
                });
                const { url: c } = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(s), l = {
                    url: c,
                    html: n
                };
                return !r.cache.write || e.method && "GET" !== e.method || t !== c || o.cache.set(l.url, l), l;
            });
        }
        t = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(t).url;
        const { visit: r = o.visit } = e, i = {
            ...o.options.requestHeaders,
            ...e.headers
        }, s = e.timeout ?? o.options.timeout, c = new AbortController, { signal: l } = c;
        e = {
            ...e,
            headers: i,
            signal: l
        };
        let u, d = !1, m = null;
        s && s > 0 && (m = setTimeout(()=>{
            d = !0, c.abort("timeout");
        }, s));
        const f = function(n, i) {
            try {
                var s = Promise.resolve(o.hooks.call("fetch:request", r, {
                    url: t,
                    options: e
                }, (t, { url: e, options: n })=>fetch(e, n))).then(function(t) {
                    u = t, m && clearTimeout(m);
                });
            } catch (t) {
                return i(t);
            }
            return s && s.then ? s.then(void 0, i) : s;
        }(0, function(e) {
            if (d) throw o.hooks.call("fetch:timeout", r, {
                url: t
            }), new $d756dbc053e9c131$var$h(`Request timed out: ${t}`, {
                url: t,
                timedOut: d
            });
            if ("AbortError" === e?.name || l.aborted) throw new $d756dbc053e9c131$var$h(`Request aborted: ${t}`, {
                url: t,
                aborted: !0
            });
            throw e;
        });
        return Promise.resolve(f && f.then ? f.then(n) : n());
    } catch (p) {
        return Promise.reject(p);
    }
};
class $d756dbc053e9c131$var$h extends Error {
    constructor(t, e){
        super(t), this.url = void 0, this.status = void 0, this.aborted = void 0, this.timedOut = void 0, this.name = "FetchError", this.url = e.url, this.status = e.status, this.aborted = e.aborted || !1, this.timedOut = e.timedOut || !1;
    }
}
class $d756dbc053e9c131$var$u {
    constructor(t){
        this.swup = void 0, this.pages = new Map, this.swup = t;
    }
    get size() {
        return this.pages.size;
    }
    get all() {
        const t = new Map;
        return this.pages.forEach((e, n)=>{
            t.set(n, {
                ...e
            });
        }), t;
    }
    has(t) {
        return this.pages.has(this.resolve(t));
    }
    get(t) {
        const e = this.pages.get(this.resolve(t));
        return e ? {
            ...e
        } : e;
    }
    set(t, e) {
        t = this.resolve(t), e = {
            ...e,
            url: t
        }, this.pages.set(t, e), this.swup.hooks.callSync("cache:set", void 0, {
            page: e
        });
    }
    update(t, e) {
        t = this.resolve(t);
        const n = {
            ...this.get(t),
            ...e,
            url: t
        };
        this.pages.set(t, n);
    }
    delete(t) {
        this.pages.delete(this.resolve(t));
    }
    clear() {
        this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
    }
    prune(t) {
        this.pages.forEach((e, n)=>{
            t(n, e) && this.delete(n);
        });
    }
    resolve(t) {
        const { url: e } = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(t);
        return this.swup.resolveUrl(e);
    }
}
const $d756dbc053e9c131$export$2fa187e846a241c4 = (t, e = document)=>e.querySelector(t), $d756dbc053e9c131$export$dcd0d083aa86c355 = (t, e = document)=>Array.from(e.querySelectorAll(t)), $d756dbc053e9c131$export$bdd553fddd433dcb = ()=>new Promise((t)=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                t();
            });
        });
    });
function $d756dbc053e9c131$export$4369c812aac99591(t) {
    return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then;
}
function $d756dbc053e9c131$export$8586fbe018c72b76(t, e = []) {
    return new Promise((n, o)=>{
        const r = t(...e);
        $d756dbc053e9c131$export$4369c812aac99591(r) ? r.then(n, o) : n(r);
    });
}
function $d756dbc053e9c131$export$7d26bbb1236dafd6(t) {
    t = t || document.body, t?.getBoundingClientRect();
}
function $d756dbc053e9c131$export$bfb619fe77197843(t, e) {
    const n = t?.closest(`[${e}]`);
    return n?.hasAttribute(e) ? n?.getAttribute(e) || !0 : void 0;
}
class $d756dbc053e9c131$var$y {
    constructor(t){
        this.swup = void 0, this.swupClasses = [
            "to-",
            "is-changing",
            "is-rendering",
            "is-popstate",
            "is-animating",
            "is-leaving"
        ], this.swup = t;
    }
    get selectors() {
        const { scope: t } = this.swup.visit.animation;
        return "containers" === t ? this.swup.visit.containers : "html" === t ? [
            "html"
        ] : Array.isArray(t) ? t : [];
    }
    get selector() {
        return this.selectors.join(",");
    }
    get targets() {
        return this.selector.trim() ? $d756dbc053e9c131$export$dcd0d083aa86c355(this.selector) : [];
    }
    add() {
        this.targets.forEach((t)=>t.classList.add(...[].slice.call(arguments)));
    }
    remove() {
        this.targets.forEach((t)=>t.classList.remove(...[].slice.call(arguments)));
    }
    clear() {
        this.targets.forEach((t)=>{
            const e = t.className.split(" ").filter((t)=>this.isSwupClass(t));
            t.classList.remove(...e);
        });
    }
    isSwupClass(t) {
        return this.swupClasses.some((e)=>t.startsWith(e));
    }
}
class $d756dbc053e9c131$var$k {
    constructor(t, e){
        this.id = void 0, this.state = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.animation = void 0, this.trigger = void 0, this.cache = void 0, this.history = void 0, this.scroll = void 0, this.meta = void 0;
        const { to: n, from: o, hash: r, el: i, event: s } = e;
        this.id = Math.random(), this.state = 1, this.from = {
            url: o ?? t.location.url,
            hash: t.location.hash
        }, this.to = {
            url: n,
            hash: r
        }, this.containers = t.options.containers, this.animation = {
            animate: !0,
            wait: !1,
            name: void 0,
            native: t.options.native,
            scope: t.options.animationScope,
            selector: t.options.animationSelector
        }, this.trigger = {
            el: i,
            event: s
        }, this.cache = {
            read: t.options.cache,
            write: t.options.cache
        }, this.history = {
            action: "push",
            popstate: !1,
            direction: void 0
        }, this.scroll = {
            reset: !0,
            target: void 0
        }, this.meta = {};
    }
    advance(t) {
        this.state < t && (this.state = t);
    }
    abort() {
        this.state = 8;
    }
    ignore() {
        this.state = 10;
    }
    get done() {
        return this.state >= 7;
    }
    get ignored() {
        return 10 === this.state;
    }
}
function $d756dbc053e9c131$var$P(t) {
    return new $d756dbc053e9c131$var$k(this, t);
}
const $d756dbc053e9c131$var$b = "undefined" != typeof Symbol ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function $d756dbc053e9c131$var$S(t, e, n) {
    if (!t.s) {
        if (n instanceof $d756dbc053e9c131$var$E) {
            if (!n.s) return void (n.o = $d756dbc053e9c131$var$S.bind(null, t, e));
            1 & e && (e = n.s), n = n.v;
        }
        if (n && n.then) return void n.then($d756dbc053e9c131$var$S.bind(null, t, e), $d756dbc053e9c131$var$S.bind(null, t, 2));
        t.s = e, t.v = n;
        const o = t.o;
        o && o(t);
    }
}
const $d756dbc053e9c131$var$E = /*#__PURE__*/ function() {
    function t() {}
    return t.prototype.then = function(e, n) {
        const o = new t, r = this.s;
        if (r) {
            const t = 1 & r ? e : n;
            if (t) {
                try {
                    $d756dbc053e9c131$var$S(o, 1, t(this.v));
                } catch (t) {
                    $d756dbc053e9c131$var$S(o, 2, t);
                }
                return o;
            }
            return this;
        }
        return this.o = function(t) {
            try {
                const r = t.v;
                1 & t.s ? $d756dbc053e9c131$var$S(o, 1, e ? e(r) : r) : n ? $d756dbc053e9c131$var$S(o, 1, n(r)) : $d756dbc053e9c131$var$S(o, 2, r);
            } catch (t) {
                $d756dbc053e9c131$var$S(o, 2, t);
            }
        }, o;
    }, t;
}();
function $d756dbc053e9c131$var$C(t) {
    return t instanceof $d756dbc053e9c131$var$E && 1 & t.s;
}
class $d756dbc053e9c131$var$U {
    constructor(t){
        this.swup = void 0, this.registry = new Map, this.hooks = [
            "animation:out:start",
            "animation:out:await",
            "animation:out:end",
            "animation:in:start",
            "animation:in:await",
            "animation:in:end",
            "animation:skip",
            "cache:clear",
            "cache:set",
            "content:replace",
            "content:scroll",
            "enable",
            "disable",
            "fetch:request",
            "fetch:error",
            "fetch:timeout",
            "history:popstate",
            "link:click",
            "link:self",
            "link:anchor",
            "link:newtab",
            "page:load",
            "page:view",
            "scroll:top",
            "scroll:anchor",
            "visit:start",
            "visit:transition",
            "visit:abort",
            "visit:end"
        ], this.nextHookId = 0, this.swup = t, this.init();
    }
    init() {
        this.hooks.forEach((t)=>this.create(t));
    }
    create(t) {
        this.registry.has(t) || this.registry.set(t, new Map);
    }
    exists(t) {
        return this.registry.has(t);
    }
    get(t) {
        const e = this.registry.get(t);
        if (e) return e;
        console.error(`Unknown hook '${t}'`);
    }
    clear() {
        this.registry.forEach((t)=>t.clear());
    }
    on(t, e, n = {}) {
        const o = this.get(t);
        if (!o) return console.warn(`Hook '${t}' not found.`), ()=>{};
        const r = {
            ...n,
            id: ++this.nextHookId,
            hook: t,
            handler: e
        };
        return o.set(e, r), ()=>this.off(t, e);
    }
    before(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            before: !0
        });
    }
    replace(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            replace: !0
        });
    }
    once(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            once: !0
        });
    }
    off(t, e) {
        const n = this.get(t);
        n && e ? n.delete(e) || console.warn(`Handler for hook '${t}' not found.`) : n && n.clear();
    }
    call(t, e, n, o) {
        try {
            const r = this, [i, s, a] = r.parseCallArgs(t, e, n, o), { before: c, handler: l, after: h } = r.getHandlers(t, a);
            return Promise.resolve(r.run(c, i, s)).then(function() {
                return Promise.resolve(r.run(l, i, s, !0)).then(function([e]) {
                    return Promise.resolve(r.run(h, i, s)).then(function() {
                        return r.dispatchDomEvent(t, i, s), e;
                    });
                });
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    callSync(t, e, n, o) {
        const [r, i, s] = this.parseCallArgs(t, e, n, o), { before: a, handler: c, after: l } = this.getHandlers(t, s);
        this.runSync(a, r, i);
        const [h] = this.runSync(c, r, i, !0);
        return this.runSync(l, r, i), this.dispatchDomEvent(t, r, i), h;
    }
    parseCallArgs(t, e, n, o) {
        return e instanceof $d756dbc053e9c131$var$k || "object" != typeof e && "function" != typeof n ? [
            e,
            n,
            o
        ] : [
            void 0,
            e,
            n
        ];
    }
    run(t, e, n, o = !1) {
        try {
            let r;
            const i = this;
            void 0 === e && (e = i.swup.visit);
            const s = [], a = function(t, e, n) {
                if ("function" == typeof t[$d756dbc053e9c131$var$b]) {
                    var o, r, i, s = t[$d756dbc053e9c131$var$b]();
                    if (function t(a) {
                        try {
                            for(; !((o = s.next()).done || n && n());)if ((a = e(o.value)) && a.then) {
                                if (!$d756dbc053e9c131$var$C(a)) return void a.then(t, i || (i = $d756dbc053e9c131$var$S.bind(null, r = new $d756dbc053e9c131$var$E, 2)));
                                a = a.v;
                            }
                            r ? $d756dbc053e9c131$var$S(r, 1, a) : r = a;
                        } catch (t) {
                            $d756dbc053e9c131$var$S(r || (r = new $d756dbc053e9c131$var$E), 2, t);
                        }
                    }(), s.return) {
                        var a = function(t) {
                            try {
                                o.done || s.return();
                            } catch (t) {}
                            return t;
                        };
                        if (r && r.then) return r.then(a, function(t) {
                            throw a(t);
                        });
                        a();
                    }
                    return r;
                }
                if (!("length" in t)) throw new TypeError("Object is not iterable");
                for(var c = [], l = 0; l < t.length; l++)c.push(t[l]);
                return function(t, e, n) {
                    var o, r, i = -1;
                    return function s(a) {
                        try {
                            for(; ++i < t.length && (!n || !n());)if ((a = e(i)) && a.then) {
                                if (!$d756dbc053e9c131$var$C(a)) return void a.then(s, r || (r = $d756dbc053e9c131$var$S.bind(null, o = new $d756dbc053e9c131$var$E, 2)));
                                a = a.v;
                            }
                            o ? $d756dbc053e9c131$var$S(o, 1, a) : o = a;
                        } catch (t) {
                            $d756dbc053e9c131$var$S(o || (o = new $d756dbc053e9c131$var$E), 2, t);
                        }
                    }(), o;
                }(c, function(t) {
                    return e(c[t]);
                }, n);
            }(t, function({ hook: t, handler: r, defaultHandler: a, once: c }) {
                if (!e?.done) return c && i.off(t, r), function(t, o) {
                    try {
                        var i = Promise.resolve($d756dbc053e9c131$export$8586fbe018c72b76(r, [
                            e,
                            n,
                            a
                        ])).then(function(t) {
                            s.push(t);
                        });
                    } catch (t) {
                        return o(t);
                    }
                    return i && i.then ? i.then(void 0, o) : i;
                }(0, function(e) {
                    if (o) throw e;
                    console.error(`Error in hook '${t}':`, e);
                });
            }, function() {
                return r;
            });
            return Promise.resolve(a && a.then ? a.then(function(t) {
                return r ? t : s;
            }) : r ? a : s);
        } catch (t) {
            return Promise.reject(t);
        }
    }
    runSync(t, e = this.swup.visit, n, o = !1) {
        const r = [];
        for (const { hook: i, handler: s, defaultHandler: a, once: c } of t)if (!e?.done) {
            c && this.off(i, s);
            try {
                const t = s(e, n, a);
                r.push(t), $d756dbc053e9c131$export$4369c812aac99591(t) && console.warn(`Swup will not await Promises in handler for synchronous hook '${i}'.`);
            } catch (t) {
                if (o) throw t;
                console.error(`Error in hook '${i}':`, t);
            }
        }
        return r;
    }
    getHandlers(t, e) {
        const n = this.get(t);
        if (!n) return {
            found: !1,
            before: [],
            handler: [],
            after: [],
            replaced: !1
        };
        const o = Array.from(n.values()), r = this.sortRegistrations, i = o.filter(({ before: t, replace: e })=>t && !e).sort(r), s = o.filter(({ replace: t })=>t).filter((t)=>!0).sort(r), a = o.filter(({ before: t, replace: e })=>!t && !e).sort(r), c = s.length > 0;
        let l = [];
        if (e && (l = [
            {
                id: 0,
                hook: t,
                handler: e
            }
        ], c)) {
            const n = s.length - 1, { handler: o, once: r } = s[n], i = (t)=>{
                const n = s[t - 1];
                return n ? (e, o)=>n.handler(e, o, i(t - 1)) : e;
            };
            l = [
                {
                    id: 0,
                    hook: t,
                    once: r,
                    handler: o,
                    defaultHandler: i(n)
                }
            ];
        }
        return {
            found: !0,
            before: i,
            handler: l,
            after: a,
            replaced: c
        };
    }
    sortRegistrations(t, e) {
        return (t.priority ?? 0) - (e.priority ?? 0) || t.id - e.id || 0;
    }
    dispatchDomEvent(t, e, n) {
        if (e?.done) return;
        const o = {
            hook: t,
            args: n,
            visit: e || this.swup.visit
        };
        document.dispatchEvent(new CustomEvent("swup:any", {
            detail: o,
            bubbles: !0
        })), document.dispatchEvent(new CustomEvent(`swup:${t}`, {
            detail: o,
            bubbles: !0
        }));
    }
    parseName(t) {
        const [e, ...n] = t.split(".");
        return [
            e,
            n.reduce((t, e)=>({
                    ...t,
                    [e]: !0
                }), {})
        ];
    }
}
const $d756dbc053e9c131$var$$ = (t)=>{
    if (t && "#" === t.charAt(0) && (t = t.substring(1)), !t) return null;
    const e = decodeURIComponent(t);
    let n = document.getElementById(t) || document.getElementById(e) || $d756dbc053e9c131$export$2fa187e846a241c4(`a[name='${CSS.escape(t)}']`) || $d756dbc053e9c131$export$2fa187e846a241c4(`a[name='${CSS.escape(e)}']`);
    return n || "top" !== t || (n = document.body), n;
}, $d756dbc053e9c131$var$x = function({ selector: t, elements: e }) {
    try {
        if (!1 === t && !e) return Promise.resolve();
        let n = [];
        if (e) n = Array.from(e);
        else if (t && (n = $d756dbc053e9c131$export$dcd0d083aa86c355(t, document.body), !n.length)) return console.warn(`[swup] No elements found matching animationSelector \`${t}\``), Promise.resolve();
        const o = n.map((t)=>(function(t) {
                const { type: e, timeout: n, propCount: o } = function(t) {
                    const e = window.getComputedStyle(t), n = $d756dbc053e9c131$var$j(e, `${$d756dbc053e9c131$var$A}Delay`), o = $d756dbc053e9c131$var$j(e, `${$d756dbc053e9c131$var$A}Duration`), r = $d756dbc053e9c131$var$I(n, o), i = $d756dbc053e9c131$var$j(e, `${$d756dbc053e9c131$var$H}Delay`), s = $d756dbc053e9c131$var$j(e, `${$d756dbc053e9c131$var$H}Duration`), a = $d756dbc053e9c131$var$I(i, s), c = Math.max(r, a), l = c > 0 ? r > a ? $d756dbc053e9c131$var$A : $d756dbc053e9c131$var$H : null;
                    return {
                        type: l,
                        timeout: c,
                        propCount: l ? l === $d756dbc053e9c131$var$A ? o.length : s.length : 0
                    };
                }(t);
                return !(!e || !n) && new Promise((r)=>{
                    const i = `${e}end`, s = performance.now();
                    let a = 0;
                    const c = ()=>{
                        t.removeEventListener(i, l), r();
                    }, l = (e)=>{
                        e.target === t && ((performance.now() - s) / 1e3 < e.elapsedTime || ++a >= o && c());
                    };
                    setTimeout(()=>{
                        a < o && c();
                    }, n + 1), t.addEventListener(i, l);
                });
            })(t)).filter((t)=>!1 !== t);
        return o.length ? Promise.resolve(Promise.all(o)).then(function() {}) : (t && console.warn(`[swup] No CSS animation duration defined on elements matching \`${t}\``), Promise.resolve());
    } catch (t) {
        return Promise.reject(t);
    }
}, $d756dbc053e9c131$var$A = "transition", $d756dbc053e9c131$var$H = "animation";
function $d756dbc053e9c131$var$j(t, e) {
    return (t[e] || "").split(", ");
}
function $d756dbc053e9c131$var$I(t, e) {
    for(; t.length < e.length;)t = t.concat(t);
    return Math.max(...e.map((e, n)=>$d756dbc053e9c131$var$V(e) + $d756dbc053e9c131$var$V(t[n])));
}
function $d756dbc053e9c131$var$V(t) {
    return 1e3 * parseFloat(t);
}
const $d756dbc053e9c131$var$L = function(t, e = {}) {
    try {
        let s;
        const c = this;
        function o(o) {
            if (s) return o;
            c.navigating = !0, c.visit = t;
            const { el: l } = t.trigger;
            e.referrer = e.referrer || c.location.url, !1 === e.animate && (t.animation.animate = !1), t.animation.animate || c.classes.clear();
            const h = e.history || $d756dbc053e9c131$export$bfb619fe77197843(l, "data-swup-history");
            "string" == typeof h && [
                "push",
                "replace"
            ].includes(h) && (t.history.action = h);
            const u = e.animation || $d756dbc053e9c131$export$bfb619fe77197843(l, "data-swup-animation");
            return "string" == typeof u && (t.animation.name = u), t.meta = e.meta || {}, "object" == typeof e.cache ? (t.cache.read = e.cache.read ?? t.cache.read, t.cache.write = e.cache.write ?? t.cache.write) : void 0 !== e.cache && (t.cache = {
                read: !!e.cache,
                write: !!e.cache
            }), delete e.cache, function(o, s) {
                try {
                    var l = function(o, s) {
                        try {
                            var l = Promise.resolve(c.hooks.call("visit:start", t, void 0)).then(function() {
                                function o() {
                                    if (t.ignored) throw new Error(`Visit to ${t.to.url} manually ignored`);
                                    if (!t.done) return Promise.resolve(c.hooks.call("visit:transition", t, void 0, function() {
                                        try {
                                            let n;
                                            function e(e) {
                                                return n ? e : (t.advance(4), Promise.resolve(c.animatePageOut(t)).then(function() {
                                                    function e() {
                                                        return Promise.resolve(c.animatePageIn(t)).then(function() {});
                                                    }
                                                    const n = function() {
                                                        if (t.animation.native && document.startViewTransition) return Promise.resolve(document.startViewTransition(function() {
                                                            try {
                                                                const e = c.renderPage;
                                                                return Promise.resolve(s).then(function(n) {
                                                                    return Promise.resolve(e.call(c, t, n));
                                                                });
                                                            } catch (t) {
                                                                return Promise.reject(t);
                                                            }
                                                        }).finished).then(function() {});
                                                        {
                                                            const e = c.renderPage;
                                                            return Promise.resolve(s).then(function(n) {
                                                                return Promise.resolve(e.call(c, t, n)).then(function() {});
                                                            });
                                                        }
                                                    }();
                                                    return n && n.then ? n.then(e) : e();
                                                }));
                                            }
                                            const o = function() {
                                                if (!t.animation.animate) return Promise.resolve(c.hooks.call("animation:skip", void 0)).then(function() {
                                                    const e = c.renderPage;
                                                    return Promise.resolve(s).then(function(o) {
                                                        return Promise.resolve(e.call(c, t, o)).then(function() {
                                                            n = 1;
                                                        });
                                                    });
                                                });
                                            }();
                                            return Promise.resolve(o && o.then ? o.then(e) : e(o));
                                        } catch (r) {
                                            return Promise.reject(r);
                                        }
                                    })).then(function() {
                                        if (!t.done) return Promise.resolve(c.hooks.call("visit:end", t, void 0, ()=>c.classes.clear())).then(function() {
                                            t.state = 7, c.navigating = !1, c.onVisitEnd && (c.onVisitEnd(), c.onVisitEnd = void 0);
                                        });
                                    });
                                }
                                t.state = 3;
                                const s = c.hooks.call("page:load", t, {
                                    options: e
                                }, function(t, e) {
                                    try {
                                        function n(t) {
                                            return e.page = t, e.cache = !!o, e.page;
                                        }
                                        let o;
                                        return t.cache.read && (o = c.cache.get(t.to.url)), Promise.resolve(o ? n(o) : Promise.resolve(c.fetchPage(t.to.url, e.options)).then(n));
                                    } catch (r) {
                                        return Promise.reject(r);
                                    }
                                });
                                s.then(({ html: e })=>{
                                    t.advance(5), t.to.html = e, t.to.document = (new DOMParser).parseFromString(e, "text/html");
                                });
                                const l = t.to.url + t.to.hash;
                                t.history.popstate || ("replace" === t.history.action || t.to.url === c.location.url ? $d756dbc053e9c131$export$9dd2847e0d2d8b0(l) : (c.currentHistoryIndex++, $d756dbc053e9c131$export$c38a4311235454af(l, {
                                    index: c.currentHistoryIndex
                                }))), c.location = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(l), t.history.popstate && c.classes.add("is-popstate"), t.animation.name && c.classes.add(`to-${$d756dbc053e9c131$export$b04d9b8d414ba5e8(t.animation.name)}`);
                                const h = function() {
                                    if (t.animation.wait) return Promise.resolve(s).then(function() {});
                                }();
                                return h && h.then ? h.then(o) : o();
                            });
                        } catch (t) {
                            return s(t);
                        }
                        return l && l.then ? l.then(void 0, s) : l;
                    }(0, function(e) {
                        e && !e?.aborted ? (t.advance(9), console.error(e), c.options.skipPopStateHandling = ()=>(window.location.assign(t.to.url + t.to.hash), !0), window.history.back()) : t.advance(8);
                    });
                } catch (t) {
                    return s(!0, t);
                }
                return l && l.then ? l.then(s.bind(null, !1), s.bind(null, !0)) : s(!1, l);
            }(0, function(e, n) {
                if (delete t.to.document, e) throw n;
                return n;
            });
        }
        const l = function() {
            if (c.navigating) return function() {
                if (!(c.visit.state >= 6)) return Promise.resolve(c.hooks.call("visit:abort", c.visit, void 0)).then(function() {
                    delete c.visit.to.document, c.visit.state = 8;
                });
                t.state = 2, c.onVisitEnd = ()=>c.performNavigation(t, e), s = 1;
            }();
        }();
        return Promise.resolve(l && l.then ? l.then(o) : o(l));
    } catch (h) {
        return Promise.reject(h);
    }
};
function $d756dbc053e9c131$var$T(t, e = {}, n = {}) {
    if ("string" != typeof t) throw new Error("swup.navigate() requires a URL parameter");
    if (this.shouldIgnoreVisit(t, {
        el: n.el,
        event: n.event
    })) return void window.location.assign(t);
    const { url: o, hash: r } = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(t), i = this.createVisit({
        ...n,
        to: o,
        hash: r
    });
    this.performNavigation(i, e);
}
const $d756dbc053e9c131$var$q = function(t) {
    try {
        const e = this;
        return Promise.resolve(e.hooks.call("animation:out:start", t, void 0, ()=>{
            e.classes.add("is-changing", "is-animating", "is-leaving");
        })).then(function() {
            return Promise.resolve(e.hooks.call("animation:out:await", t, {
                skip: !1
            }, (t, { skip: n })=>{
                if (!n) return e.awaitAnimations({
                    selector: t.animation.selector
                });
            })).then(function() {
                return Promise.resolve(e.hooks.call("animation:out:end", t, void 0)).then(function() {});
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $d756dbc053e9c131$var$R = function(t) {
    const e = t.to.document;
    if (!e) return !1;
    const n = e.querySelector("title")?.innerText || "";
    document.title = n;
    const o = $d756dbc053e9c131$export$dcd0d083aa86c355('[data-swup-persist]:not([data-swup-persist=""])'), r = t.containers.map((t)=>{
        const n = document.querySelector(t), o = e.querySelector(t);
        return n && o ? (n.replaceWith(o.cloneNode(!0)), !0) : (n || console.warn(`[swup] Container missing in current document: ${t}`), o || console.warn(`[swup] Container missing in incoming document: ${t}`), !1);
    }).filter(Boolean);
    return o.forEach((t)=>{
        const e = t.getAttribute("data-swup-persist"), n = $d756dbc053e9c131$export$2fa187e846a241c4(`[data-swup-persist="${e}"]`);
        n && n !== t && n.replaceWith(t);
    }), r.length === t.containers.length;
}, $d756dbc053e9c131$var$N = function(t) {
    const e = {
        behavior: "auto"
    }, { target: n, reset: o } = t.scroll, r = n ?? t.to.hash;
    let i = !1;
    return r && (i = this.hooks.callSync("scroll:anchor", t, {
        hash: r,
        options: e
    }, (t, { hash: e, options: n })=>{
        const o = this.getAnchorElement(e);
        return o && o.scrollIntoView(n), !!o;
    })), o && !i && (i = this.hooks.callSync("scroll:top", t, {
        options: e
    }, (t, { options: e })=>(window.scrollTo({
            top: 0,
            left: 0,
            ...e
        }), !0))), i;
}, $d756dbc053e9c131$var$D = function(t) {
    try {
        const e = this;
        if (t.done) return Promise.resolve();
        const n = e.hooks.call("animation:in:await", t, {
            skip: !1
        }, (t, { skip: n })=>{
            if (!n) return e.awaitAnimations({
                selector: t.animation.selector
            });
        });
        return Promise.resolve($d756dbc053e9c131$export$bdd553fddd433dcb()).then(function() {
            return Promise.resolve(e.hooks.call("animation:in:start", t, void 0, ()=>{
                e.classes.remove("is-animating");
            })).then(function() {
                return Promise.resolve(n).then(function() {
                    return Promise.resolve(e.hooks.call("animation:in:end", t, void 0)).then(function() {});
                });
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $d756dbc053e9c131$var$O = function(t, e) {
    try {
        const r = this;
        if (t.done) return Promise.resolve();
        t.advance(6);
        const { url: s } = e;
        return r.isSameResolvedUrl($d756dbc053e9c131$export$dc90482e4ef07afd(), s) || ($d756dbc053e9c131$export$9dd2847e0d2d8b0(s), r.location = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(s), t.to.url = r.location.url, t.to.hash = r.location.hash), Promise.resolve(r.hooks.call("content:replace", t, {
            page: e
        }, (t, {})=>{
            if (r.classes.remove("is-leaving"), t.animation.animate && r.classes.add("is-rendering"), !r.replaceContent(t)) throw new Error("[swup] Container mismatch, aborting");
            t.animation.animate && (r.classes.add("is-changing", "is-animating", "is-rendering"), t.animation.name && r.classes.add(`to-${$d756dbc053e9c131$export$b04d9b8d414ba5e8(t.animation.name)}`));
        })).then(function() {
            return Promise.resolve(r.hooks.call("content:scroll", t, void 0, ()=>r.scrollToContent(t))).then(function() {
                return Promise.resolve(r.hooks.call("page:view", t, {
                    url: r.location.url,
                    title: document.title
                })).then(function() {});
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $d756dbc053e9c131$var$M = function(t) {
    var e;
    if (e = t, Boolean(e?.isSwupPlugin)) {
        if (t.swup = this, !t._checkRequirements || t._checkRequirements()) return t._beforeMount && t._beforeMount(), t.mount(), this.plugins.push(t), this.plugins;
    } else console.error("Not a swup plugin instance", t);
};
function $d756dbc053e9c131$var$W(t) {
    const e = this.findPlugin(t);
    if (e) return e.unmount(), e._afterUnmount && e._afterUnmount(), this.plugins = this.plugins.filter((t)=>t !== e), this.plugins;
    console.error("No such plugin", e);
}
function $d756dbc053e9c131$var$B(t) {
    return this.plugins.find((e)=>"string" == typeof t ? [
            `Swup${t}`,
            t
        ].includes(e.name) : e === t);
}
function $d756dbc053e9c131$var$_(t) {
    if ("function" != typeof this.options.resolveUrl) return console.warn("[swup] options.resolveUrl expects a callback function."), t;
    const e = this.options.resolveUrl(t);
    return e && "string" == typeof e ? e.startsWith("//") || e.startsWith("http") ? (console.warn("[swup] options.resolveUrl needs to return a relative url"), t) : e : (console.warn("[swup] options.resolveUrl needs to return a url"), t);
}
function $d756dbc053e9c131$var$F(t, e) {
    return this.resolveUrl(t) === this.resolveUrl(e);
}
const $d756dbc053e9c131$var$K = {
    animateHistoryBrowsing: !1,
    animationSelector: '[class*="transition-"]',
    animationScope: "html",
    cache: !0,
    containers: [
        "#swup"
    ],
    hooks: {},
    ignoreVisit: (t, { el: e } = {})=>!!e?.closest("[data-no-swup]"),
    linkSelector: "a[href]",
    linkToSelf: "scroll",
    native: !1,
    plugins: [],
    resolveUrl: (t)=>t,
    requestHeaders: {
        "X-Requested-With": "swup",
        Accept: "text/html, application/xhtml+xml"
    },
    skipPopStateHandling: (t)=>"swup" !== t.state?.source,
    timeout: 0
};
class $d756dbc053e9c131$export$2e2bcd8739ae039 {
    get currentPageUrl() {
        return this.location.url;
    }
    constructor(t = {}){
        this.version = "4.9.2", this.options = void 0, this.defaults = $d756dbc053e9c131$var$K, this.plugins = [], this.visit = void 0, this.cache = void 0, this.hooks = void 0, this.classes = void 0, this.location = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(window.location.href), this.currentHistoryIndex = void 0, this.clickDelegate = void 0, this.navigating = !1, this.onVisitEnd = void 0, this.use = $d756dbc053e9c131$var$M, this.unuse = $d756dbc053e9c131$var$W, this.findPlugin = $d756dbc053e9c131$var$B, this.log = ()=>{}, this.navigate = $d756dbc053e9c131$var$T, this.performNavigation = $d756dbc053e9c131$var$L, this.createVisit = $d756dbc053e9c131$var$P, this.delegateEvent = $d756dbc053e9c131$export$b93d41a1bb659592, this.fetchPage = $d756dbc053e9c131$var$l, this.awaitAnimations = $d756dbc053e9c131$var$x, this.renderPage = $d756dbc053e9c131$var$O, this.replaceContent = $d756dbc053e9c131$var$R, this.animatePageIn = $d756dbc053e9c131$var$D, this.animatePageOut = $d756dbc053e9c131$var$q, this.scrollToContent = $d756dbc053e9c131$var$N, this.getAnchorElement = $d756dbc053e9c131$var$$, this.getCurrentUrl = $d756dbc053e9c131$export$dc90482e4ef07afd, this.resolveUrl = $d756dbc053e9c131$var$_, this.isSameResolvedUrl = $d756dbc053e9c131$var$F, this.options = {
            ...this.defaults,
            ...t
        }, this.handleLinkClick = this.handleLinkClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.cache = new $d756dbc053e9c131$var$u(this), this.classes = new $d756dbc053e9c131$var$y(this), this.hooks = new $d756dbc053e9c131$var$U(this), this.visit = this.createVisit({
            to: ""
        }), this.currentHistoryIndex = window.history.state?.index ?? 1, this.enable();
    }
    enable() {
        try {
            const t = this, { linkSelector: e } = t.options;
            t.clickDelegate = t.delegateEvent(e, "click", t.handleLinkClick), window.addEventListener("popstate", t.handlePopState), t.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), t.options.native = t.options.native && !!document.startViewTransition, t.options.plugins.forEach((e)=>t.use(e));
            for (const [e, n] of Object.entries(t.options.hooks)){
                const [o, r] = t.hooks.parseName(e);
                t.hooks.on(o, n, r);
            }
            return "swup" !== window.history.state?.source && $d756dbc053e9c131$export$9dd2847e0d2d8b0(null, {
                index: t.currentHistoryIndex
            }), Promise.resolve($d756dbc053e9c131$export$bdd553fddd433dcb()).then(function() {
                return Promise.resolve(t.hooks.call("enable", void 0, void 0, ()=>{
                    const e = document.documentElement;
                    e.classList.add("swup-enabled"), e.classList.toggle("swup-native", t.options.native);
                })).then(function() {});
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    destroy() {
        try {
            const t = this;
            return t.clickDelegate.destroy(), window.removeEventListener("popstate", t.handlePopState), t.cache.clear(), t.plugins.forEach((e)=>t.unuse(e)), Promise.resolve(t.hooks.call("disable", void 0, void 0, ()=>{
                const t = document.documentElement;
                t.classList.remove("swup-enabled"), t.classList.remove("swup-native");
            })).then(function() {
                t.hooks.clear();
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    shouldIgnoreVisit(t, { el: e, event: n } = {}) {
        const { origin: o, url: r, hash: i } = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(t);
        return o !== window.location.origin || !(!e || !this.triggerWillOpenNewWindow(e)) || !!this.options.ignoreVisit(r + i, {
            el: e,
            event: n
        });
    }
    handleLinkClick(t) {
        const e = t.delegateTarget, { href: n, url: o, hash: r } = $d756dbc053e9c131$export$18a2be9195644f38.fromElement(e);
        if (this.shouldIgnoreVisit(n, {
            el: e,
            event: t
        })) return;
        if (this.navigating && o === this.visit.to.url) return void t.preventDefault();
        const s = this.createVisit({
            to: o,
            hash: r,
            el: e,
            event: t
        });
        t.metaKey || t.ctrlKey || t.shiftKey || t.altKey ? this.hooks.callSync("link:newtab", s, {
            href: n
        }) : 0 === t.button && this.hooks.callSync("link:click", s, {
            el: e,
            event: t
        }, ()=>{
            const e = s.from.url ?? "";
            t.preventDefault(), o && o !== e ? this.isSameResolvedUrl(o, e) || this.performNavigation(s) : r ? this.hooks.callSync("link:anchor", s, {
                hash: r
            }, ()=>{
                $d756dbc053e9c131$export$9dd2847e0d2d8b0(o + r), this.scrollToContent(s);
            }) : this.hooks.callSync("link:self", s, void 0, ()=>{
                "navigate" === this.options.linkToSelf ? this.performNavigation(s) : ($d756dbc053e9c131$export$9dd2847e0d2d8b0(o), this.scrollToContent(s));
            });
        });
    }
    handlePopState(t) {
        const e = t.state?.url ?? window.location.href;
        if (this.options.skipPopStateHandling(t)) return;
        if (this.isSameResolvedUrl($d756dbc053e9c131$export$dc90482e4ef07afd(), this.location.url)) return;
        const { url: n, hash: r } = $d756dbc053e9c131$export$18a2be9195644f38.fromUrl(e), i = this.createVisit({
            to: n,
            hash: r,
            event: t
        });
        i.history.popstate = !0;
        const s = t.state?.index ?? 0;
        s && s !== this.currentHistoryIndex && (i.history.direction = s - this.currentHistoryIndex > 0 ? "forwards" : "backwards", this.currentHistoryIndex = s), i.animation.animate = !1, i.scroll.reset = !1, i.scroll.target = !1, this.options.animateHistoryBrowsing && (i.animation.animate = !0, i.scroll.reset = !0), this.hooks.callSync("history:popstate", i, {
            event: t
        }, ()=>{
            this.performNavigation(i);
        });
    }
    triggerWillOpenNewWindow(t) {
        return !!t.matches('[download], [target="_blank"]');
    }
}


const $c144e3dc13c87fd6$var$r = (r)=>String(r).split(".").map((r)=>String(parseInt(r || "0", 10))).concat([
        "0",
        "0"
    ]).slice(0, 3).join(".");
class $c144e3dc13c87fd6$export$2e2bcd8739ae039 {
    constructor(){
        this.isSwupPlugin = !0, this.swup = void 0, this.version = void 0, this.requires = {}, this.handlersToUnregister = [];
    }
    mount() {}
    unmount() {
        this.handlersToUnregister.forEach((r)=>r()), this.handlersToUnregister = [];
    }
    _beforeMount() {
        if (!this.name) throw new Error("You must define a name of plugin when creating a class.");
    }
    _afterUnmount() {}
    _checkRequirements() {
        return "object" != typeof this.requires || Object.entries(this.requires).forEach((e)=>{
            let [t, n] = e;
            if (n = Array.isArray(n) ? n : [
                n
            ], !function(e, t, n) {
                const s = function(r, e) {
                    if ("swup" === r) return e.version ?? "";
                    {
                        const t = e.findPlugin(r);
                        return t?.version ?? "";
                    }
                }(e, n);
                return !!s && ((e, t)=>t.every((t)=>{
                        const [, n, s] = t.match(/^([\D]+)?(.*)$/) || [];
                        var o, i;
                        return ((r, e)=>{
                            const t = {
                                "": (r)=>0 === r,
                                ">": (r)=>r > 0,
                                ">=": (r)=>r >= 0,
                                "<": (r)=>r < 0,
                                "<=": (r)=>r <= 0
                            };
                            return (t[e] || t[""])(r);
                        })((i = s, o = $c144e3dc13c87fd6$var$r(o = e), i = $c144e3dc13c87fd6$var$r(i), o.localeCompare(i, void 0, {
                            numeric: !0
                        })), n || ">=");
                    }))(s, t);
            }(t, n, this.swup)) {
                const r = `${t} ${n.join(", ")}`;
                throw new Error(`Plugin version mismatch: ${this.name} requires ${r}`);
            }
        }), !0;
    }
    on(r, e, t) {
        var n;
        void 0 === t && (t = {}), e = !(n = e).name.startsWith("bound ") || n.hasOwnProperty("prototype") ? e.bind(this) : e;
        const s = this.swup.hooks.on(r, e, t);
        return this.handlersToUnregister.push(s), s;
    }
    once(r, e, t) {
        return void 0 === t && (t = {}), this.on(r, e, {
            ...t,
            once: !0
        });
    }
    before(r, e, t) {
        return void 0 === t && (t = {}), this.on(r, e, {
            ...t,
            before: !0
        });
    }
    replace(r, e, t) {
        return void 0 === t && (t = {}), this.on(r, e, {
            ...t,
            replace: !0
        });
    }
    off(r, e) {
        return this.swup.hooks.off(r, e);
    }
}


// focus - focusOptions - preventScroll polyfill
(function() {
    if (typeof window === "undefined" || typeof document === "undefined" || typeof HTMLElement === "undefined") return;
    var supportsPreventScrollOption = false;
    try {
        var focusElem = document.createElement("div");
        focusElem.addEventListener("focus", function(event) {
            event.preventDefault();
            event.stopPropagation();
        }, true);
        focusElem.focus(Object.defineProperty({}, "preventScroll", {
            get: function() {
                // Edge v18 gives a false positive for supporting inputs
                if (navigator && typeof navigator.userAgent !== 'undefined' && navigator.userAgent && navigator.userAgent.match(/Edge\/1[7-8]/)) return supportsPreventScrollOption = false;
                supportsPreventScrollOption = true;
            }
        }));
    } catch (e) {}
    if (HTMLElement.prototype.nativeFocus === undefined && !supportsPreventScrollOption) {
        HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;
        var calcScrollableElements = function(element) {
            var parent = element.parentNode;
            var scrollableElements = [];
            var rootScrollingElement = document.scrollingElement || document.documentElement;
            while(parent && parent !== rootScrollingElement){
                if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push([
                    parent,
                    parent.scrollTop,
                    parent.scrollLeft
                ]);
                parent = parent.parentNode;
            }
            parent = rootScrollingElement;
            scrollableElements.push([
                parent,
                parent.scrollTop,
                parent.scrollLeft
            ]);
            return scrollableElements;
        };
        var restoreScrollPosition = function(scrollableElements) {
            for(var i = 0; i < scrollableElements.length; i++){
                scrollableElements[i][0].scrollTop = scrollableElements[i][1];
                scrollableElements[i][0].scrollLeft = scrollableElements[i][2];
            }
            scrollableElements = [];
        };
        var patchedFocus = function(args) {
            if (args && args.preventScroll) {
                var evScrollableElements = calcScrollableElements(this);
                if (typeof setTimeout === 'function') {
                    var thisElem = this;
                    setTimeout(function() {
                        thisElem.nativeFocus();
                        restoreScrollPosition(evScrollableElements);
                    }, 0);
                } else {
                    this.nativeFocus();
                    restoreScrollPosition(evScrollableElements);
                }
            } else this.nativeFocus();
        };
        HTMLElement.prototype.focus = patchedFocus;
    }
})();



function $6e909e2c194aa611$var$n(t, e) {
    return Object.keys(e).reduce((t, n)=>t.replace(`{${n}}`, e[n] || ""), t || "");
}
class $6e909e2c194aa611$var$o {
    constructor(){
        this.id = "swup-announcer", this.style = "position:absolute;top:0;left:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;white-space:nowrap;word-wrap:normal;width:1px;height:1px;", this.region = void 0, this.region = this.getRegion() ?? this.createRegion();
    }
    getRegion() {
        return document.getElementById(this.id);
    }
    createRegion() {
        const t = function(t) {
            const e = document.createElement("template");
            return e.innerHTML = t, e.content.children[0];
        }(`<p aria-live="assertive" aria-atomic="true" id="${this.id}" style="${this.style}"></p>`);
        return document.body.appendChild(t), t;
    }
    announce(t, e = 0) {
        return new Promise((n)=>{
            setTimeout(()=>{
                this.region.textContent === t && (t = `${t}.`), this.region.textContent = "", this.region.textContent = t, n();
            }, e);
        });
    }
}
function $6e909e2c194aa611$var$i(t) {
    let e;
    if (e = "string" == typeof t ? document.querySelector(t) : t, !(e instanceof HTMLElement)) return;
    const n = e.getAttribute("tabindex");
    e.setAttribute("tabindex", "-1"), e.focus({
        preventScroll: !0
    }), null !== n && e.setAttribute("tabindex", n);
}
class $6e909e2c194aa611$export$2e2bcd8739ae039 extends (0, $c144e3dc13c87fd6$export$2e2bcd8739ae039) {
    constructor(t = {}){
        super(), this.name = "SwupA11yPlugin", this.requires = {
            swup: ">=4"
        }, this.defaults = {
            headingSelector: [
                "main h1",
                "h1"
            ],
            respectReducedMotion: !0,
            autofocus: !1,
            announcements: {
                visit: "Navigated to: {title}",
                url: "New page at {url}"
            }
        }, this.options = void 0, this.announcer = void 0, this.announcementDelay = 100, this.rootSelector = "body", this.handleAnchorScroll = (t, { hash: e })=>{
            const n = this.swup.getAnchorElement(e);
            n instanceof HTMLElement && $6e909e2c194aa611$var$i(n);
        }, this.options = {
            ...this.defaults,
            ...t
        }, this.announcer = new $6e909e2c194aa611$var$o;
    }
    mount() {
        this.swup.hooks.create("content:announce"), this.swup.hooks.create("content:focus"), this.before("visit:start", this.prepareVisit), this.on("visit:start", this.markAsBusy), this.on("visit:end", this.unmarkAsBusy), this.on("content:replace", this.maybeFocusEarly), this.on("visit:end", this.maybeFocusLate), this.on("visit:end", this.announceContent), this.on("scroll:anchor", this.handleAnchorScroll), this.before("visit:start", this.disableAnimations), this.before("link:self", this.disableAnimations), this.before("link:anchor", this.disableAnimations), this.swup.announce = this.announce.bind(this);
    }
    unmount() {
        this.swup.announce = void 0;
    }
    announce(t) {
        try {
            return Promise.resolve(this.announcer.announce(t)).then(function() {});
        } catch (t) {
            return Promise.reject(t);
        }
    }
    markAsBusy() {
        document.documentElement.setAttribute("aria-busy", "true");
    }
    unmarkAsBusy() {
        document.documentElement.removeAttribute("aria-busy");
    }
    prepareVisit(t) {
        t.a11y = {
            announce: void 0,
            focus: {
                selector: this.rootSelector,
                wait: !0
            }
        };
    }
    announceContent(t) {
        this.swup.hooks.callSync("content:announce", t, void 0, (t)=>{
            void 0 === t.a11y.announce && (t.a11y.announce = this.getPageAnnouncement()), t.a11y.announce && this.announcer.announce(t.a11y.announce, this.announcementDelay);
        });
    }
    maybeFocusEarly(t) {
        const e = this.parseVisitFocus(t.a11y.focus);
        e && !e.wait && this.focusContent(t);
    }
    maybeFocusLate(t) {
        const e = this.parseVisitFocus(t.a11y.focus);
        e && e.wait && this.focusContent(t);
    }
    focusContent(t) {
        this.swup.hooks.callSync("content:focus", t, void 0, (t)=>{
            const e = this.parseVisitFocus(t.a11y.focus);
            e && (this.options.autofocus && !0 === function() {
                const t = function() {
                    const t = document.querySelector("body [autofocus]");
                    if (t && !t.closest('[inert], [aria-disabled], [aria-hidden="true"]')) return t;
                }();
                return !!t && (t !== document.activeElement && t.focus(), !0);
            }() || $6e909e2c194aa611$var$i(e.selector));
        });
    }
    parseVisitFocus(t) {
        if (!t) return !1;
        const e = "string" == typeof t ? {
            selector: t,
            wait: !0
        } : t;
        return !!e.selector && e;
    }
    getPageAnnouncement() {
        const { headingSelector: t, announcements: o } = this.options;
        return function({ headingSelector: t = "h1", announcements: o = {} }) {
            const i = document.documentElement.lang || "*", { href: s, url: r, pathname: c } = (0, $d756dbc053e9c131$export$18a2be9195644f38).fromUrl(window.location.href), a = o[i] ?? o["*"] ?? o;
            if ("object" != typeof a) return;
            const u = Array.isArray(t) ? t : [
                t
            ], h = u.reduce((t, e)=>t ?? document.querySelector(e), null);
            h || console.warn(`SwupA11yPlugin: No main heading (${u.join(" / ")}) found on new page`);
            const l = h?.getAttribute("aria-label") || h?.textContent || document.title || $6e909e2c194aa611$var$n(a.url, {
                href: s,
                url: r,
                path: c
            });
            return $6e909e2c194aa611$var$n(a.visit, {
                title: l,
                href: s,
                url: r,
                path: c
            });
        }({
            headingSelector: t,
            announcements: o
        });
    }
    disableAnimations(t) {
        this.options.respectReducedMotion && window.matchMedia("(prefers-reduced-motion: reduce)").matches && (t.animation.animate = !1, t.scroll.animate = !1);
    }
}



function $ad959d4ee38cbe75$var$t(e) {
    return "title" !== e.localName && !e.matches("[data-swup-theme]");
}
function $ad959d4ee38cbe75$var$s(e, t) {
    return e.outerHTML === t.outerHTML;
}
function $ad959d4ee38cbe75$var$n(e, t = []) {
    const s = Array.from(e.attributes);
    return t.length ? s.filter(({ name: e })=>t.some((t)=>t instanceof RegExp ? t.test(e) : e === t)) : s;
}
function $ad959d4ee38cbe75$var$o(e) {
    return e.matches("link[rel=stylesheet][href]");
}
class $ad959d4ee38cbe75$export$2e2bcd8739ae039 extends (0, $c144e3dc13c87fd6$export$2e2bcd8739ae039) {
    constructor(e = {}){
        super();
        const r = this;
        this.name = "SwupHeadPlugin", this.requires = {
            swup: ">=4.6"
        }, this.defaults = {
            persistTags: !1,
            persistAssets: !1,
            awaitAssets: !1,
            attributes: [
                "lang",
                "dir"
            ],
            timeout: 3e3
        }, this.options = void 0, this.updateHead = function(e, {}) {
            try {
                const { awaitAssets: i, attributes: u, timeout: a } = r.options, l = e.to.document, { removed: c, added: h } = function(e, n, { shouldPersist: o = ()=>!1 } = {}) {
                    const r = Array.from(e.children), i = Array.from(n.children), u = (a = r, i.reduce((e, t, n)=>(a.some((e)=>$ad959d4ee38cbe75$var$s(t, e)) || e.push({
                            el: t,
                            index: n
                        }), e), []));
                    var a;
                    const l = function(e, t) {
                        return e.reduce((e, n)=>(t.some((e)=>$ad959d4ee38cbe75$var$s(n, e)) || e.push({
                                el: n
                            }), e), []);
                    }(r, i);
                    l.reverse().filter(({ el: e })=>$ad959d4ee38cbe75$var$t(e)).filter(({ el: e })=>!o(e)).forEach(({ el: t })=>e.removeChild(t));
                    const c = u.filter(({ el: e })=>$ad959d4ee38cbe75$var$t(e)).map((t)=>{
                        let s = t.el.cloneNode(!0);
                        return e.insertBefore(s, e.children[(t.index || 0) + 1] || null), {
                            ...t,
                            el: s
                        };
                    });
                    return {
                        removed: l.map(({ el: e })=>e),
                        added: c.map(({ el: e })=>e)
                    };
                }(document.head, l.head, {
                    shouldPersist: (e)=>r.isPersistentTag(e)
                });
                r.swup.log(`Removed ${c.length} / added ${h.length} tags in head`), u?.length && function(e, t, s = []) {
                    const o = new Set;
                    for (const { name: r, value: i } of $ad959d4ee38cbe75$var$n(t, s))e.setAttribute(r, i), o.add(r);
                    for (const { name: t } of $ad959d4ee38cbe75$var$n(e, s))o.has(t) || e.removeAttribute(t);
                }(document.documentElement, l.documentElement, u);
                const d = function() {
                    if (i) {
                        const e = function(e, t = 0) {
                            return e.filter($ad959d4ee38cbe75$var$o).map((e)=>(function(e, t = 0) {
                                    let s;
                                    const n = (t)=>{
                                        e.sheet ? t() : s = setTimeout(()=>n(t), 10);
                                    };
                                    return new Promise((o)=>{
                                        n(()=>o(e)), t > 0 && setTimeout(()=>{
                                            s && clearTimeout(s), o(e);
                                        }, t);
                                    });
                                })(e, t));
                        }(h, a), t = function() {
                            if (e.length) return r.swup.log(`Waiting for ${e.length} assets to load`), Promise.resolve(Promise.all(e)).then(function() {});
                        }();
                        if (t && t.then) return t.then(function() {});
                    }
                }();
                return Promise.resolve(d && d.then ? d.then(function() {}) : void 0);
            } catch (e) {
                return Promise.reject(e);
            }
        }, this.options = {
            ...this.defaults,
            ...e
        }, this.options.persistAssets && !this.options.persistTags && (this.options.persistTags = "link[rel=stylesheet], script[src], style");
    }
    mount() {
        this.before("content:replace", this.updateHead);
    }
    isPersistentTag(e) {
        const { persistTags: t } = this.options;
        return "function" == typeof t ? t(e) : "string" == typeof t && t.length > 0 ? e.matches(t) : Boolean(t);
    }
}



const $fc9556b339369654$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $fc9556b339369654$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $fc9556b339369654$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $fc9556b339369654$var$e(o.overflowY, n) || $fc9556b339369654$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $fc9556b339369654$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $fc9556b339369654$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $fc9556b339369654$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$fc9556b339369654$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $fc9556b339369654$var$t(W) && p(W);){
        if (W = $fc9556b339369654$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $fc9556b339369654$var$n(W) && !$fc9556b339369654$var$n(document.documentElement) || null != W && $fc9556b339369654$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$fc9556b339369654$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $fc9556b339369654$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $fc9556b339369654$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $fc9556b339369654$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $fc9556b339369654$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $45a279ded9626458$var$e = (t, o = document)=>Array.from(o.querySelectorAll(t));
class $45a279ded9626458$export$2e2bcd8739ae039 extends (0, $c144e3dc13c87fd6$export$2e2bcd8739ae039) {
    constructor(t = {}){
        super(), this.name = "SwupScrollPlugin", this.requires = {
            swup: ">=4.2.0"
        }, this.defaults = {
            doScrollingRightAway: !1,
            animateScroll: {
                betweenPages: !0,
                samePageWithHash: !0,
                samePage: !0
            },
            getAnchorElement: void 0,
            offset: 0,
            scrollContainers: "[data-swup-scroll-container]",
            shouldResetScrollPosition: ()=>!0,
            markScrollTarget: !1,
            scrollFunction: void 0
        }, this.options = void 0, this.cachedScrollPositions = {}, this.previousScrollRestoration = void 0, this.currentCacheKey = void 0, this.getAnchorElement = (t = "")=>"function" == typeof this.options.getAnchorElement ? this.options.getAnchorElement(t) : this.swup.getAnchorElement(t), this.getOffset = (t, o, e)=>{
            let s;
            return s = "function" == typeof this.options.offset ? this.options.offset(t, o, e) : this.options.offset, "object" == typeof s && "number" == typeof s.top && "number" == typeof s.left ? s : {
                top: parseInt(String(s ?? ""), 10) || 0,
                left: 0
            };
        }, this.onBeforeLinkToSelf = (t)=>{
            t.scroll.animate = this.shouldAnimate("samePage");
        }, this.handleScrollToTop = (t)=>(this.scrollTo({
                top: 0,
                left: 0
            }, t.scroll.animate), !0), this.onBeforeLinkToAnchor = (t)=>{
            t.scroll.animate = this.shouldAnimate("samePageWithHash");
        }, this.handleScrollToAnchor = (t, { hash: o })=>this.maybeScrollToAnchor(o, t.scroll.animate), this.onBeforeVisitStart = (t)=>{
            t.scroll.scrolledToContent = !1, t.scroll.animate = this.shouldAnimate("betweenPages");
        }, this.onVisitStart = (t)=>{
            this.cacheScrollPositions(t.from.url), this.maybeResetScrollPositions(t), t.scroll.animate && this.options.doScrollingRightAway && !(t.scroll.target ?? t.to.hash) && this.doScrollingBetweenPages(t);
        }, this.handleScrollToContent = (t)=>{
            t.scroll.scrolledToContent || this.doScrollingBetweenPages(t), this.restoreScrollContainers(t.to.url);
        }, this.doScrollingBetweenPages = (t)=>{
            if (t.history.popstate && !t.animation.animate) return;
            const o = t.scroll.target ?? t.to.hash;
            if (o && this.maybeScrollToAnchor(o, t.scroll.animate)) return;
            if (!t.scroll.reset) return;
            const e = this.getCachedScrollPositions(t.to.url), { top: s = 0, left: l = 0 } = e?.window || {
                top: 0,
                left: 0
            };
            requestAnimationFrame(()=>this.scrollTo({
                    top: s,
                    left: l
                }, t.scroll.animate)), t.scroll.scrolledToContent = !0;
        }, this.maybeResetScrollPositions = (t)=>{
            const { popstate: o } = t.history, { url: e } = t.to, { el: s } = t.trigger;
            o || s && !this.options.shouldResetScrollPosition(s) || this.resetScrollPositions(e);
        }, this.options = {
            ...this.defaults,
            ...t
        };
    }
    mount() {
        const t = this.swup;
        t.hooks.create("scroll:start"), t.hooks.create("scroll:end"), t.scrollTo = this.scrollTo.bind(this), this.previousScrollRestoration = window.history.scrollRestoration, t.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), this.updateScrollTarget = this.updateScrollTarget.bind(this), this.options.markScrollTarget && (window.addEventListener("popstate", this.updateScrollTarget), window.addEventListener("hashchange", this.updateScrollTarget), this.on("page:view", this.updateScrollTarget), this.on("link:anchor", this.updateScrollTarget), this.on("link:self", this.updateScrollTarget), this.updateScrollTarget()), this.before("visit:start", this.onBeforeVisitStart, {
            priority: -1
        }), this.on("visit:start", this.onVisitStart, {
            priority: 1
        }), this.replace("content:scroll", this.handleScrollToContent), this.before("link:self", this.onBeforeLinkToSelf, {
            priority: -1
        }), this.replace("scroll:top", this.handleScrollToTop), this.before("link:anchor", this.onBeforeLinkToAnchor, {
            priority: -1
        }), this.replace("scroll:anchor", this.handleScrollToAnchor);
    }
    unmount() {
        super.unmount(), this.previousScrollRestoration && (window.history.scrollRestoration = this.previousScrollRestoration), window.removeEventListener("popstate", this.updateScrollTarget), window.removeEventListener("hashchange", this.updateScrollTarget), this.cachedScrollPositions = {}, delete this.swup.scrollTo;
    }
    shouldAnimate(t) {
        return "boolean" == typeof this.options.animateScroll ? this.options.animateScroll : this.options.animateScroll[t];
    }
    maybeScrollToAnchor(t, o = !1) {
        if (!t) return !1;
        const e = this.getAnchorElement(t);
        return e ? e instanceof Element ? (this.scrollElementIntoView(e, o), !0) : (console.warn(`Anchor target ${t} is not a DOM node`), !1) : (console.warn(`Anchor target ${t} not found`), !1);
    }
    cacheScrollPositions(t) {
        const o = this.swup.resolveUrl(t), s = $45a279ded9626458$var$e(this.options.scrollContainers).map((t)=>({
                top: t.scrollTop,
                left: t.scrollLeft
            })), l = {
            window: {
                top: window.scrollY,
                left: window.scrollX
            },
            containers: s
        };
        this.cachedScrollPositions[o] = l;
    }
    resetScrollPositions(t) {
        const o = this.swup.resolveUrl(t);
        delete this.cachedScrollPositions[o];
    }
    getCachedScrollPositions(t) {
        const o = this.swup.resolveUrl(t);
        return this.cachedScrollPositions[o];
    }
    restoreScrollContainers(t) {
        const o = this.getCachedScrollPositions(t);
        o && 0 !== o.containers.length && $45a279ded9626458$var$e(this.options.scrollContainers).forEach((t, e)=>{
            const s = o.containers[e];
            null != s && (t.scrollTop = s.top, t.scrollLeft = s.left);
        });
    }
    updateScrollTarget() {
        const { hash: t } = window.location, o = document.querySelector("[data-swup-scroll-target]");
        let e = this.getAnchorElement(t);
        e instanceof HTMLBodyElement && (e = null), o !== e && (o?.removeAttribute("data-swup-scroll-target"), e?.setAttribute("data-swup-scroll-target", ""));
    }
    getRootScrollContainer() {
        return document.scrollingElement instanceof HTMLElement ? document.scrollingElement : document.documentElement;
    }
    scrollTo(t, o = !0, e) {
        const s = this.swup.createVisit({
            to: this.swup.location.url
        }), { top: l = 0, left: i = 0 } = "number" == typeof t ? {
            top: t
        } : t;
        e ??= this.getRootScrollContainer(), (this.options.scrollFunction ?? this.applyScroll)(e, l, i, o, ()=>this.swup.hooks.callSync("scroll:start", s, void 0), ()=>this.swup.hooks.callSync("scroll:end", s, void 0));
    }
    applyScroll(t, o, e, s, l, i) {
        const r = t instanceof HTMLHtmlElement || t instanceof HTMLBodyElement ? window : t;
        l(), r.addEventListener("scrollend", i, {
            once: !0
        }), r.addEventListener("wheel", ()=>{
            t.scrollTo({
                top: t.scrollTop,
                left: t.scrollLeft,
                behavior: "instant"
            });
        }, {
            once: !0
        }), t.scrollTo({
            top: o,
            left: e,
            behavior: s ? "smooth" : "instant"
        });
    }
    scrollElementIntoView(t, e = !1) {
        (0, $fc9556b339369654$export$3b12cb22b12b954b)(t, {
            scrollMode: "always",
            block: "start",
            inline: "start"
        }).forEach(({ top: o, left: s, el: l })=>{
            const { top: i = 0, left: r = 0 } = this.getOffset(t, l, {
                top: o,
                left: s
            });
            this.scrollTo({
                top: o - i,
                left: s - r
            }, e, l);
        });
    }
}



var $5WGJt = parcelRequire("5WGJt");
/*!
 * CSSPlugin 3.15.0
 * https://gsap.com
 *
 * Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $5WGJt = parcelRequire("5WGJt");
var $75d916b583848404$var$_win, $75d916b583848404$var$_doc, $75d916b583848404$var$_docElement, $75d916b583848404$var$_pluginInitted, $75d916b583848404$var$_tempDiv, $75d916b583848404$var$_tempDivStyler, $75d916b583848404$var$_recentSetterPlugin, $75d916b583848404$var$_reverting, $75d916b583848404$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $75d916b583848404$var$_transformProps = {}, $75d916b583848404$var$_RAD2DEG = 180 / Math.PI, $75d916b583848404$var$_DEG2RAD = Math.PI / 180, $75d916b583848404$var$_atan2 = Math.atan2, $75d916b583848404$var$_bigNum = 1e8, $75d916b583848404$var$_capsExp = /([A-Z])/g, $75d916b583848404$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $75d916b583848404$var$_complexExp = /[\s,\(]\S/, $75d916b583848404$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $75d916b583848404$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $75d916b583848404$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $75d916b583848404$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$75d916b583848404$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$75d916b583848404$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $75d916b583848404$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $75d916b583848404$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $75d916b583848404$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $75d916b583848404$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $75d916b583848404$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $75d916b583848404$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $75d916b583848404$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $75d916b583848404$var$_transformProp = "transform", $75d916b583848404$var$_transformOriginProp = $75d916b583848404$var$_transformProp + "Origin", $75d916b583848404$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $75d916b583848404$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $75d916b583848404$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $75d916b583848404$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $75d916b583848404$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $75d916b583848404$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $75d916b583848404$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($75d916b583848404$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($75d916b583848404$var$_transformOriginProp, isNotCSS, "");
        }
        property = $75d916b583848404$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $75d916b583848404$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $75d916b583848404$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($75d916b583848404$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $75d916b583848404$var$_reverting();
        if ((!i || !i.isStart) && !style[$75d916b583848404$var$_transformProp]) {
            $75d916b583848404$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$75d916b583848404$var$_transformOriginProp]) {
                style[$75d916b583848404$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $75d916b583848404$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $75d916b583848404$var$_revertStyle,
        save: $75d916b583848404$var$_saveStyle
    };
    target._gsap || (0, $5WGJt.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $75d916b583848404$var$_supports3D, $75d916b583848404$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $75d916b583848404$var$_doc.createElementNS ? $75d916b583848404$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $75d916b583848404$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $75d916b583848404$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $75d916b583848404$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($75d916b583848404$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $75d916b583848404$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $75d916b583848404$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $75d916b583848404$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $75d916b583848404$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($75d916b583848404$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $75d916b583848404$var$_prefixes[i] : "") + property;
}, $75d916b583848404$var$_initCore = function _initCore() {
    if ($75d916b583848404$var$_windowExists() && window.document) {
        $75d916b583848404$var$_win = window;
        $75d916b583848404$var$_doc = $75d916b583848404$var$_win.document;
        $75d916b583848404$var$_docElement = $75d916b583848404$var$_doc.documentElement;
        $75d916b583848404$var$_tempDiv = $75d916b583848404$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $75d916b583848404$var$_tempDivStyler = $75d916b583848404$export$a232bb0480ae674a("div");
        $75d916b583848404$var$_transformProp = $75d916b583848404$export$8cbef5dd49a09c8b($75d916b583848404$var$_transformProp);
        $75d916b583848404$var$_transformOriginProp = $75d916b583848404$var$_transformProp + "Origin";
        $75d916b583848404$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $75d916b583848404$var$_supports3D = !!$75d916b583848404$export$8cbef5dd49a09c8b("perspective");
        $75d916b583848404$var$_reverting = (0, $5WGJt.gsap).core.reverting;
        $75d916b583848404$var$_pluginInitted = 1;
    }
}, $75d916b583848404$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $75d916b583848404$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $75d916b583848404$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $75d916b583848404$var$_docElement.removeChild(svg);
    return bbox;
}, $75d916b583848404$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $75d916b583848404$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $75d916b583848404$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $75d916b583848404$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$75d916b583848404$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$75d916b583848404$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $75d916b583848404$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $75d916b583848404$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$75d916b583848404$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $75d916b583848404$var$_transformProps && property !== $75d916b583848404$var$_transformOriginProp) property = $75d916b583848404$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($75d916b583848404$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $75d916b583848404$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $5WGJt.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd : $75d916b583848404$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $75d916b583848404$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $75d916b583848404$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$75d916b583848404$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $75d916b583848404$var$_tempDiv.style, horizontal = $75d916b583848404$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $75d916b583848404$var$_nonConvertibleUnits[unit] || $75d916b583848404$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $75d916b583848404$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($75d916b583848404$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $5WGJt._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $75d916b583848404$var$_doc || !parent.appendChild) parent = $75d916b583848404$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $5WGJt._ticker).time && !cache.uncache) return (0, $5WGJt._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $75d916b583848404$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$75d916b583848404$var$_nonStandardLayouts[$75d916b583848404$var$_getComputedProperty(parent, "display")] && (style.position = $75d916b583848404$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($75d916b583848404$var$_tempDiv);
            px = $75d916b583848404$var$_tempDiv[measureProperty];
            parent.removeChild($75d916b583848404$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $5WGJt._getCache)(parent);
            cache.time = (0, $5WGJt._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $5WGJt._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $75d916b583848404$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $75d916b583848404$var$_pluginInitted || $75d916b583848404$var$_initCore();
    if (property in $75d916b583848404$var$_propertyAliases && property !== "transform") {
        property = $75d916b583848404$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($75d916b583848404$var$_transformProps[property] && property !== "transform") {
        value = $75d916b583848404$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $75d916b583848404$var$_firstTwoOnly($75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $75d916b583848404$var$_specialProps[property] && $75d916b583848404$var$_specialProps[property](target, property, unit) || $75d916b583848404$var$_getComputedProperty(target, property) || (0, $5WGJt._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $75d916b583848404$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $75d916b583848404$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $75d916b583848404$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $75d916b583848404$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $75d916b583848404$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $5WGJt.PropTween)(this._pt, target.style, prop, 0, 1, (0, $5WGJt._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $75d916b583848404$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $75d916b583848404$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $75d916b583848404$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $5WGJt._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $5WGJt._numWithUnitExp)) || [];
    endValues = end.match((0, $5WGJt._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $5WGJt._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $5WGJt._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $5WGJt._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $5WGJt._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $75d916b583848404$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd : $75d916b583848404$var$_renderNonTweeningValue;
    (0, $5WGJt._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $75d916b583848404$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $75d916b583848404$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $75d916b583848404$var$_keywordToPercent[x] || x;
    split[1] = $75d916b583848404$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $75d916b583848404$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($75d916b583848404$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $75d916b583848404$var$_transformOriginProp : $75d916b583848404$var$_transformProp;
                }
                $75d916b583848404$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $75d916b583848404$var$_removeProperty(target, $75d916b583848404$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $75d916b583848404$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $75d916b583848404$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$75d916b583848404$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $5WGJt.PropTween)(plugin._pt, target, property, 0, 0, $75d916b583848404$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $75d916b583848404$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $75d916b583848404$var$_rotationalProperties = {}, $75d916b583848404$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $75d916b583848404$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformProp);
    return $75d916b583848404$var$_isNullTransform(matrixString) ? $75d916b583848404$var$_identity2DMatrix : matrixString.substr(7).match((0, $5WGJt._numExp)).map((0, $5WGJt._round));
}, $75d916b583848404$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $5WGJt._getCache)(target), style = target.style, matrix = $75d916b583848404$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $75d916b583848404$var$_identity2DMatrix : matrix;
    } else if (matrix === $75d916b583848404$var$_identity2DMatrix && !target.offsetParent && target !== $75d916b583848404$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $75d916b583848404$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $75d916b583848404$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $75d916b583848404$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $75d916b583848404$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $75d916b583848404$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $75d916b583848404$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $75d916b583848404$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $75d916b583848404$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$75d916b583848404$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $75d916b583848404$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $5WGJt.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $75d916b583848404$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$75d916b583848404$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$75d916b583848404$var$_transformProp] !== "none" ? cs[$75d916b583848404$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $75d916b583848404$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $75d916b583848404$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $75d916b583848404$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $75d916b583848404$var$_atan2(b, a) * $75d916b583848404$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $75d916b583848404$var$_atan2(c, d) * $75d916b583848404$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $75d916b583848404$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $75d916b583848404$var$_atan2(a32, a33);
            rotationX = angle * $75d916b583848404$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $75d916b583848404$var$_atan2(-c, a33);
            rotationY = angle * $75d916b583848404$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $75d916b583848404$var$_atan2(b, a);
            rotation = angle * $75d916b583848404$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $5WGJt._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $5WGJt._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $75d916b583848404$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $75d916b583848404$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$75d916b583848404$var$_isNullTransform($75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $5WGJt._round)(scaleX);
    cache.scaleY = (0, $5WGJt._round)(scaleY);
    cache.rotation = (0, $5WGJt._round)(rotation) + deg;
    cache.rotationX = (0, $5WGJt._round)(rotationX) + deg;
    cache.rotationY = (0, $5WGJt._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$75d916b583848404$var$_transformOriginProp] = $75d916b583848404$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $5WGJt._config).force3D;
    cache.renderTransform = cache.svg ? $75d916b583848404$var$_renderSVGTransforms : $75d916b583848404$var$_supports3D ? $75d916b583848404$var$_renderCSSTransforms : $75d916b583848404$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $75d916b583848404$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$75d916b583848404$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $5WGJt.getUnit)(start);
    return (0, $5WGJt._round)(parseFloat(start) + parseFloat($75d916b583848404$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $75d916b583848404$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $75d916b583848404$var$_renderCSSTransforms(ratio, cache);
}, $75d916b583848404$var$_zeroDeg = "0deg", $75d916b583848404$var$_zeroPx = "0px", $75d916b583848404$var$_endParenthesis = ") ", $75d916b583848404$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $75d916b583848404$var$_zeroDeg || rotationY !== $75d916b583848404$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $75d916b583848404$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $75d916b583848404$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $75d916b583848404$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $75d916b583848404$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $75d916b583848404$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $75d916b583848404$var$_zeroPx) transforms += "perspective(" + transformPerspective + $75d916b583848404$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $75d916b583848404$var$_zeroPx || y !== $75d916b583848404$var$_zeroPx || z !== $75d916b583848404$var$_zeroPx) transforms += z !== $75d916b583848404$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $75d916b583848404$var$_endParenthesis;
    if (rotation !== $75d916b583848404$var$_zeroDeg) transforms += "rotate(" + rotation + $75d916b583848404$var$_endParenthesis;
    if (rotationY !== $75d916b583848404$var$_zeroDeg) transforms += "rotateY(" + rotationY + $75d916b583848404$var$_endParenthesis;
    if (rotationX !== $75d916b583848404$var$_zeroDeg) transforms += "rotateX(" + rotationX + $75d916b583848404$var$_endParenthesis;
    if (skewX !== $75d916b583848404$var$_zeroDeg || skewY !== $75d916b583848404$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $75d916b583848404$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $75d916b583848404$var$_endParenthesis;
    target.style[$75d916b583848404$var$_transformProp] = transforms || "translate(0, 0)";
}, $75d916b583848404$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $75d916b583848404$var$_DEG2RAD;
        skewX *= $75d916b583848404$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $75d916b583848404$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $5WGJt._round)(a11);
        a21 = (0, $5WGJt._round)(a21);
        a12 = (0, $5WGJt._round)(a12);
        a22 = (0, $5WGJt._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $75d916b583848404$var$_convertToUnit(target, "x", x, "px");
        ty = $75d916b583848404$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $5WGJt._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $5WGJt._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $5WGJt._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $5WGJt._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$75d916b583848404$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $75d916b583848404$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $5WGJt._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $75d916b583848404$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $75d916b583848404$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $75d916b583848404$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $5WGJt.PropTween)(plugin._pt, target, property, startNum, change, $75d916b583848404$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $75d916b583848404$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $75d916b583848404$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $75d916b583848404$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$75d916b583848404$var$_transformProp] = transforms;
        endCache = $75d916b583848404$var$_parseTransform(target, 1);
        $75d916b583848404$var$_removeProperty(target, $75d916b583848404$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$75d916b583848404$var$_transformProp];
        style[$75d916b583848404$var$_transformProp] = transforms;
        endCache = $75d916b583848404$var$_parseTransform(target, 1);
        style[$75d916b583848404$var$_transformProp] = startValue;
    }
    for(p in $75d916b583848404$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $5WGJt.getUnit)(startValue);
            endUnit = (0, $5WGJt.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $5WGJt.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $75d916b583848404$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $75d916b583848404$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $5WGJt._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $75d916b583848404$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $75d916b583848404$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $75d916b583848404$export$855822f522f18eef = {
    name: "css",
    register: $75d916b583848404$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $75d916b583848404$var$_pluginInitted || $75d916b583848404$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $75d916b583848404$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $5WGJt._plugins)[p] && (0, $5WGJt._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $75d916b583848404$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $5WGJt._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $5WGJt._colorExp).lastIndex = 0;
                if (!(0, $5WGJt._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $5WGJt.getUnit)(startValue);
                    endUnit = (0, $5WGJt.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $5WGJt._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $5WGJt._replaceRandom)(startValue));
                    (0, $5WGJt.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $5WGJt._config).units[p] || (0, $5WGJt.getUnit)($75d916b583848404$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $75d916b583848404$var$_get(target, p)); // can't work with relative values
                } else startValue = $75d916b583848404$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $75d916b583848404$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $75d916b583848404$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $75d916b583848404$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $75d916b583848404$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $75d916b583848404$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $75d916b583848404$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $75d916b583848404$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $75d916b583848404$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $75d916b583848404$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $5WGJt.PropTween)(this._pt, style, $75d916b583848404$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $5WGJt.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $5WGJt._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $75d916b583848404$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($75d916b583848404$var$_transformOriginProp, 0, style[$75d916b583848404$var$_transformOriginProp]);
                        endValue = $75d916b583848404$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $75d916b583848404$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $75d916b583848404$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $75d916b583848404$var$_addNonTweeningPT(this, style, p, $75d916b583848404$var$_firstTwoOnly(startValue), $75d916b583848404$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $75d916b583848404$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $75d916b583848404$var$_rotationalProperties) {
                        $75d916b583848404$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $5WGJt._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $75d916b583848404$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $75d916b583848404$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $75d916b583848404$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$75d916b583848404$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $5WGJt.getUnit)(endValue) || (p in (0, $5WGJt._config).units ? (0, $5WGJt._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $5WGJt.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $5WGJt._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $75d916b583848404$var$_renderRoundedCSSProp : $75d916b583848404$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $75d916b583848404$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $75d916b583848404$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $5WGJt._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $75d916b583848404$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $5WGJt._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$75d916b583848404$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $75d916b583848404$var$_get,
    aliases: $75d916b583848404$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $75d916b583848404$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $75d916b583848404$var$_transformProps && property !== $75d916b583848404$var$_transformOriginProp && (target._gsap.x || $75d916b583848404$var$_get(target, "x")) ? plugin && $75d916b583848404$var$_recentSetterPlugin === plugin ? property === "scale" ? $75d916b583848404$var$_setterScale : $75d916b583848404$var$_setterTransform : ($75d916b583848404$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $75d916b583848404$var$_setterScaleWithRender : $75d916b583848404$var$_setterTransformWithRender) : target.style && !(0, $5WGJt._isUndefined)(target.style[property]) ? $75d916b583848404$var$_setterCSSStyle : ~property.indexOf("-") ? $75d916b583848404$var$_setterCSSProp : (0, $5WGJt._getSetter)(target, property);
    },
    core: {
        _removeProperty: $75d916b583848404$var$_removeProperty,
        _getMatrix: $75d916b583848404$var$_getMatrix
    }
};
(0, $5WGJt.gsap).utils.checkPrefix = $75d916b583848404$export$8cbef5dd49a09c8b;
(0, $5WGJt.gsap).core.getStyleSaver = $75d916b583848404$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $5WGJt._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $75d916b583848404$var$_transformProps[name] = 1;
    });
    (0, $5WGJt._forEachName)(rotation, function(name) {
        (0, $5WGJt._config).units[name] = "deg";
        $75d916b583848404$var$_rotationalProperties[name] = 1;
    });
    $75d916b583848404$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $5WGJt._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $75d916b583848404$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $5WGJt._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $5WGJt._config).units[name] = "px";
});
(0, $5WGJt.gsap).registerPlugin($75d916b583848404$export$855822f522f18eef);


var $f3bc927f09a8d458$export$99ee26438460406a = (0, $5WGJt.gsap).registerPlugin((0, $75d916b583848404$export$855822f522f18eef)) || (0, $5WGJt.gsap), // to protect from tree shaking
$f3bc927f09a8d458$export$7b23975ad686bf91 = $f3bc927f09a8d458$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $cfd1378c1e8f6244$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cfd1378c1e8f6244$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cfd1378c1e8f6244$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cfd1378c1e8f6244$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $cfd1378c1e8f6244$var$gsap, $cfd1378c1e8f6244$var$_coreInitted, $cfd1378c1e8f6244$var$_clamp, $cfd1378c1e8f6244$var$_win, $cfd1378c1e8f6244$var$_doc, $cfd1378c1e8f6244$var$_docEl, $cfd1378c1e8f6244$var$_body, $cfd1378c1e8f6244$var$_isTouch, $cfd1378c1e8f6244$var$_pointerType, $cfd1378c1e8f6244$var$ScrollTrigger, $cfd1378c1e8f6244$var$_root, $cfd1378c1e8f6244$var$_normalizer, $cfd1378c1e8f6244$var$_eventTypes, $cfd1378c1e8f6244$var$_context, $cfd1378c1e8f6244$var$_getGSAP = function _getGSAP() {
    return $cfd1378c1e8f6244$var$gsap || typeof window !== "undefined" && ($cfd1378c1e8f6244$var$gsap = window.gsap) && $cfd1378c1e8f6244$var$gsap.registerPlugin && $cfd1378c1e8f6244$var$gsap;
}, $cfd1378c1e8f6244$var$_startup = 1, $cfd1378c1e8f6244$var$_observers = [], $cfd1378c1e8f6244$export$3cd1cee43d19b683 = [], $cfd1378c1e8f6244$export$d8e56d510a804d0a = [], $cfd1378c1e8f6244$var$_getTime = Date.now, $cfd1378c1e8f6244$var$_bridge = function _bridge(name, value) {
    return value;
}, $cfd1378c1e8f6244$var$_integrate = function _integrate() {
    var core = $cfd1378c1e8f6244$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $cfd1378c1e8f6244$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $cfd1378c1e8f6244$export$d8e56d510a804d0a);
    $cfd1378c1e8f6244$export$3cd1cee43d19b683 = scrollers;
    $cfd1378c1e8f6244$export$d8e56d510a804d0a = proxies;
    $cfd1378c1e8f6244$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $cfd1378c1e8f6244$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$cfd1378c1e8f6244$export$d8e56d510a804d0a.indexOf(element) && $cfd1378c1e8f6244$export$d8e56d510a804d0a[$cfd1378c1e8f6244$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $cfd1378c1e8f6244$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$cfd1378c1e8f6244$var$_root.indexOf(el);
}, $cfd1378c1e8f6244$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $cfd1378c1e8f6244$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $cfd1378c1e8f6244$var$_scrollLeft = "scrollLeft", $cfd1378c1e8f6244$var$_scrollTop = "scrollTop", $cfd1378c1e8f6244$var$_onScroll = function _onScroll() {
    return $cfd1378c1e8f6244$var$_normalizer && $cfd1378c1e8f6244$var$_normalizer.isPressed || $cfd1378c1e8f6244$export$3cd1cee43d19b683.cache++;
}, $cfd1378c1e8f6244$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $cfd1378c1e8f6244$var$_startup && ($cfd1378c1e8f6244$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $cfd1378c1e8f6244$var$_normalizer && $cfd1378c1e8f6244$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($cfd1378c1e8f6244$var$_normalizer && $cfd1378c1e8f6244$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $cfd1378c1e8f6244$export$3cd1cee43d19b683.cache;
            isNormalizing && $cfd1378c1e8f6244$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $cfd1378c1e8f6244$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $cfd1378c1e8f6244$var$_bridge("ref")) {
            cachingFunc.cacheID = $cfd1378c1e8f6244$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1 = {
    s: $cfd1378c1e8f6244$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $cfd1378c1e8f6244$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $cfd1378c1e8f6244$var$_win.scrollTo(value, $cfd1378c1e8f6244$export$8e40fc98ff518e9d.sc()) : $cfd1378c1e8f6244$var$_win.pageXOffset || $cfd1378c1e8f6244$var$_doc[$cfd1378c1e8f6244$var$_scrollLeft] || $cfd1378c1e8f6244$var$_docEl[$cfd1378c1e8f6244$var$_scrollLeft] || $cfd1378c1e8f6244$var$_body[$cfd1378c1e8f6244$var$_scrollLeft] || 0;
    })
}, $cfd1378c1e8f6244$export$8e40fc98ff518e9d = {
    s: $cfd1378c1e8f6244$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $cfd1378c1e8f6244$export$b2cabb342cb0ebe1,
    sc: $cfd1378c1e8f6244$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $cfd1378c1e8f6244$var$_win.scrollTo($cfd1378c1e8f6244$export$b2cabb342cb0ebe1.sc(), value) : $cfd1378c1e8f6244$var$_win.pageYOffset || $cfd1378c1e8f6244$var$_doc[$cfd1378c1e8f6244$var$_scrollTop] || $cfd1378c1e8f6244$var$_docEl[$cfd1378c1e8f6244$var$_scrollTop] || $cfd1378c1e8f6244$var$_body[$cfd1378c1e8f6244$var$_scrollTop] || 0;
    })
}, $cfd1378c1e8f6244$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $cfd1378c1e8f6244$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $cfd1378c1e8f6244$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $cfd1378c1e8f6244$var$_isWithin = function _isWithin(element, list) {
    // check if the element is in the list or is a descendant of an element in the list.
    var i = list.length;
    while(i--){
        if (list[i] === element || list[i].contains(element)) return true;
    }
    return false;
}, $cfd1378c1e8f6244$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $cfd1378c1e8f6244$export$4330f3a92e5d2e94(element) && (element = $cfd1378c1e8f6244$var$_doc.scrollingElement || $cfd1378c1e8f6244$var$_docEl);
    var i = $cfd1378c1e8f6244$export$3cd1cee43d19b683.indexOf(element), offset = sc === $cfd1378c1e8f6244$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $cfd1378c1e8f6244$export$3cd1cee43d19b683.push(element) - 1);
    $cfd1378c1e8f6244$export$3cd1cee43d19b683[i + offset] || $cfd1378c1e8f6244$var$_addListener(element, "scroll", $cfd1378c1e8f6244$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $cfd1378c1e8f6244$export$3cd1cee43d19b683[i + offset], func = prev || ($cfd1378c1e8f6244$export$3cd1cee43d19b683[i + offset] = $cfd1378c1e8f6244$var$_scrollCacheFunc($cfd1378c1e8f6244$export$6078f1ef08b38af9(element, s), true) || ($cfd1378c1e8f6244$export$4330f3a92e5d2e94(element) ? sc : $cfd1378c1e8f6244$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $cfd1378c1e8f6244$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $cfd1378c1e8f6244$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $cfd1378c1e8f6244$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $cfd1378c1e8f6244$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $cfd1378c1e8f6244$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $cfd1378c1e8f6244$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.cancelable !== false && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $cfd1378c1e8f6244$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $cfd1378c1e8f6244$var$_setScrollTrigger = function _setScrollTrigger() {
    $cfd1378c1e8f6244$var$ScrollTrigger = $cfd1378c1e8f6244$var$gsap.core.globals().ScrollTrigger;
    $cfd1378c1e8f6244$var$ScrollTrigger && $cfd1378c1e8f6244$var$ScrollTrigger.core && $cfd1378c1e8f6244$var$_integrate();
}, $cfd1378c1e8f6244$var$_initCore = function _initCore(core) {
    $cfd1378c1e8f6244$var$gsap = core || $cfd1378c1e8f6244$var$_getGSAP();
    if (!$cfd1378c1e8f6244$var$_coreInitted && $cfd1378c1e8f6244$var$gsap && typeof document !== "undefined" && document.body) {
        $cfd1378c1e8f6244$var$_win = window;
        $cfd1378c1e8f6244$var$_doc = document;
        $cfd1378c1e8f6244$var$_docEl = $cfd1378c1e8f6244$var$_doc.documentElement;
        $cfd1378c1e8f6244$var$_body = $cfd1378c1e8f6244$var$_doc.body;
        $cfd1378c1e8f6244$var$_root = [
            $cfd1378c1e8f6244$var$_win,
            $cfd1378c1e8f6244$var$_doc,
            $cfd1378c1e8f6244$var$_docEl,
            $cfd1378c1e8f6244$var$_body
        ];
        $cfd1378c1e8f6244$var$_clamp = $cfd1378c1e8f6244$var$gsap.utils.clamp;
        $cfd1378c1e8f6244$var$_context = $cfd1378c1e8f6244$var$gsap.core.context || function() {};
        $cfd1378c1e8f6244$var$_pointerType = "onpointerenter" in $cfd1378c1e8f6244$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $cfd1378c1e8f6244$var$_isTouch = $cfd1378c1e8f6244$export$c1cbdee04e18ea8b.isTouch = $cfd1378c1e8f6244$var$_win.matchMedia && $cfd1378c1e8f6244$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $cfd1378c1e8f6244$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $cfd1378c1e8f6244$var$_eventTypes = $cfd1378c1e8f6244$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $cfd1378c1e8f6244$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $cfd1378c1e8f6244$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $cfd1378c1e8f6244$var$_startup = 0;
        }, 500);
        $cfd1378c1e8f6244$var$_coreInitted = 1;
    }
    $cfd1378c1e8f6244$var$ScrollTrigger || $cfd1378c1e8f6244$var$_setScrollTrigger(); // Observer might be initted BEFORE ScrollTrigger, so don't put this with the initting code. ScrollTrigger will call Observer.register() when it inits.
    return $cfd1378c1e8f6244$var$_coreInitted;
};
$cfd1378c1e8f6244$export$b2cabb342cb0ebe1.op = $cfd1378c1e8f6244$export$8e40fc98ff518e9d;
$cfd1378c1e8f6244$export$3cd1cee43d19b683.cache = 0;
var $cfd1378c1e8f6244$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $cfd1378c1e8f6244$var$_coreInitted || $cfd1378c1e8f6244$var$_initCore($cfd1378c1e8f6244$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $cfd1378c1e8f6244$var$ScrollTrigger || $cfd1378c1e8f6244$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $cfd1378c1e8f6244$export$937374fea3f88711(target) || $cfd1378c1e8f6244$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $cfd1378c1e8f6244$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($cfd1378c1e8f6244$var$_win.getComputedStyle($cfd1378c1e8f6244$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = $cfd1378c1e8f6244$export$8665aac53dad5647(target, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1), scrollFuncY = $cfd1378c1e8f6244$export$8665aac53dad5647(target, $cfd1378c1e8f6244$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $cfd1378c1e8f6244$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $cfd1378c1e8f6244$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $cfd1378c1e8f6244$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $cfd1378c1e8f6244$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && $cfd1378c1e8f6244$var$_isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $cfd1378c1e8f6244$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $cfd1378c1e8f6244$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $cfd1378c1e8f6244$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $cfd1378c1e8f6244$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $cfd1378c1e8f6244$var$_addListener(isNormalizer ? target : ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $cfd1378c1e8f6244$var$_removeListener(isNormalizer ? target : ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $cfd1378c1e8f6244$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $cfd1378c1e8f6244$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($cfd1378c1e8f6244$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $cfd1378c1e8f6244$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $cfd1378c1e8f6244$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $cfd1378c1e8f6244$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $cfd1378c1e8f6244$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $cfd1378c1e8f6244$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $cfd1378c1e8f6244$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $cfd1378c1e8f6244$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $cfd1378c1e8f6244$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $cfd1378c1e8f6244$var$_addListener(isViewport ? ownerDoc : target, "scroll", $cfd1378c1e8f6244$var$_onScroll);
                type.indexOf("scroll") >= 0 && $cfd1378c1e8f6244$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $cfd1378c1e8f6244$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $cfd1378c1e8f6244$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $cfd1378c1e8f6244$var$_addListener(target, $cfd1378c1e8f6244$var$_eventTypes[0], _onPress, passive, capture);
                    $cfd1378c1e8f6244$var$_addListener(ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[2], _onRelease);
                    $cfd1378c1e8f6244$var$_addListener(ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[3], _onRelease);
                    allowClicks && $cfd1378c1e8f6244$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $cfd1378c1e8f6244$var$_addListener(target, "click", _onClick);
                    onGestureStart && $cfd1378c1e8f6244$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $cfd1378c1e8f6244$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $cfd1378c1e8f6244$var$_addListener(target, $cfd1378c1e8f6244$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $cfd1378c1e8f6244$var$_addListener(target, $cfd1378c1e8f6244$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $cfd1378c1e8f6244$var$_addListener(target, $cfd1378c1e8f6244$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $cfd1378c1e8f6244$var$_observers.filter(function(o) {
                    return o !== self && $cfd1378c1e8f6244$export$4330f3a92e5d2e94(o.target);
                }).length || $cfd1378c1e8f6244$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $cfd1378c1e8f6244$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $cfd1378c1e8f6244$var$_removeListener(isNormalizer ? target : ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[1], _onDrag, true);
                }
                $cfd1378c1e8f6244$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $cfd1378c1e8f6244$var$_removeListener(target, "wheel", _onWheel, capture);
                $cfd1378c1e8f6244$var$_removeListener(target, $cfd1378c1e8f6244$var$_eventTypes[0], _onPress, capture);
                $cfd1378c1e8f6244$var$_removeListener(ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[2], _onRelease);
                $cfd1378c1e8f6244$var$_removeListener(ownerDoc, $cfd1378c1e8f6244$var$_eventTypes[3], _onRelease);
                $cfd1378c1e8f6244$var$_removeListener(target, "click", clickCapture, true);
                $cfd1378c1e8f6244$var$_removeListener(target, "click", _onClick);
                $cfd1378c1e8f6244$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $cfd1378c1e8f6244$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $cfd1378c1e8f6244$var$_removeListener(target, $cfd1378c1e8f6244$var$_pointerType + "enter", _onHover);
                $cfd1378c1e8f6244$var$_removeListener(target, $cfd1378c1e8f6244$var$_pointerType + "leave", _onHoverEnd);
                $cfd1378c1e8f6244$var$_removeListener(target, $cfd1378c1e8f6244$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $cfd1378c1e8f6244$var$_observers.indexOf(self);
            i >= 0 && $cfd1378c1e8f6244$var$_observers.splice(i, 1);
            $cfd1378c1e8f6244$var$_normalizer === self && ($cfd1378c1e8f6244$var$_normalizer = 0);
        };
        $cfd1378c1e8f6244$var$_observers.push(self);
        isNormalizer && $cfd1378c1e8f6244$export$4330f3a92e5d2e94(target) && ($cfd1378c1e8f6244$var$_normalizer = self);
        self.enable(event);
    };
    $cfd1378c1e8f6244$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$cfd1378c1e8f6244$export$c1cbdee04e18ea8b.version = "3.15.0";
$cfd1378c1e8f6244$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $cfd1378c1e8f6244$export$c1cbdee04e18ea8b(vars);
};
$cfd1378c1e8f6244$export$c1cbdee04e18ea8b.register = $cfd1378c1e8f6244$var$_initCore;
$cfd1378c1e8f6244$export$c1cbdee04e18ea8b.getAll = function() {
    return $cfd1378c1e8f6244$var$_observers.slice();
};
$cfd1378c1e8f6244$export$c1cbdee04e18ea8b.getById = function(id) {
    return $cfd1378c1e8f6244$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$cfd1378c1e8f6244$var$_getGSAP() && $cfd1378c1e8f6244$var$gsap.registerPlugin($cfd1378c1e8f6244$export$c1cbdee04e18ea8b);


var $ae5f928ed8e7c926$var$gsap, $ae5f928ed8e7c926$var$_coreInitted, $ae5f928ed8e7c926$var$_win, $ae5f928ed8e7c926$var$_doc, $ae5f928ed8e7c926$var$_docEl, $ae5f928ed8e7c926$var$_body, $ae5f928ed8e7c926$var$_root, $ae5f928ed8e7c926$var$_resizeDelay, $ae5f928ed8e7c926$var$_toArray, $ae5f928ed8e7c926$var$_clamp, $ae5f928ed8e7c926$var$_time2, $ae5f928ed8e7c926$var$_syncInterval, $ae5f928ed8e7c926$var$_refreshing, $ae5f928ed8e7c926$var$_pointerIsDown, $ae5f928ed8e7c926$var$_transformProp, $ae5f928ed8e7c926$var$_i, $ae5f928ed8e7c926$var$_prevWidth, $ae5f928ed8e7c926$var$_prevHeight, $ae5f928ed8e7c926$var$_autoRefresh, $ae5f928ed8e7c926$var$_sort, $ae5f928ed8e7c926$var$_suppressOverwrites, $ae5f928ed8e7c926$var$_ignoreResize, $ae5f928ed8e7c926$var$_normalizer, $ae5f928ed8e7c926$var$_ignoreMobileResize, $ae5f928ed8e7c926$var$_baseScreenHeight, $ae5f928ed8e7c926$var$_baseScreenWidth, $ae5f928ed8e7c926$var$_fixIOSBug, $ae5f928ed8e7c926$var$_context, $ae5f928ed8e7c926$var$_scrollRestoration, $ae5f928ed8e7c926$var$_div100vh, $ae5f928ed8e7c926$var$_100vh, $ae5f928ed8e7c926$var$_isReverted, $ae5f928ed8e7c926$var$_clampingMax, $ae5f928ed8e7c926$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$ae5f928ed8e7c926$var$_startup = 1, $ae5f928ed8e7c926$var$_getTime = Date.now, $ae5f928ed8e7c926$var$_time1 = $ae5f928ed8e7c926$var$_getTime(), $ae5f928ed8e7c926$var$_lastScrollTime = 0, $ae5f928ed8e7c926$var$_enabled = 0, $ae5f928ed8e7c926$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $ae5f928ed8e7c926$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $ae5f928ed8e7c926$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$ae5f928ed8e7c926$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $ae5f928ed8e7c926$var$_rafBugFix = function _rafBugFix() {
    return $ae5f928ed8e7c926$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$ae5f928ed8e7c926$var$_pointerDownHandler = function _pointerDownHandler() {
    return $ae5f928ed8e7c926$var$_pointerIsDown = 1;
}, $ae5f928ed8e7c926$var$_pointerUpHandler = function _pointerUpHandler() {
    return $ae5f928ed8e7c926$var$_pointerIsDown = 0;
}, $ae5f928ed8e7c926$var$_passThrough = function _passThrough(v) {
    return v;
}, $ae5f928ed8e7c926$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $ae5f928ed8e7c926$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $ae5f928ed8e7c926$var$_getGSAP = function _getGSAP() {
    return $ae5f928ed8e7c926$var$gsap || $ae5f928ed8e7c926$var$_windowExists() && ($ae5f928ed8e7c926$var$gsap = window.gsap) && $ae5f928ed8e7c926$var$gsap.registerPlugin && $ae5f928ed8e7c926$var$gsap;
}, $ae5f928ed8e7c926$var$_isViewport = function _isViewport(e) {
    return !!~$ae5f928ed8e7c926$var$_root.indexOf(e);
}, $ae5f928ed8e7c926$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $ae5f928ed8e7c926$var$_100vh : $ae5f928ed8e7c926$var$_win["inner" + dimensionProperty]) || $ae5f928ed8e7c926$var$_docEl["client" + dimensionProperty] || $ae5f928ed8e7c926$var$_body["client" + dimensionProperty];
}, $ae5f928ed8e7c926$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($ae5f928ed8e7c926$var$_isViewport(element) ? function() {
        $ae5f928ed8e7c926$var$_winOffsets.width = $ae5f928ed8e7c926$var$_win.innerWidth;
        $ae5f928ed8e7c926$var$_winOffsets.height = $ae5f928ed8e7c926$var$_100vh;
        return $ae5f928ed8e7c926$var$_winOffsets;
    } : function() {
        return $ae5f928ed8e7c926$var$_getBounds(element);
    });
}, $ae5f928ed8e7c926$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $ae5f928ed8e7c926$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $ae5f928ed8e7c926$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $cfd1378c1e8f6244$export$d8e56d510a804d0a).indexOf(element) ? $ae5f928ed8e7c926$var$_getBoundsFunc(element) : function() {
        return $ae5f928ed8e7c926$var$_winOffsets;
    };
}, $ae5f928ed8e7c926$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(element, s)) ? a() - $ae5f928ed8e7c926$var$_getBoundsFunc(element)()[d] : $ae5f928ed8e7c926$var$_isViewport(element) ? ($ae5f928ed8e7c926$var$_docEl[s] || $ae5f928ed8e7c926$var$_body[s]) - $ae5f928ed8e7c926$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $ae5f928ed8e7c926$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $ae5f928ed8e7c926$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($ae5f928ed8e7c926$var$_autoRefresh[i + 1])) && func($ae5f928ed8e7c926$var$_autoRefresh[i], $ae5f928ed8e7c926$var$_autoRefresh[i + 1], $ae5f928ed8e7c926$var$_autoRefresh[i + 2]);
}, $ae5f928ed8e7c926$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $ae5f928ed8e7c926$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $ae5f928ed8e7c926$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $ae5f928ed8e7c926$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $ae5f928ed8e7c926$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $ae5f928ed8e7c926$var$_callback = function _callback(self, func, extraParam) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self, extraParam);
        }) : func(self, extraParam);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $ae5f928ed8e7c926$var$_abs = Math.abs, $ae5f928ed8e7c926$var$_left = "left", $ae5f928ed8e7c926$var$_top = "top", $ae5f928ed8e7c926$var$_right = "right", $ae5f928ed8e7c926$var$_bottom = "bottom", $ae5f928ed8e7c926$var$_width = "width", $ae5f928ed8e7c926$var$_height = "height", $ae5f928ed8e7c926$var$_Right = "Right", $ae5f928ed8e7c926$var$_Left = "Left", $ae5f928ed8e7c926$var$_Top = "Top", $ae5f928ed8e7c926$var$_Bottom = "Bottom", $ae5f928ed8e7c926$var$_padding = "padding", $ae5f928ed8e7c926$var$_margin = "margin", $ae5f928ed8e7c926$var$_Width = "Width", $ae5f928ed8e7c926$var$_Height = "Height", $ae5f928ed8e7c926$var$_px = "px", $ae5f928ed8e7c926$var$_getComputedStyle = function _getComputedStyle(element) {
    return $ae5f928ed8e7c926$var$_win.getComputedStyle(element.nodeType === Node.DOCUMENT_NODE ? element.scrollingElement : element);
}, $ae5f928ed8e7c926$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $ae5f928ed8e7c926$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $ae5f928ed8e7c926$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $ae5f928ed8e7c926$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $ae5f928ed8e7c926$var$_getComputedStyle(element)[$ae5f928ed8e7c926$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $ae5f928ed8e7c926$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect ? element.getBoundingClientRect() : element.scrollingElement.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $ae5f928ed8e7c926$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $ae5f928ed8e7c926$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $ae5f928ed8e7c926$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $ae5f928ed8e7c926$var$gsap.utils.snap($ae5f928ed8e7c926$var$_getLabelRatioArray(animation), value);
    };
}, $ae5f928ed8e7c926$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $ae5f928ed8e7c926$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $ae5f928ed8e7c926$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $ae5f928ed8e7c926$var$_snapDirectional($ae5f928ed8e7c926$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $ae5f928ed8e7c926$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $ae5f928ed8e7c926$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $ae5f928ed8e7c926$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $ae5f928ed8e7c926$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $ae5f928ed8e7c926$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $ae5f928ed8e7c926$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $ae5f928ed8e7c926$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $ae5f928ed8e7c926$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($ae5f928ed8e7c926$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $ae5f928ed8e7c926$var$_keywords ? $ae5f928ed8e7c926$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $ae5f928ed8e7c926$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $ae5f928ed8e7c926$var$_doc.createElement("div"), useFixedPosition = $ae5f928ed8e7c926$var$_isViewport(container) || (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $ae5f928ed8e7c926$var$_body : container.tagName === "IFRAME" ? container.contentDocument.body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d) ? $ae5f928ed8e7c926$var$_right : $ae5f928ed8e7c926$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $ae5f928ed8e7c926$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $ae5f928ed8e7c926$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $ae5f928ed8e7c926$var$_Width] = 1;
    vars["border" + oppositeSide + $ae5f928ed8e7c926$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $ae5f928ed8e7c926$var$gsap.set(marker, vars);
}, $ae5f928ed8e7c926$var$_triggers = [], $ae5f928ed8e7c926$var$_ids = {}, $ae5f928ed8e7c926$var$_rafID, $ae5f928ed8e7c926$var$_sync = function _sync() {
    return $ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_lastScrollTime > 34 && ($ae5f928ed8e7c926$var$_rafID || ($ae5f928ed8e7c926$var$_rafID = requestAnimationFrame($ae5f928ed8e7c926$var$_updateAll)));
}, $ae5f928ed8e7c926$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$ae5f928ed8e7c926$var$_normalizer || !$ae5f928ed8e7c926$var$_normalizer.isPressed || $ae5f928ed8e7c926$var$_normalizer.startX > $ae5f928ed8e7c926$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++;
        if ($ae5f928ed8e7c926$var$_normalizer) $ae5f928ed8e7c926$var$_rafID || ($ae5f928ed8e7c926$var$_rafID = requestAnimationFrame($ae5f928ed8e7c926$var$_updateAll));
        else $ae5f928ed8e7c926$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $ae5f928ed8e7c926$var$_lastScrollTime || $ae5f928ed8e7c926$var$_dispatch("scrollStart");
        $ae5f928ed8e7c926$var$_lastScrollTime = $ae5f928ed8e7c926$var$_getTime();
    }
}, $ae5f928ed8e7c926$var$_setBaseDimensions = function _setBaseDimensions() {
    $ae5f928ed8e7c926$var$_baseScreenWidth = $ae5f928ed8e7c926$var$_win.innerWidth;
    $ae5f928ed8e7c926$var$_baseScreenHeight = $ae5f928ed8e7c926$var$_win.innerHeight;
}, $ae5f928ed8e7c926$var$_onResize = function _onResize(force) {
    (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++;
    (force === true || !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_ignoreResize && !$ae5f928ed8e7c926$var$_doc.fullscreenElement && !$ae5f928ed8e7c926$var$_doc.webkitFullscreenElement && (!$ae5f928ed8e7c926$var$_ignoreMobileResize || $ae5f928ed8e7c926$var$_baseScreenWidth !== $ae5f928ed8e7c926$var$_win.innerWidth || Math.abs($ae5f928ed8e7c926$var$_win.innerHeight - $ae5f928ed8e7c926$var$_baseScreenHeight) > $ae5f928ed8e7c926$var$_win.innerHeight * 0.25)) && $ae5f928ed8e7c926$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$ae5f928ed8e7c926$var$_listeners = {}, $ae5f928ed8e7c926$var$_emptyArray = [], $ae5f928ed8e7c926$var$_softRefresh = function _softRefresh() {
    return $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$export$875bcbe48555930, "scrollEnd", _softRefresh) || $ae5f928ed8e7c926$var$_refreshAll(true);
}, $ae5f928ed8e7c926$var$_dispatch = function _dispatch(type) {
    return $ae5f928ed8e7c926$var$_listeners[type] && $ae5f928ed8e7c926$var$_listeners[type].map(function(f) {
        return f();
    }) || $ae5f928ed8e7c926$var$_emptyArray;
}, $ae5f928ed8e7c926$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$ae5f928ed8e7c926$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $ae5f928ed8e7c926$var$_savedStyles.length; i += 5)if (!media || $ae5f928ed8e7c926$var$_savedStyles[i + 4] && $ae5f928ed8e7c926$var$_savedStyles[i + 4].query === media) {
        $ae5f928ed8e7c926$var$_savedStyles[i].style.cssText = $ae5f928ed8e7c926$var$_savedStyles[i + 1];
        $ae5f928ed8e7c926$var$_savedStyles[i].getBBox && $ae5f928ed8e7c926$var$_savedStyles[i].setAttribute("transform", $ae5f928ed8e7c926$var$_savedStyles[i + 2] || "");
        $ae5f928ed8e7c926$var$_savedStyles[i + 3].uncache = 1;
    }
}, $ae5f928ed8e7c926$var$_recordScrollPositions = function _recordScrollPositions() {
    return (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).forEach(function(obj) {
        return $ae5f928ed8e7c926$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });
}, // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
$ae5f928ed8e7c926$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($ae5f928ed8e7c926$var$_i = 0; $ae5f928ed8e7c926$var$_i < $ae5f928ed8e7c926$var$_triggers.length; $ae5f928ed8e7c926$var$_i++){
        trigger = $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $ae5f928ed8e7c926$var$_isReverted = true;
    media && $ae5f928ed8e7c926$var$_revertRecorded(media);
    media || $ae5f928ed8e7c926$var$_dispatch("revert");
}, $ae5f928ed8e7c926$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++;
    (force || !$ae5f928ed8e7c926$var$_refreshingAll) && (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).forEach(function(obj) {
        return $ae5f928ed8e7c926$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $ae5f928ed8e7c926$var$_isString(scrollRestoration) && ($ae5f928ed8e7c926$var$_win.history.scrollRestoration = $ae5f928ed8e7c926$var$_scrollRestoration = scrollRestoration);
}, $ae5f928ed8e7c926$var$_refreshingAll, $ae5f928ed8e7c926$var$_refreshID = 0, $ae5f928ed8e7c926$var$_queueRefreshID, $ae5f928ed8e7c926$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($ae5f928ed8e7c926$var$_queueRefreshID !== $ae5f928ed8e7c926$var$_refreshID) {
        var id = $ae5f928ed8e7c926$var$_queueRefreshID = $ae5f928ed8e7c926$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $ae5f928ed8e7c926$var$_refreshID && $ae5f928ed8e7c926$var$_refreshAll(true);
        });
    }
}, $ae5f928ed8e7c926$var$_refresh100vh = function _refresh100vh() {
    $ae5f928ed8e7c926$var$_body.appendChild($ae5f928ed8e7c926$var$_div100vh);
    $ae5f928ed8e7c926$var$_100vh = !$ae5f928ed8e7c926$var$_normalizer && $ae5f928ed8e7c926$var$_div100vh.offsetHeight || $ae5f928ed8e7c926$var$_win.innerHeight;
    $ae5f928ed8e7c926$var$_body.removeChild($ae5f928ed8e7c926$var$_div100vh);
}, $ae5f928ed8e7c926$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $ae5f928ed8e7c926$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $ae5f928ed8e7c926$var$_refreshAll = function _refreshAll(force, skipRevert) {
    $ae5f928ed8e7c926$var$_docEl = $ae5f928ed8e7c926$var$_doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    $ae5f928ed8e7c926$var$_body = $ae5f928ed8e7c926$var$_doc.body;
    $ae5f928ed8e7c926$var$_root = [
        $ae5f928ed8e7c926$var$_win,
        $ae5f928ed8e7c926$var$_doc,
        $ae5f928ed8e7c926$var$_docEl,
        $ae5f928ed8e7c926$var$_body
    ];
    if ($ae5f928ed8e7c926$var$_lastScrollTime && !force && !$ae5f928ed8e7c926$var$_isReverted) {
        $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$export$875bcbe48555930, "scrollEnd", $ae5f928ed8e7c926$var$_softRefresh);
        return;
    }
    $ae5f928ed8e7c926$var$_refresh100vh();
    $ae5f928ed8e7c926$var$_refreshingAll = $ae5f928ed8e7c926$export$875bcbe48555930.isRefreshing = true;
    $ae5f928ed8e7c926$var$_isReverted || $ae5f928ed8e7c926$var$_recordScrollPositions();
    var refreshInits = $ae5f928ed8e7c926$var$_dispatch("refreshInit");
    $ae5f928ed8e7c926$var$_sort && $ae5f928ed8e7c926$export$875bcbe48555930.sort();
    skipRevert || $ae5f928ed8e7c926$var$_revertAll();
    (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($ae5f928ed8e7c926$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $ae5f928ed8e7c926$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $ae5f928ed8e7c926$var$_isReverted = false;
    $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $ae5f928ed8e7c926$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $ae5f928ed8e7c926$var$_hideAllMarkers(true);
    $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $ae5f928ed8e7c926$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $ae5f928ed8e7c926$var$_hideAllMarkers(false);
    $ae5f928ed8e7c926$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($ae5f928ed8e7c926$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $ae5f928ed8e7c926$var$_clearScrollMemory($ae5f928ed8e7c926$var$_scrollRestoration, 1);
    $ae5f928ed8e7c926$var$_resizeDelay.pause();
    $ae5f928ed8e7c926$var$_refreshID++;
    $ae5f928ed8e7c926$var$_refreshingAll = 2;
    $ae5f928ed8e7c926$var$_updateAll(2);
    $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
        return $ae5f928ed8e7c926$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $ae5f928ed8e7c926$var$_refreshingAll = $ae5f928ed8e7c926$export$875bcbe48555930.isRefreshing = false;
    $ae5f928ed8e7c926$var$_dispatch("refresh");
}, $ae5f928ed8e7c926$var$_lastScroll = 0, $ae5f928ed8e7c926$var$_direction = 1, $ae5f928ed8e7c926$var$_primary, $ae5f928ed8e7c926$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$ae5f928ed8e7c926$var$_refreshingAll && !$ae5f928ed8e7c926$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $ae5f928ed8e7c926$export$875bcbe48555930.isUpdating = true;
        $ae5f928ed8e7c926$var$_primary && $ae5f928ed8e7c926$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $ae5f928ed8e7c926$var$_triggers.length, time = $ae5f928ed8e7c926$var$_getTime(), recordVelocity = time - $ae5f928ed8e7c926$var$_time1 >= 50, scroll = l && $ae5f928ed8e7c926$var$_triggers[0].scroll();
        $ae5f928ed8e7c926$var$_direction = $ae5f928ed8e7c926$var$_lastScroll > scroll ? -1 : 1;
        $ae5f928ed8e7c926$var$_refreshingAll || ($ae5f928ed8e7c926$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($ae5f928ed8e7c926$var$_lastScrollTime && !$ae5f928ed8e7c926$var$_pointerIsDown && time - $ae5f928ed8e7c926$var$_lastScrollTime > 200) {
                $ae5f928ed8e7c926$var$_lastScrollTime = 0;
                $ae5f928ed8e7c926$var$_dispatch("scrollEnd");
            }
            $ae5f928ed8e7c926$var$_time2 = $ae5f928ed8e7c926$var$_time1;
            $ae5f928ed8e7c926$var$_time1 = time;
        }
        if ($ae5f928ed8e7c926$var$_direction < 0) {
            $ae5f928ed8e7c926$var$_i = l;
            while($ae5f928ed8e7c926$var$_i-- > 0)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i] && $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].update(0, recordVelocity);
            $ae5f928ed8e7c926$var$_direction = 1;
        } else for($ae5f928ed8e7c926$var$_i = 0; $ae5f928ed8e7c926$var$_i < l; $ae5f928ed8e7c926$var$_i++)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i] && $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].update(0, recordVelocity);
        $ae5f928ed8e7c926$export$875bcbe48555930.isUpdating = false;
    }
    $ae5f928ed8e7c926$var$_rafID = 0;
}, $ae5f928ed8e7c926$var$_propNamesToCopy = [
    $ae5f928ed8e7c926$var$_left,
    $ae5f928ed8e7c926$var$_top,
    $ae5f928ed8e7c926$var$_bottom,
    $ae5f928ed8e7c926$var$_right,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Bottom,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Right,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Top,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $ae5f928ed8e7c926$var$_stateProps = $ae5f928ed8e7c926$var$_propNamesToCopy.concat([
    $ae5f928ed8e7c926$var$_width,
    $ae5f928ed8e7c926$var$_height,
    "boxSizing",
    "max" + $ae5f928ed8e7c926$var$_Width,
    "max" + $ae5f928ed8e7c926$var$_Height,
    "position",
    $ae5f928ed8e7c926$var$_margin,
    $ae5f928ed8e7c926$var$_padding,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left
]), $ae5f928ed8e7c926$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $ae5f928ed8e7c926$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $ae5f928ed8e7c926$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $ae5f928ed8e7c926$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $ae5f928ed8e7c926$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $ae5f928ed8e7c926$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$ae5f928ed8e7c926$var$_bottom] = pinStyle[$ae5f928ed8e7c926$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$ae5f928ed8e7c926$var$_width] = $ae5f928ed8e7c926$var$_getSize(pin, (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1)) + $ae5f928ed8e7c926$var$_px;
        spacerStyle[$ae5f928ed8e7c926$var$_height] = $ae5f928ed8e7c926$var$_getSize(pin, (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d)) + $ae5f928ed8e7c926$var$_px;
        spacerStyle[$ae5f928ed8e7c926$var$_padding] = pinStyle[$ae5f928ed8e7c926$var$_margin] = pinStyle[$ae5f928ed8e7c926$var$_top] = pinStyle[$ae5f928ed8e7c926$var$_left] = "0";
        $ae5f928ed8e7c926$var$_setState(spacerState);
        pinStyle[$ae5f928ed8e7c926$var$_width] = pinStyle["max" + $ae5f928ed8e7c926$var$_Width] = cs[$ae5f928ed8e7c926$var$_width];
        pinStyle[$ae5f928ed8e7c926$var$_height] = pinStyle["max" + $ae5f928ed8e7c926$var$_Height] = cs[$ae5f928ed8e7c926$var$_height];
        pinStyle[$ae5f928ed8e7c926$var$_padding] = cs[$ae5f928ed8e7c926$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $ae5f928ed8e7c926$var$_capsExp = /([A-Z])/g, $ae5f928ed8e7c926$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $ae5f928ed8e7c926$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($ae5f928ed8e7c926$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $ae5f928ed8e7c926$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $ae5f928ed8e7c926$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($ae5f928ed8e7c926$var$_stateProps[i], style[$ae5f928ed8e7c926$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $ae5f928ed8e7c926$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $ae5f928ed8e7c926$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$ae5f928ed8e7c926$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $ae5f928ed8e7c926$var$_isFunction(value) && (value = value(self));
    if ($ae5f928ed8e7c926$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $ae5f928ed8e7c926$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$ae5f928ed8e7c926$var$_isNumber(value)) {
        $ae5f928ed8e7c926$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(trigger, self) || $ae5f928ed8e7c926$var$_body;
        bounds = $ae5f928ed8e7c926$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $ae5f928ed8e7c926$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $ae5f928ed8e7c926$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $ae5f928ed8e7c926$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $ae5f928ed8e7c926$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $ae5f928ed8e7c926$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $ae5f928ed8e7c926$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $ae5f928ed8e7c926$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $ae5f928ed8e7c926$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($ae5f928ed8e7c926$var$_body[p1], $ae5f928ed8e7c926$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $ae5f928ed8e7c926$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $ae5f928ed8e7c926$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $ae5f928ed8e7c926$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $ae5f928ed8e7c926$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $ae5f928ed8e7c926$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $ae5f928ed8e7c926$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $ae5f928ed8e7c926$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $ae5f928ed8e7c926$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$ae5f928ed8e7c926$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $ae5f928ed8e7c926$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $ae5f928ed8e7c926$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, $ae5f928ed8e7c926$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $ae5f928ed8e7c926$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$ae5f928ed8e7c926$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $cfd1378c1e8f6244$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $ae5f928ed8e7c926$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++;
            getTween.tween && $ae5f928ed8e7c926$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $ae5f928ed8e7c926$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $ae5f928ed8e7c926$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $ae5f928ed8e7c926$export$875bcbe48555930.isTouch && $ae5f928ed8e7c926$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $ae5f928ed8e7c926$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $ae5f928ed8e7c926$var$_coreInitted || ScrollTrigger.register($ae5f928ed8e7c926$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $ae5f928ed8e7c926$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$ae5f928ed8e7c926$var$_enabled) {
            this.update = this.refresh = this.kill = $ae5f928ed8e7c926$var$_passThrough;
            return;
        }
        vars = $ae5f928ed8e7c926$var$_setDefaults($ae5f928ed8e7c926$var$_isString(vars) || $ae5f928ed8e7c926$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $ae5f928ed8e7c926$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1) : (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(vars.scroller || $ae5f928ed8e7c926$var$_win), scrollerCache = $ae5f928ed8e7c926$var$gsap.core.getCache(scroller), isViewport = $ae5f928ed8e7c926$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $ae5f928ed8e7c926$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($ae5f928ed8e7c926$var$_getComputedStyle(scroller)["border" + direction.p2 + $ae5f928ed8e7c926$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $ae5f928ed8e7c926$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $ae5f928ed8e7c926$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $cfd1378c1e8f6244$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $ae5f928ed8e7c926$var$_sort = 1;
            vars.refreshPriority === -9999 && ($ae5f928ed8e7c926$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $ae5f928ed8e7c926$var$_getTweenCreator(scroller, (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d)),
            left: $ae5f928ed8e7c926$var$_getTweenCreator(scroller, (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $ae5f928ed8e7c926$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $ae5f928ed8e7c926$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$ae5f928ed8e7c926$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $ae5f928ed8e7c926$var$_body.style && $ae5f928ed8e7c926$var$gsap.set(isViewport ? [
                $ae5f928ed8e7c926$var$_body,
                $ae5f928ed8e7c926$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).forEach(function(o) {
                return $ae5f928ed8e7c926$var$_isFunction(o) && o.target === (isViewport ? $ae5f928ed8e7c926$var$_doc.scrollingElement || $ae5f928ed8e7c926$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $ae5f928ed8e7c926$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $ae5f928ed8e7c926$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $ae5f928ed8e7c926$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $ae5f928ed8e7c926$var$_snapDirectional(snap.snapTo)(value, $ae5f928ed8e7c926$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $ae5f928ed8e7c926$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $ae5f928ed8e7c926$var$_isObject(snapDurClamp) ? $ae5f928ed8e7c926$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $ae5f928ed8e7c926$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $ae5f928ed8e7c926$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $ae5f928ed8e7c926$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$ae5f928ed8e7c926$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * 1000 || 0, change1 = $ae5f928ed8e7c926$var$gsap.utils.clamp(-progress, 1 - progress, $ae5f928ed8e7c926$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $ae5f928ed8e7c926$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $ae5f928ed8e7c926$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($ae5f928ed8e7c926$var$_abs(Math.max($ae5f928ed8e7c926$var$_abs(naturalEnd - totalProgress), $ae5f928ed8e7c926$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $ae5f928ed8e7c926$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && $ae5f928ed8e7c926$var$_callback(self, _onInterrupt);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && $ae5f928ed8e7c926$var$_callback(self, _onComplete);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && $ae5f928ed8e7c926$var$_callback(self, onStart, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($ae5f928ed8e7c926$var$_ids[id] = self);
        trigger = self.trigger = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $cfd1378c1e8f6244$export$937374fea3f88711)(pin);
        $ae5f928ed8e7c926$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $ae5f928ed8e7c926$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $ae5f928ed8e7c926$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $ae5f928ed8e7c926$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $ae5f928ed8e7c926$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $ae5f928ed8e7c926$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $ae5f928ed8e7c926$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $ae5f928ed8e7c926$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $ae5f928ed8e7c926$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $ae5f928ed8e7c926$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $ae5f928ed8e7c926$var$gsap.getProperty(pin);
            pinSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(pin, direction.a, $ae5f928ed8e7c926$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, cs);
            pinState = $ae5f928ed8e7c926$var$_getState(pin);
        }
        if (markers) {
            markerVars = $ae5f928ed8e7c926$var$_isObject(markers) ? $ae5f928ed8e7c926$var$_setDefaults(markers, $ae5f928ed8e7c926$var$_markerDefaults) : $ae5f928ed8e7c926$var$_markerDefaults;
            markerStartTrigger = $ae5f928ed8e7c926$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $ae5f928ed8e7c926$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $cfd1378c1e8f6244$export$937374fea3f88711)((0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $ae5f928ed8e7c926$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $ae5f928ed8e7c926$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $ae5f928ed8e7c926$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $ae5f928ed8e7c926$var$_px));
            if (!useFixedPosition && !((0, $cfd1378c1e8f6244$export$d8e56d510a804d0a).length && (0, $cfd1378c1e8f6244$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $ae5f928ed8e7c926$var$_makePositionable(isViewport ? $ae5f928ed8e7c926$var$_body : scroller);
                $ae5f928ed8e7c926$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(markerStartTrigger, direction.a, $ae5f928ed8e7c926$var$_px);
                markerEndSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(markerEndTrigger, direction.a, $ae5f928ed8e7c926$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $ae5f928ed8e7c926$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $ae5f928ed8e7c926$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $ae5f928ed8e7c926$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, $ae5f928ed8e7c926$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $ae5f928ed8e7c926$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($ae5f928ed8e7c926$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $ae5f928ed8e7c926$var$_lastScrollTime) {
                $ae5f928ed8e7c926$var$_addListener(ScrollTrigger, "scrollEnd", $ae5f928ed8e7c926$var$_softRefresh);
                return;
            }
            !$ae5f928ed8e7c926$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $ae5f928ed8e7c926$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            if (invalidateOnRefresh && animation) {
                animation.revert({
                    kill: false
                }).invalidate();
                animation.getChildren ? animation.getChildren(true, true, false).forEach(function(t) {
                    return t.vars.immediateRender && t.render(0, true, true);
                }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
            }
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $ae5f928ed8e7c926$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $ae5f928ed8e7c926$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $ae5f928ed8e7c926$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $cfd1378c1e8f6244$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $ae5f928ed8e7c926$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $ae5f928ed8e7c926$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $ae5f928ed8e7c926$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $ae5f928ed8e7c926$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $ae5f928ed8e7c926$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($ae5f928ed8e7c926$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $ae5f928ed8e7c926$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $ae5f928ed8e7c926$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $ae5f928ed8e7c926$var$_parseClamp(parsedStart, "start", self);
            start = $ae5f928ed8e7c926$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $ae5f928ed8e7c926$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($ae5f928ed8e7c926$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($ae5f928ed8e7c926$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $ae5f928ed8e7c926$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $ae5f928ed8e7c926$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $ae5f928ed8e7c926$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $ae5f928ed8e7c926$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $ae5f928ed8e7c926$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $ae5f928ed8e7c926$var$_triggers[i] || {};
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$ae5f928ed8e7c926$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $ae5f928ed8e7c926$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $ae5f928ed8e7c926$var$gsap.utils.clamp(0, 1, $ae5f928ed8e7c926$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $ae5f928ed8e7c926$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($ae5f928ed8e7c926$var$_clampingMax && self.end >= $ae5f928ed8e7c926$var$_maxScroll(scroller, direction))) {
                cs = $ae5f928ed8e7c926$var$_getComputedStyle(pin);
                isVertical = direction === (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $ae5f928ed8e7c926$var$_doc.scrollingElement || $ae5f928ed8e7c926$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $ae5f928ed8e7c926$var$_getComputedStyle($ae5f928ed8e7c926$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, cs);
                pinState = $ae5f928ed8e7c926$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $ae5f928ed8e7c926$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $cfd1378c1e8f6244$export$8665aac53dad5647)(scroller, isVertical ? (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1) : (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $ae5f928ed8e7c926$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $ae5f928ed8e7c926$var$_padding ? $ae5f928ed8e7c926$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $ae5f928ed8e7c926$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $ae5f928ed8e7c926$var$_px);
                    }
                    $ae5f928ed8e7c926$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $ae5f928ed8e7c926$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $ae5f928ed8e7c926$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $ae5f928ed8e7c926$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $ae5f928ed8e7c926$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$ae5f928ed8e7c926$var$_width] = override["max" + $ae5f928ed8e7c926$var$_Width] = Math.ceil(bounds.width) + $ae5f928ed8e7c926$var$_px;
                    override[$ae5f928ed8e7c926$var$_height] = override["max" + $ae5f928ed8e7c926$var$_Height] = Math.ceil(bounds.height) + $ae5f928ed8e7c926$var$_px;
                    override[$ae5f928ed8e7c926$var$_margin] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Top] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Right] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Bottom] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Left] = "0";
                    override[$ae5f928ed8e7c926$var$_padding] = cs[$ae5f928ed8e7c926$var$_padding];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left];
                    pinActiveState = $ae5f928ed8e7c926$var$_copyState(pinOriginalState, override, pinReparent);
                    $ae5f928ed8e7c926$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $ae5f928ed8e7c926$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $ae5f928ed8e7c926$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $ae5f928ed8e7c926$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $ae5f928ed8e7c926$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$ae5f928ed8e7c926$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $ae5f928ed8e7c926$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $ae5f928ed8e7c926$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $ae5f928ed8e7c926$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $ae5f928ed8e7c926$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $ae5f928ed8e7c926$var$gsap.getProperty(markerEndTrigger, direction.p);
                $ae5f928ed8e7c926$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $ae5f928ed8e7c926$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $ae5f928ed8e7c926$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $ae5f928ed8e7c926$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$ae5f928ed8e7c926$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$ae5f928ed8e7c926$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $ae5f928ed8e7c926$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $ae5f928ed8e7c926$var$_endAnimation(animation, animation.reversed()) : isToggle || $ae5f928ed8e7c926$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $ae5f928ed8e7c926$var$_triggers.indexOf(self), a = self.direction > 0 ? $ae5f928ed8e7c926$var$_triggers.slice(0, i).reverse() : $ae5f928ed8e7c926$var$_triggers.slice(i + 1);
            return ($ae5f928ed8e7c926$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $ae5f928ed8e7c926$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup && $ae5f928ed8e7c926$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$ae5f928ed8e7c926$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($ae5f928ed8e7c926$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($ae5f928ed8e7c926$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($ae5f928ed8e7c926$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $ae5f928ed8e7c926$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $ae5f928ed8e7c926$var$_getBounds(pin, true), _offset = scroll - start;
                                $ae5f928ed8e7c926$var$_reparent(pin, $ae5f928ed8e7c926$var$_body, bounds.top + (direction === (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d) ? _offset : 0) + $ae5f928ed8e7c926$var$_px, bounds.left + (direction === (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d) ? 0 : _offset) + $ae5f928ed8e7c926$var$_px);
                            } else $ae5f928ed8e7c926$var$_reparent(pin, spacer);
                        }
                        $ae5f928ed8e7c926$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$ae5f928ed8e7c926$var$_limitCallbacks)) && $ae5f928ed8e7c926$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$ae5f928ed8e7c926$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$ae5f928ed8e7c926$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $ae5f928ed8e7c926$var$_callback(self, onToggle);
                        callbacks[toggleState] && $ae5f928ed8e7c926$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $ae5f928ed8e7c926$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($ae5f928ed8e7c926$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $ae5f928ed8e7c926$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $ae5f928ed8e7c926$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$ae5f928ed8e7c926$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $ae5f928ed8e7c926$var$_addListener(scroller, "resize", $ae5f928ed8e7c926$var$_onResize);
                isViewport || $ae5f928ed8e7c926$var$_addListener(scroller, "scroll", $ae5f928ed8e7c926$var$_onScroll);
                onRefreshInit && $ae5f928ed8e7c926$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $ae5f928ed8e7c926$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $ae5f928ed8e7c926$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $ae5f928ed8e7c926$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $ae5f928ed8e7c926$var$_px;
                $ae5f928ed8e7c926$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            reset !== false && self.revert(true, true);
            if (self.enabled) {
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $ae5f928ed8e7c926$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $ae5f928ed8e7c926$var$_triggers.length;
                    while(i--){
                        if ($ae5f928ed8e7c926$var$_triggers[i].scroller === scroller && $ae5f928ed8e7c926$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $ae5f928ed8e7c926$var$_removeListener(scroller, "resize", $ae5f928ed8e7c926$var$_onResize);
                    isViewport || $ae5f928ed8e7c926$var$_removeListener(scroller, "scroll", $ae5f928ed8e7c926$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $ae5f928ed8e7c926$var$_ids[id];
            var i = $ae5f928ed8e7c926$var$_triggers.indexOf(self);
            i >= 0 && $ae5f928ed8e7c926$var$_triggers.splice(i, 1);
            i === $ae5f928ed8e7c926$var$_i && $ae5f928ed8e7c926$var$_direction > 0 && $ae5f928ed8e7c926$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $ae5f928ed8e7c926$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $ae5f928ed8e7c926$var$_primary === self && ($ae5f928ed8e7c926$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $ae5f928ed8e7c926$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            $ae5f928ed8e7c926$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $ae5f928ed8e7c926$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$ae5f928ed8e7c926$var$_coreInitted) {
            $ae5f928ed8e7c926$var$gsap = core || $ae5f928ed8e7c926$var$_getGSAP();
            $ae5f928ed8e7c926$var$_windowExists() && window.document && ScrollTrigger.enable();
            $ae5f928ed8e7c926$var$_coreInitted = $ae5f928ed8e7c926$var$_enabled;
        }
        return $ae5f928ed8e7c926$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$ae5f928ed8e7c926$var$_defaults[p] = config[p];
        return $ae5f928ed8e7c926$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $ae5f928ed8e7c926$var$_enabled = 0;
        $ae5f928ed8e7c926$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_win, "wheel", $ae5f928ed8e7c926$var$_onScroll);
        $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_doc, "scroll", $ae5f928ed8e7c926$var$_onScroll);
        clearInterval($ae5f928ed8e7c926$var$_syncInterval);
        $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_doc, "touchcancel", $ae5f928ed8e7c926$var$_passThrough);
        $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_body, "touchstart", $ae5f928ed8e7c926$var$_passThrough);
        $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_removeListener, $ae5f928ed8e7c926$var$_doc, "pointerdown,touchstart,mousedown", $ae5f928ed8e7c926$var$_pointerDownHandler);
        $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_removeListener, $ae5f928ed8e7c926$var$_doc, "pointerup,touchend,mouseup", $ae5f928ed8e7c926$var$_pointerUpHandler);
        $ae5f928ed8e7c926$var$_resizeDelay.kill();
        $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_removeListener);
        for(var i = 0; i < (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).length; i += 3){
            $ae5f928ed8e7c926$var$_wheelListener($ae5f928ed8e7c926$var$_removeListener, (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i], (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i + 1]);
            $ae5f928ed8e7c926$var$_wheelListener($ae5f928ed8e7c926$var$_removeListener, (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i], (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $ae5f928ed8e7c926$var$_win = window;
        $ae5f928ed8e7c926$var$_doc = document;
        $ae5f928ed8e7c926$var$_docEl = $ae5f928ed8e7c926$var$_doc.documentElement;
        $ae5f928ed8e7c926$var$_body = $ae5f928ed8e7c926$var$_doc.body;
        if ($ae5f928ed8e7c926$var$gsap) {
            $ae5f928ed8e7c926$var$_toArray = $ae5f928ed8e7c926$var$gsap.utils.toArray;
            $ae5f928ed8e7c926$var$_clamp = $ae5f928ed8e7c926$var$gsap.utils.clamp;
            $ae5f928ed8e7c926$var$_context = $ae5f928ed8e7c926$var$gsap.core.context || $ae5f928ed8e7c926$var$_passThrough;
            $ae5f928ed8e7c926$var$_suppressOverwrites = $ae5f928ed8e7c926$var$gsap.core.suppressOverwrites || $ae5f928ed8e7c926$var$_passThrough;
            $ae5f928ed8e7c926$var$_scrollRestoration = $ae5f928ed8e7c926$var$_win.history.scrollRestoration || "auto";
            $ae5f928ed8e7c926$var$_lastScroll = $ae5f928ed8e7c926$var$_win.pageYOffset || 0;
            $ae5f928ed8e7c926$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($ae5f928ed8e7c926$var$_body) {
                $ae5f928ed8e7c926$var$_enabled = 1;
                $ae5f928ed8e7c926$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $ae5f928ed8e7c926$var$_div100vh.style.height = "100vh";
                $ae5f928ed8e7c926$var$_div100vh.style.position = "absolute";
                $ae5f928ed8e7c926$var$_refresh100vh();
                $ae5f928ed8e7c926$var$_rafBugFix();
                (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).register($ae5f928ed8e7c926$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).isTouch;
                $ae5f928ed8e7c926$var$_fixIOSBug = (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $ae5f928ed8e7c926$var$_ignoreMobileResize = (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).isTouch === 1;
                $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_win, "wheel", $ae5f928ed8e7c926$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $ae5f928ed8e7c926$var$_root = [
                    $ae5f928ed8e7c926$var$_win,
                    $ae5f928ed8e7c926$var$_doc,
                    $ae5f928ed8e7c926$var$_docEl,
                    $ae5f928ed8e7c926$var$_body
                ];
                if ($ae5f928ed8e7c926$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $ae5f928ed8e7c926$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $ae5f928ed8e7c926$var$gsap.addEventListener("matchMediaInit", function() {
                        $ae5f928ed8e7c926$var$_recordScrollPositions();
                        $ae5f928ed8e7c926$var$_revertAll();
                    });
                    $ae5f928ed8e7c926$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $ae5f928ed8e7c926$var$_revertRecorded();
                    });
                    $ae5f928ed8e7c926$var$gsap.addEventListener("matchMedia", function() {
                        $ae5f928ed8e7c926$var$_refreshAll(0, 1);
                        $ae5f928ed8e7c926$var$_dispatch("matchMedia");
                    });
                    $ae5f928ed8e7c926$var$gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $ae5f928ed8e7c926$var$_setBaseDimensions();
                        return $ae5f928ed8e7c926$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $ae5f928ed8e7c926$var$_setBaseDimensions();
                $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_doc, "scroll", $ae5f928ed8e7c926$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = $ae5f928ed8e7c926$var$_body.hasAttribute("style"), bodyStyle = $ae5f928ed8e7c926$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $ae5f928ed8e7c926$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $ae5f928ed8e7c926$var$_getBounds($ae5f928ed8e7c926$var$_body);
                (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    $ae5f928ed8e7c926$var$_body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    $ae5f928ed8e7c926$var$_body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $ae5f928ed8e7c926$var$_syncInterval = setInterval($ae5f928ed8e7c926$var$_sync, 250);
                $ae5f928ed8e7c926$var$gsap.delayedCall(0.5, function() {
                    return $ae5f928ed8e7c926$var$_startup = 0;
                });
                $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_doc, "touchcancel", $ae5f928ed8e7c926$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_body, "touchstart", $ae5f928ed8e7c926$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_addListener, $ae5f928ed8e7c926$var$_doc, "pointerdown,touchstart,mousedown", $ae5f928ed8e7c926$var$_pointerDownHandler);
                $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_addListener, $ae5f928ed8e7c926$var$_doc, "pointerup,touchend,mouseup", $ae5f928ed8e7c926$var$_pointerUpHandler);
                $ae5f928ed8e7c926$var$_transformProp = $ae5f928ed8e7c926$var$gsap.utils.checkPrefix("transform");
                $ae5f928ed8e7c926$var$_stateProps.push($ae5f928ed8e7c926$var$_transformProp);
                $ae5f928ed8e7c926$var$_coreInitted = $ae5f928ed8e7c926$var$_getTime();
                $ae5f928ed8e7c926$var$_resizeDelay = $ae5f928ed8e7c926$var$gsap.delayedCall(0.2, $ae5f928ed8e7c926$var$_refreshAll).pause();
                $ae5f928ed8e7c926$var$_autoRefresh = [
                    $ae5f928ed8e7c926$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $ae5f928ed8e7c926$var$_win.innerWidth, h = $ae5f928ed8e7c926$var$_win.innerHeight;
                        if ($ae5f928ed8e7c926$var$_doc.hidden) {
                            $ae5f928ed8e7c926$var$_prevWidth = w;
                            $ae5f928ed8e7c926$var$_prevHeight = h;
                        } else if ($ae5f928ed8e7c926$var$_prevWidth !== w || $ae5f928ed8e7c926$var$_prevHeight !== h) $ae5f928ed8e7c926$var$_onResize();
                    },
                    $ae5f928ed8e7c926$var$_doc,
                    "DOMContentLoaded",
                    $ae5f928ed8e7c926$var$_refreshAll,
                    $ae5f928ed8e7c926$var$_win,
                    "load",
                    $ae5f928ed8e7c926$var$_refreshAll,
                    $ae5f928ed8e7c926$var$_win,
                    "resize",
                    $ae5f928ed8e7c926$var$_onResize
                ];
                $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_addListener);
                $ae5f928ed8e7c926$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).length; i += 3){
                    $ae5f928ed8e7c926$var$_wheelListener($ae5f928ed8e7c926$var$_removeListener, (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i], (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i + 1]);
                    $ae5f928ed8e7c926$var$_wheelListener($ae5f928ed8e7c926$var$_removeListener, (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i], (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683)[i + 2]);
                }
            } else if ($ae5f928ed8e7c926$var$_doc) {
                var onLoad = function onLoad() {
                    ScrollTrigger.enable();
                    $ae5f928ed8e7c926$var$_doc.removeEventListener("DOMContentLoaded", onLoad);
                };
                $ae5f928ed8e7c926$var$_doc.addEventListener("DOMContentLoaded", onLoad);
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($ae5f928ed8e7c926$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($ae5f928ed8e7c926$var$_syncInterval) || ($ae5f928ed8e7c926$var$_syncInterval = ms) && setInterval($ae5f928ed8e7c926$var$_sync, ms);
        "ignoreMobileResize" in vars && ($ae5f928ed8e7c926$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_removeListener) || $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_addListener, vars.autoRefreshEvents || "none");
            $ae5f928ed8e7c926$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(target), i = (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).indexOf(t), isViewport = $ae5f928ed8e7c926$var$_isViewport(t);
        if (~i) (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $cfd1378c1e8f6244$export$d8e56d510a804d0a).unshift($ae5f928ed8e7c926$var$_win, vars, $ae5f928ed8e7c926$var$_body, vars, $ae5f928ed8e7c926$var$_docEl, vars) : (0, $cfd1378c1e8f6244$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($ae5f928ed8e7c926$var$_isString(element) ? (0, $cfd1378c1e8f6244$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $ae5f928ed8e7c926$var$_width : $ae5f928ed8e7c926$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $ae5f928ed8e7c926$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $ae5f928ed8e7c926$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $ae5f928ed8e7c926$var$_isString(element) && (element = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $ae5f928ed8e7c926$var$_width : $ae5f928ed8e7c926$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $ae5f928ed8e7c926$var$_keywords ? $ae5f928ed8e7c926$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $ae5f928ed8e7c926$var$_win.innerWidth : (bounds.top + offset) / $ae5f928ed8e7c926$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $ae5f928ed8e7c926$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $ae5f928ed8e7c926$var$_listeners.killAll || [];
            $ae5f928ed8e7c926$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$ae5f928ed8e7c926$export$875bcbe48555930.version = "3.15.0";
$ae5f928ed8e7c926$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $ae5f928ed8e7c926$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $ae5f928ed8e7c926$var$_savedStyles.indexOf(target);
            i >= 0 && $ae5f928ed8e7c926$var$_savedStyles.splice(i, 5);
            $ae5f928ed8e7c926$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $ae5f928ed8e7c926$var$gsap.core.getCache(target), $ae5f928ed8e7c926$var$_context());
        }
    }) : $ae5f928ed8e7c926$var$_savedStyles;
};
$ae5f928ed8e7c926$export$875bcbe48555930.revert = function(soft, media) {
    return $ae5f928ed8e7c926$var$_revertAll(!soft, media);
};
$ae5f928ed8e7c926$export$875bcbe48555930.create = function(vars, animation) {
    return new $ae5f928ed8e7c926$export$875bcbe48555930(vars, animation);
};
$ae5f928ed8e7c926$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $ae5f928ed8e7c926$var$_onResize(true) : ($ae5f928ed8e7c926$var$_coreInitted || $ae5f928ed8e7c926$export$875bcbe48555930.register()) && $ae5f928ed8e7c926$var$_refreshAll(true);
};
$ae5f928ed8e7c926$export$875bcbe48555930.update = function(force) {
    return ++(0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache && $ae5f928ed8e7c926$var$_updateAll(force === true ? 2 : 0);
};
$ae5f928ed8e7c926$export$875bcbe48555930.clearScrollMemory = $ae5f928ed8e7c926$var$_clearScrollMemory;
$ae5f928ed8e7c926$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $ae5f928ed8e7c926$var$_maxScroll(element, horizontal ? (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1) : (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d));
};
$ae5f928ed8e7c926$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $cfd1378c1e8f6244$export$8665aac53dad5647)((0, $cfd1378c1e8f6244$export$937374fea3f88711)(element), horizontal ? (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1) : (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d));
};
$ae5f928ed8e7c926$export$875bcbe48555930.getById = function(id) {
    return $ae5f928ed8e7c926$var$_ids[id];
};
$ae5f928ed8e7c926$export$875bcbe48555930.getAll = function() {
    return $ae5f928ed8e7c926$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$ae5f928ed8e7c926$export$875bcbe48555930.isScrolling = function() {
    return !!$ae5f928ed8e7c926$var$_lastScrollTime;
};
$ae5f928ed8e7c926$export$875bcbe48555930.snapDirectional = $ae5f928ed8e7c926$var$_snapDirectional;
$ae5f928ed8e7c926$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $ae5f928ed8e7c926$var$_listeners[type] || ($ae5f928ed8e7c926$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$ae5f928ed8e7c926$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $ae5f928ed8e7c926$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$ae5f928ed8e7c926$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $ae5f928ed8e7c926$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $ae5f928ed8e7c926$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($ae5f928ed8e7c926$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $ae5f928ed8e7c926$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($ae5f928ed8e7c926$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $ae5f928ed8e7c926$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $ae5f928ed8e7c926$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $ae5f928ed8e7c926$var$_docEl && _allowNativePanning($ae5f928ed8e7c926$var$_body, direction);
}, $ae5f928ed8e7c926$var$_overflow = {
    auto: 1,
    scroll: 1
}, $ae5f928ed8e7c926$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $ae5f928ed8e7c926$var$gsap.core.getCache(node), time = $ae5f928ed8e7c926$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $ae5f928ed8e7c926$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($ae5f928ed8e7c926$var$_overflow[(cs = $ae5f928ed8e7c926$var$_getComputedStyle(node)).overflowY] || $ae5f928ed8e7c926$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$ae5f928ed8e7c926$var$_isViewport(node) && ($ae5f928ed8e7c926$var$_overflow[(cs = $ae5f928ed8e7c926$var$_getComputedStyle(node)).overflowY] || $ae5f928ed8e7c926$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$ae5f928ed8e7c926$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $ae5f928ed8e7c926$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_doc, (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).eventTypes[0], $ae5f928ed8e7c926$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_doc, (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).eventTypes[0], $ae5f928ed8e7c926$var$_captureInputs, true);
        }
    });
}, $ae5f928ed8e7c926$var$_inputExp = /(input|label|select|textarea)/i, $ae5f928ed8e7c926$var$_inputIsFocused, $ae5f928ed8e7c926$var$_captureInputs = function _captureInputs(e) {
    var isInput = $ae5f928ed8e7c926$var$_inputExp.test(e.target.tagName);
    if (isInput || $ae5f928ed8e7c926$var$_inputIsFocused) {
        e._gsapAllow = true;
        $ae5f928ed8e7c926$var$_inputIsFocused = isInput;
    }
}, $ae5f928ed8e7c926$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $ae5f928ed8e7c926$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $cfd1378c1e8f6244$export$937374fea3f88711)(vars.target) || $ae5f928ed8e7c926$var$_docEl, smoother = $ae5f928ed8e7c926$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $ae5f928ed8e7c926$var$_fixIOSBug && (vars.content && (0, $cfd1378c1e8f6244$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $cfd1378c1e8f6244$export$8665aac53dad5647)(target, (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d)), scrollFuncX = (0, $cfd1378c1e8f6244$export$8665aac53dad5647)(target, (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b).isTouch && $ae5f928ed8e7c926$var$_win.visualViewport ? $ae5f928ed8e7c926$var$_win.visualViewport.scale * $ae5f928ed8e7c926$var$_win.visualViewport.width : $ae5f928ed8e7c926$var$_win.outerWidth) / $ae5f928ed8e7c926$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $ae5f928ed8e7c926$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $ae5f928ed8e7c926$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $ae5f928ed8e7c926$var$_passThrough, scrollClampY = $ae5f928ed8e7c926$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $ae5f928ed8e7c926$var$_maxScroll(target, (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d));
        scrollClampY = $ae5f928ed8e7c926$var$_clamp($ae5f928ed8e7c926$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $ae5f928ed8e7c926$var$_clamp(0, $ae5f928ed8e7c926$var$_maxScroll(target, (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1))));
        lastRefreshID = $ae5f928ed8e7c926$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $ae5f928ed8e7c926$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $ae5f928ed8e7c926$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $ae5f928ed8e7c926$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache;
                $ae5f928ed8e7c926$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $ae5f928ed8e7c926$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $ae5f928ed8e7c926$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $ae5f928ed8e7c926$var$_round(($ae5f928ed8e7c926$var$_win.visualViewport && $ae5f928ed8e7c926$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $ae5f928ed8e7c926$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $ae5f928ed8e7c926$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $ae5f928ed8e7c926$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $ae5f928ed8e7c926$var$_maxScroll(target, (0, $cfd1378c1e8f6244$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $ae5f928ed8e7c926$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $ae5f928ed8e7c926$var$_maxScroll(target, (0, $cfd1378c1e8f6244$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($ae5f928ed8e7c926$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $ae5f928ed8e7c926$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($ae5f928ed8e7c926$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $ae5f928ed8e7c926$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $ae5f928ed8e7c926$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $ae5f928ed8e7c926$var$_updateAll();
    };
    vars.onEnable = function() {
        $ae5f928ed8e7c926$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $ae5f928ed8e7c926$export$875bcbe48555930.addEventListener("refresh", onResize);
        $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $ae5f928ed8e7c926$var$_allowNativePanning(target, true);
        $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$var$_win, "resize", onResize);
        $ae5f928ed8e7c926$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $ae5f928ed8e7c926$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $ae5f928ed8e7c926$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $ae5f928ed8e7c926$var$_fixIOSBug && $ae5f928ed8e7c926$var$gsap.ticker.add($ae5f928ed8e7c926$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $ae5f928ed8e7c926$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $ae5f928ed8e7c926$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $ae5f928ed8e7c926$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$ae5f928ed8e7c926$export$875bcbe48555930.sort = function(func) {
    if ($ae5f928ed8e7c926$var$_isFunction(func)) return $ae5f928ed8e7c926$var$_triggers.sort(func);
    var scroll = $ae5f928ed8e7c926$var$_win.pageYOffset || 0;
    $ae5f928ed8e7c926$export$875bcbe48555930.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + $ae5f928ed8e7c926$var$_win.innerHeight;
    });
    return $ae5f928ed8e7c926$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
$ae5f928ed8e7c926$export$875bcbe48555930.observe = function(vars) {
    return new (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b)(vars);
};
$ae5f928ed8e7c926$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $ae5f928ed8e7c926$var$_normalizer;
    if (vars === true && $ae5f928ed8e7c926$var$_normalizer) return $ae5f928ed8e7c926$var$_normalizer.enable();
    if (vars === false) {
        $ae5f928ed8e7c926$var$_normalizer && $ae5f928ed8e7c926$var$_normalizer.kill();
        $ae5f928ed8e7c926$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $cfd1378c1e8f6244$export$c1cbdee04e18ea8b) ? vars : $ae5f928ed8e7c926$var$_getScrollNormalizer(vars);
    $ae5f928ed8e7c926$var$_normalizer && $ae5f928ed8e7c926$var$_normalizer.target === normalizer.target && $ae5f928ed8e7c926$var$_normalizer.kill();
    $ae5f928ed8e7c926$var$_isViewport(normalizer.target) && ($ae5f928ed8e7c926$var$_normalizer = normalizer);
    return normalizer;
};
$ae5f928ed8e7c926$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $cfd1378c1e8f6244$export$5de019f4480f0f8d),
    _inputObserver: $ae5f928ed8e7c926$var$_inputObserver,
    _scrollers: (0, $cfd1378c1e8f6244$export$3cd1cee43d19b683),
    _proxies: (0, $cfd1378c1e8f6244$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $ae5f928ed8e7c926$var$_lastScrollTime || $ae5f928ed8e7c926$var$_dispatch("scrollStart");
            $ae5f928ed8e7c926$var$_lastScrollTime = $ae5f928ed8e7c926$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $ae5f928ed8e7c926$var$_refreshing;
        }
    }
};
$ae5f928ed8e7c926$var$_getGSAP() && $ae5f928ed8e7c926$var$gsap.registerPlugin($ae5f928ed8e7c926$export$875bcbe48555930);


const $d39b81b5e37ca29a$var$body = document.body;
const $d39b81b5e37ca29a$export$a7f6cffb6b8ba11c = ()=>{
    const scrollY = window.scrollY;
    $d39b81b5e37ca29a$var$body.dataset.scrollLockY = String(scrollY);
    $d39b81b5e37ca29a$var$body.style.position = "fixed";
    $d39b81b5e37ca29a$var$body.style.top = `-${scrollY}px`;
    $d39b81b5e37ca29a$var$body.style.left = "0px";
    $d39b81b5e37ca29a$var$body.style.right = "0px";
};
const $d39b81b5e37ca29a$export$3f6fecd573f3fa48 = ()=>{
    const scrollY = Number($d39b81b5e37ca29a$var$body.dataset.scrollLockY || 0);
    $d39b81b5e37ca29a$var$body.style.position = "";
    $d39b81b5e37ca29a$var$body.style.top = "";
    $d39b81b5e37ca29a$var$body.style.left = "";
    $d39b81b5e37ca29a$var$body.style.right = "";
    delete $d39b81b5e37ca29a$var$body.dataset.scrollLockY;
    window.scrollTo(0, scrollY);
};


const $d5f992f8158b4022$var$menu = document.querySelector("#main-navigation");
const $d5f992f8158b4022$var$hamburger = document.querySelector("#hamburger");
const $d5f992f8158b4022$var$openIcon = $d5f992f8158b4022$var$hamburger?.querySelector(".menuIcon");
const $d5f992f8158b4022$var$closeIcon = $d5f992f8158b4022$var$hamburger?.querySelector(".closeIcon");
// Bail out on pages (e.g. the 404 template) that don't render the header/nav
if ($d5f992f8158b4022$var$menu && $d5f992f8158b4022$var$hamburger) {
    // Toggle nav
    $d5f992f8158b4022$var$hamburger.addEventListener("click", function() {
        $d5f992f8158b4022$var$menu.classList.contains("hidden") ? $d5f992f8158b4022$export$21a5e8c01990eb73() : $d5f992f8158b4022$export$c9e788aaf7edc9f8();
    });
    // Close nav when a link is clicked
    $d5f992f8158b4022$var$menu.addEventListener("click", function(event) {
        if (event.target.tagName === "A") $d5f992f8158b4022$export$c9e788aaf7edc9f8();
    });
}
const $d5f992f8158b4022$export$21a5e8c01990eb73 = ()=>{
    if (!$d5f992f8158b4022$var$menu) return;
    (0, $d39b81b5e37ca29a$export$a7f6cffb6b8ba11c)();
    $d5f992f8158b4022$var$menu.classList.remove("hidden");
    $d5f992f8158b4022$var$menu.classList.add("block", "opacity-100");
    $d5f992f8158b4022$var$openIcon.classList.add("hidden");
    $d5f992f8158b4022$var$closeIcon.classList.remove("hidden");
};
const $d5f992f8158b4022$export$c9e788aaf7edc9f8 = ()=>{
    if (!$d5f992f8158b4022$var$menu) return;
    (0, $d39b81b5e37ca29a$export$3f6fecd573f3fa48)();
    $d5f992f8158b4022$var$menu.classList.add("hidden");
    $d5f992f8158b4022$var$menu.classList.remove("block", "opacity-100");
    $d5f992f8158b4022$var$openIcon.classList.remove("hidden");
    $d5f992f8158b4022$var$closeIcon.classList.add("hidden");
};
// Re-applies the active link styling after a swup transition swaps in new page content
const $d5f992f8158b4022$export$a3faa35d33130f1f = ()=>{
    if (!$d5f992f8158b4022$var$menu) return;
    const currentSegment = window.location.pathname.split("/").filter(Boolean)[0] ?? "";
    $d5f992f8158b4022$var$menu.querySelectorAll("a").forEach((link)=>{
        const linkSegment = link.pathname.split("/").filter(Boolean)[0] ?? "";
        link.classList.toggle("!border-yellow", linkSegment === currentSegment);
    });
};


let $edad02cabd4239fa$var$map;
let $edad02cabd4239fa$var$mapElement;
// Defaults
const $edad02cabd4239fa$var$center = {
    lat: 53.60352032867638,
    lng: -1.7814485225240047
};
const $edad02cabd4239fa$var$zoom = 16;
// Wait for the Google Maps API to be available before initializing the map
const $edad02cabd4239fa$var$waitForGoogleMaps = ()=>new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>{
            reject(new Error("Google Maps API did not become available."));
        }, 10000);
        const check = ()=>{
            if (window.google?.maps?.importLibrary) {
                clearTimeout(timeout);
                resolve();
                return;
            }
            setTimeout(check, 50);
        };
        check();
    });
// Initialize Google Maps
const $edad02cabd4239fa$var$initMap = async ()=>{
    const nextMapElement = document.getElementById("map");
    if (!nextMapElement || nextMapElement === $edad02cabd4239fa$var$mapElement) return;
    // Get map config
    const markers = JSON.parse(nextMapElement.dataset.markers || "[]");
    const mapZoom = Number(nextMapElement.dataset.zoom) || $edad02cabd4239fa$var$zoom;
    const mapCenter = nextMapElement.dataset.centerLat && nextMapElement.dataset.centerLng ? {
        lat: Number(nextMapElement.dataset.centerLat),
        lng: Number(nextMapElement.dataset.centerLng)
    } : null;
    try {
        await $edad02cabd4239fa$var$waitForGoogleMaps();
        const { InfoWindow: InfoWindow, Map: GoogleMap } = await window.google.maps.importLibrary("maps");
        const { AdvancedMarkerElement: AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        if (!nextMapElement.isConnected) return;
        // Build the map
        $edad02cabd4239fa$var$mapElement = nextMapElement;
        $edad02cabd4239fa$var$map = new GoogleMap($edad02cabd4239fa$var$mapElement, {
            center: mapCenter || (markers.length ? {
                lat: Number(markers[0].lat),
                lng: Number(markers[0].lng)
            } : $edad02cabd4239fa$var$center),
            zoom: mapZoom,
            zoomControl: true,
            mapId: "DEMO_MAP_ID",
            mapTypeControl: false
        });
        const infoWindow = new InfoWindow();
        const openMarkerInfoWindow = (marker, { title: title, address: address, website: website })=>{
            const content = document.createElement("div");
            content.className = "map-tooltip";
            const titleElement = document.createElement("p");
            titleElement.className = "map-tooltip__title";
            titleElement.textContent = title;
            content.append(titleElement);
            if (address) {
                const addressElement = document.createElement("p");
                addressElement.className = "map-tooltip__address";
                addressElement.textContent = address;
                content.append(addressElement);
            }
            if (website) {
                const websiteElement = document.createElement("a");
                websiteElement.className = "map-tooltip__website";
                websiteElement.href = website;
                websiteElement.target = "_blank";
                websiteElement.rel = "nofollow noopener";
                websiteElement.textContent = "Visit website";
                content.append(websiteElement);
            }
            infoWindow.setContent(content);
            infoWindow.open({
                map: $edad02cabd4239fa$var$map,
                anchor: marker
            });
        };
        // Add markers to the map
        const markerInstances = new Map();
        const selectMarker = (markerData)=>{
            if (!markerData) return;
            $edad02cabd4239fa$var$map.panTo(markerData.marker.position);
            openMarkerInfoWindow(markerData.marker, markerData);
        };
        markers.forEach(({ id: id, lat: lat, lng: lng, title: title, address: address, website: website })=>{
            const markerContent = document.createElement("div");
            markerContent.className = "map-marker";
            markerContent.setAttribute("aria-hidden", "true");
            const marker = new AdvancedMarkerElement({
                map: $edad02cabd4239fa$var$map,
                position: {
                    lat: Number(lat),
                    lng: Number(lng)
                },
                title: title,
                content: markerContent
            });
            const markerData = {
                marker: marker,
                title: title,
                address: address,
                website: website
            };
            markerInstances.set(String(id), markerData);
            marker.addListener("click", ()=>{
                openMarkerInfoWindow(marker, markerData);
            });
        });
        document.querySelectorAll("[data-marker-id]").forEach((card)=>{
            const selectCardMarker = ()=>{
                selectMarker(markerInstances.get(card.dataset.markerId));
            };
            card.addEventListener("click", (event)=>{
                if (event.target.closest("a")) return;
                selectCardMarker();
            });
            card.addEventListener("keydown", (event)=>{
                if (event.key !== "Enter" && event.key !== " ") return;
                event.preventDefault();
                selectCardMarker();
            });
        });
        // Fit the map bounds to include all markers if there are multiple markers,
        // unless an explicit center has been requested (e.g. a postcode search)
        if (!mapCenter && markers.length > 1) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.forEach(({ lat: lat, lng: lng })=>{
                bounds.extend({
                    lat: Number(lat),
                    lng: Number(lng)
                });
            });
            $edad02cabd4239fa$var$map.fitBounds(bounds);
        }
    } catch (error) {
        console.error(error);
    }
};
var $edad02cabd4239fa$export$2e2bcd8739ae039 = $edad02cabd4239fa$var$initMap;


/**
 * Swiper 14.1.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 6, 2026
 */ function $36f917fbf2efdd6b$export$db3b6bfb95261072(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0(obj) {
    Object.keys(obj).forEach((key)=>{
        try {
            obj[key] = null;
        } catch  {
        // no getter for object
        }
        try {
            delete obj[key];
        } catch  {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$625550452a3fa3ec(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$3b14a55fb2447963() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    return window.getComputedStyle(el, null);
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162(el, axis = 'x') {
    const style = $36f917fbf2efdd6b$var$getComputedStyle(el);
    const transform = style.transform || style.webkitTransform;
    if (!transform || transform === 'none') return 0;
    const matrix = new DOMMatrixReadOnly(transform);
    return axis === 'x' ? matrix.m41 : matrix.m42;
}
function $36f917fbf2efdd6b$export$43caf9889c228507(o) {
    // `constructor === Object` would be false for a plain object created in another realm
    // (params built in the parent page, Swiper running inside an iframe), which makes extend()
    // replace a nested defaults object instead of merging into it.
    return typeof o === 'object' && o !== null && !!o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $36f917fbf2efdd6b$var$isNode(node) {
    if (typeof HTMLElement !== 'undefined' && node instanceof HTMLElement) return true;
    return !!node && typeof node === 'object' && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(target, ...sources) {
    const to = Object(target);
    for(let i = 0; i < sources.length; i += 1){
        const nextSource = sources[i];
        if (nextSource === undefined || nextSource === null || $36f917fbf2efdd6b$var$isNode(nextSource)) continue;
        const sourceObj = nextSource;
        const keysArray = Object.keys(Object(sourceObj)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
        for (const nextKey of keysArray){
            const desc = Object.getOwnPropertyDescriptor(sourceObj, nextKey);
            if (!desc || !desc.enumerable) continue;
            const sourceVal = sourceObj[nextKey];
            if ($36f917fbf2efdd6b$export$43caf9889c228507(to[nextKey]) && $36f917fbf2efdd6b$export$43caf9889c228507(sourceVal)) {
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else if (!$36f917fbf2efdd6b$export$43caf9889c228507(to[nextKey]) && $36f917fbf2efdd6b$export$43caf9889c228507(sourceVal)) {
                to[nextKey] = {};
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else to[nextKey] = sourceVal;
        }
    }
    return to;
}
function $36f917fbf2efdd6b$export$90a7f3efeed30595(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(slideEl) {
    const direct = slideEl.querySelector('.swiper-slide-transform');
    if (direct) return direct;
    if (slideEl.shadowRoot) {
        const shadowed = slideEl.shadowRoot.querySelector('.swiper-slide-transform');
        if (shadowed) return shadowed;
    }
    return slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector = '') {
    const children = [
        ...element.children
    ];
    if (element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    return selector ? children.filter((el)=>el.matches(selector)) : children;
}
function $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, slot) {
    const queue = [
        slot
    ];
    while(queue.length > 0){
        const cur = queue.shift();
        if (el === cur) return true;
        queue.push(...cur.children, ...cur.shadowRoot ? cur.shadowRoot.children : [], ...cur.assignedElements ? cur.assignedElements() : []);
    }
    return false;
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el, parent) {
    let isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $36f917fbf2efdd6b$export$d141bba7fdc215a3(text) {
    try {
        console.warn(text);
    } catch  {
    // err
    }
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $36f917fbf2efdd6b$export$db3b6bfb95261072(classes));
    return el;
}
// Viewport-relative on purpose: every caller either compares against viewport quantities
// or adds window.scrollX/Y itself, so folding the scroll offset in here double-counts.
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9(el) {
    const box = el.getBoundingClientRect();
    return {
        top: box.top - (el.clientTop || 0),
        left: box.left - (el.clientLeft || 0)
    };
}
function $36f917fbf2efdd6b$export$342063e11d6c3cad(el, selector) {
    const prevEls = [];
    let prev = el.previousElementSibling;
    while(prev){
        if (!selector || prev.matches(selector)) prevEls.push(prev);
        prev = prev.previousElementSibling;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(el, selector) {
    const nextEls = [];
    let next = el.nextElementSibling;
    while(next){
        if (!selector || next.matches(selector)) nextEls.push(next);
        next = next.nextElementSibling;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(el, prop) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el) {
    if (!el || !el.parentNode) return undefined;
    return [
        ...el.parentNode.children
    ].indexOf(el);
}
function $36f917fbf2efdd6b$export$35e795649ee09318(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while(parent){
        if (!selector || parent.matches(selector)) parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el, callback) {
    if (!callback) return;
    el.addEventListener('transitionend', function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
    }, {
        once: true
    });
}
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(el, size, includeMargins) {
    {
        const style = window.getComputedStyle(el, null);
        return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    }
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $36f917fbf2efdd6b$export$efccba1c4a2ef57b(el, html = '') {
    const tt = globalThis.trustedTypes;
    if (typeof tt !== 'undefined') el.innerHTML = tt.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $029bc59d811a92d7$var$supportCached;
function $029bc59d811a92d7$var$calcSupport() {
    if (typeof window === 'undefined') return {
        touch: false
    };
    return {
        touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$supportCached) $029bc59d811a92d7$var$supportCached = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$supportCached;
}
let $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice({ userAgent: userAgent } = {}) {
    if (typeof window === 'undefined') return {
        ios: false,
        android: false
    };
    const support = $029bc59d811a92d7$var$getSupport();
    const platform = navigator.platform;
    const ua = userAgent || navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    const isIPhoneOrIPod = /(iPhone\sOS|iOS|iPod)/.test(ua);
    const isIPadDirect = /iPad/.test(ua);
    // iPad on iPadOS 13+ reports as MacIntel; distinguish from a real Mac by touch capability.
    const isIPadMasquerade = platform === 'MacIntel' && support.touch && navigator.maxTouchPoints > 1;
    const isIPad = isIPadDirect || isIPadMasquerade;
    const isWindows = platform === 'Win32';
    if (isAndroid && !isWindows) {
        device.os = 'android';
        device.android = true;
    }
    if (isIPad || isIPhoneOrIPod) {
        device.os = 'ios';
        device.ios = true;
    }
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides = {}) {
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
let $029bc59d811a92d7$var$browserCached;
function $029bc59d811a92d7$var$calcBrowser() {
    if (typeof window === 'undefined') return {
        isSafari: false,
        isWebView: false,
        need3dFix: false
    };
    const device = $029bc59d811a92d7$var$getDevice();
    const ua = navigator.userAgent;
    const uaLower = ua.toLowerCase();
    const isSafari = uaLower.includes('safari') && !uaLower.includes('chrome') && !uaLower.includes('android');
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    // 3D transform glitches still affect iOS WebView and Safari at the baseline (16.4+).
    const need3dFix = isSafari || isWebView && device.ios;
    return {
        isSafari: isSafari,
        isWebView: isWebView,
        need3dFix: need3dFix
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browserCached) $029bc59d811a92d7$var$browserCached = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browserCached;
}
const $029bc59d811a92d7$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? 'swiper-slide' : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    const innerLazy = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (innerLazy && !innerLazy.lazyPreloaderManaged) innerLazy.remove();
                }
            });
        }
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $029bc59d811a92d7$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $029bc59d811a92d7$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && (swiper.params.grid.rows ?? 1) > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>activeColumn + slidesPerView + i));
        swiper.slides.forEach((slideEl, i)=>{
            if (slideEl.column !== undefined && preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i);
    }
};
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(String(a.value), 10) - parseInt(String(b.value), 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
const $029bc59d811a92d7$var$isGridEnabled = (swiper, params)=>{
    return !!(swiper.grid && params.grid && params.grid.rows > 1);
};
function $029bc59d811a92d7$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointsRecord = breakpoints;
    const breakpointOnlyParams = breakpoint in breakpointsRecord ? breakpointsRecord[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    const isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    const moduleOpt = (opts, prop)=>opts[prop];
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const bpOpts = moduleOpt(breakpointParams, prop);
        if (typeof bpOpts === 'undefined') return;
        const paramsOpts = moduleOpt(params, prop);
        const wasModuleEnabled = typeof paramsOpts === 'object' && paramsOpts !== null && paramsOpts.enabled;
        const isModuleEnabled = typeof bpOpts === 'object' && bpOpts !== null && bpOpts.enabled;
        const moduleApi = swiper[prop];
        if (wasModuleEnabled && !isModuleEnabled) moduleApi?.disable?.();
        if (!wasModuleEnabled && isModuleEnabled) moduleApi?.enable?.();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // oxfmt-ignore
    const suffixes = $029bc59d811a92d7$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
const $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
var $029bc59d811a92d7$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const onceHandler = function onceHandlerFn(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        };
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            const opts = args[0];
            events = opts.events;
            data = opts.data ?? [];
            context = opts.context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$onClick(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
function $029bc59d811a92d7$var$onLoad(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $029bc59d811a92d7$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
        swiper.slideTo(slidesLength - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        const autoplay = swiper.autoplay;
        clearTimeout(autoplay.resizeTimeout);
        autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onScroll() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    let e = event.originalEvent ?? event;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    } else {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        // Legacy `e.path` was a non-standard Chrome extension; `composedPath()` is the modern API.
        const pathTree = e.path ?? (e.composedPath && e.composedPath());
        swiper.updateClickedSlide(pathTree && pathTree[0], pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
    (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -(data.currentTranslate ?? 0);
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    // Legacy event wrappers nest the native event under .originalEvent.
    const wrapped = event;
    const e = wrapped.originalEvent ?? wrapped;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
        targetTouch = found;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') document.activeElement.blur();
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    // startTranslate is guaranteed to be set by this point (set in onTouchStart-side init).
    const startTranslate = data.startTranslate ?? 0;
    data.currentTranslate = diff + startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(String(params.slidesPerView))))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && (data.currentTranslate ?? 0) < startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && (data.currentTranslate ?? 0) > startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate ?? 0);
}
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base) {
    function __closestFrom(el) {
        if (!el || el === document || el === window) return null;
        let cur = el;
        if (cur.assignedSlot) cur = cur.assignedSlot;
        const found = cur.closest(selector);
        if (!found && !cur.getRootNode) return null;
        const root = cur.getRootNode();
        return found || __closestFrom(root.host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$preventEdgeSwipe(swiper, event, startX) {
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const e = event.originalEvent ?? event;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        const pe = e;
        if (data.pointerId !== null && data.pointerId !== pe.pointerId) return;
        data.pointerId = pe.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $36f917fbf2efdd6b$export$2d1720544b23b823)(targetEl, swiper.wrapperEl)) return;
    }
    // Secondary mouse buttons (right-click / middle-click) shouldn't start a swipe.
    const mouseLike = e;
    if (typeof mouseLike.which === 'number' && mouseLike.which === 3) return;
    if (typeof mouseLike.button === 'number' && mouseLike.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // `path` is a non-standard Chrome extension; `composedPath()` is the modern API.
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (typeof params.swipeHandler === 'string' && !targetEl.closest(params.swipeHandler)) return;
    }
    // At this point `e` is a PointerEvent or MouseEvent (touchstart returned earlier).
    const pe = e;
    touches.currentX = pe.pageX;
    touches.currentY = pe.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (pe.pointerType === 'mouse' || pe.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
const $029bc59d811a92d7$var$events = (swiper, method)=>{
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    const subscribe = (events)=>{
        swiper[swiperMethod](events, $029bc59d811a92d7$var$onResize, true);
    };
    if (params.updateOnWindowResize) subscribe(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate');
    else subscribe('observerUpdate');
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $029bc59d811a92d7$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    $029bc59d811a92d7$var$events(swiper, 'on');
}
function $029bc59d811a92d7$var$detachEvents() {
    const swiper = this;
    $029bc59d811a92d7$var$events(swiper, 'off');
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual?.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', String(index));
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $029bc59d811a92d7$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual?.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const loopSlideEl = slideEl;
        const index = typeof loopSlideEl.swiperSlideIndex === 'undefined' ? Number(slideEl.getAttribute('data-swiper-slide-index')) : loopSlideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
function $029bc59d811a92d7$var$loopFix(options = {}) {
    const { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndexParam, initial: initial, byController: byController, byMousewheel: byMousewheel } = options;
    let activeSlideIndex = activeSlideIndexParam;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual?.enabled) {
        if (slideTo) {
            const virtualSlidesLength = swiper.virtual.slides.length;
            const virtualSlidesBefore = swiper.virtual.slidesBefore ?? 0;
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(virtualSlidesLength, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(virtualSlidesLength + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(virtualSlidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(String(params.slidesPerView)));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column ?? 0 : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let j = slides.length - 1; j >= 0; j -= 1)if (slides[j].column === colIndexToPrepend) prependSlidesIndexes.push(j);
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.prepend(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.append(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    const controlled = swiper.controller?.control;
    if (controlled && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(controlled)) controlled.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (controlled instanceof swiper.constructor && controlled.params.loop) controlled.loopFix({
            ...loopParams,
            slideTo: controlled.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
    };
}
const $029bc59d811a92d7$var$Observer = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    const observers = [];
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        if (!ObserverFunc) return;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options.childList),
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
};
const $029bc59d811a92d7$var$Resize = ({ swiper: swiper, on: on, emit: emit })=>{
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    // Older Safari (≤15) exposed `contentBoxSize` as a single object instead of an array.
                    const box = Array.isArray(contentBoxSize) ? contentBoxSize[0] : contentBoxSize;
                    newWidth = contentRect ? contentRect.width : box.inlineSize;
                    newHeight = contentRect ? contentRect.height : box.blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
};
function $029bc59d811a92d7$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && (swiper.params.initialSlide ?? 0) > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: t,
            behavior: 'smooth'
        });
        return true;
    }
    const browser = $029bc59d811a92d7$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl, clickedSlide: clickedSlide, clickedIndex: clickedIndex } = swiper;
    if (clickedSlide === undefined || clickedIndex === undefined) return;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual?.enabled) newIndex = newIndex + (swiper.virtual.slidesBefore ?? 0);
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                targetSlideIndex = targetSlideEl?.column ?? 0;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView;
            if (swiper.params.slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(String(swiper.params.slidesPerView)));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                newIndex = targetSlideEl?.column ?? 0;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $029bc59d811a92d7$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: -newTranslate,
            behavior: 'smooth'
        });
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        const virtualSlides = swiper.virtual.slides;
        let realIndex = aIndex - (swiper.virtual.slidesBefore ?? 0);
        if (realIndex < 0) realIndex = virtualSlides.length + realIndex;
        if (realIndex >= virtualSlides.length) realIndex -= virtualSlides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual?.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            const slide = getSlideByIndex(index);
            if (slide) activeSlides.push(slide);
        }
    } else {
        const slide = getSlideByIndex(swiper.activeIndex);
        if (slide) activeSlides.push(slide);
    }
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $029bc59d811a92d7$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual?.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    let progressLoop = swiper.progressLoop;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
function $029bc59d811a92d7$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'padding-left') || '0', 10) - parseInt((0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'padding-right') || '0', 10);
    height = height - parseInt((0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'padding-top') || '0', 10) - parseInt((0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'padding-bottom') || '0', 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || '0');
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    const resolveOffset = (value)=>typeof value === 'function' ? value.call(swiper) : value;
    const offsetBefore = resolveOffset(params.slidesOffsetBefore);
    const offsetAfter = resolveOffset(params.slidesOffsetAfter);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize = 0;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        const bp = params.breakpoints[key];
        return typeof bp?.slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(slide, 'display') === 'none') continue;
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual?.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'width') : (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'height');
            else {
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        const slidesBefore = swiper.virtual.slidesBefore ?? 0;
        const slidesAfter = swiper.virtual.slidesAfter ?? 0;
        const virtualLoopCount = slidesBefore + slidesAfter;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil(virtualLoopCount / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < virtualLoopCount; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
const $029bc59d811a92d7$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            const virtualSlides = swiper.virtual.slides;
            let slideIndex = activeIndex - (swiper.virtual.slidesBefore ?? 0);
            if (slideIndex < 0) slideIndex = virtualSlides.length + slideIndex;
            if (slideIndex >= virtualSlides.length) slideIndex -= virtualSlides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            // NOTE: legacy guard from v9; `(!prevSlide) === 0` is always false, but we preserve
            // the original behaviour (no-op) to avoid runtime changes in v14. Audit candidate.
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $029bc59d811a92d7$var$toggleSlideClasses$1(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $029bc59d811a92d7$var$toggleSlideClasses$1(slideEl, slideEl === nextSlide, params.slideNextClass);
        $029bc59d811a92d7$var$toggleSlideClasses$1(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $029bc59d811a92d7$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset ?? 0;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset ?? 0;
        const slideSize = slide.swiperSlideSize ?? 0;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $029bc59d811a92d7$var$toggleSlideClasses(slide, isVisible, params.slideVisibleClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
const $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
const $029bc59d811a92d7$var$extendedDefaults = {};
class $029bc59d811a92d7$export$25ce5a424b770e84 {
    static extendedDefaults;
    static defaults;
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0] !== null && typeof args[0] === 'object' && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && typeof params.el === 'string' && typeof document !== 'undefined' && document.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, params, {
                    el: containerEl
                });
                swipers.push(new $029bc59d811a92d7$export$25ce5a424b770e84(newParams));
            });
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent ?? undefined
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__ || []
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            const fn = mod;
            if (typeof fn === 'function' && swiper.modules.indexOf(fn) < 0) swiper.modules.push(fn);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, swiper.params);
        swiper.passedParams = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) {
            const onHandlers = swiper.params.on;
            Object.keys(onHandlers).forEach((eventName)=>{
                const handler = onHandlers[eventName];
                if (handler) swiper.on(eventName, handler);
            });
        }
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // oxfmt-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    /**
     * !INTERNAL
     */ isHorizontal() {
        return this.params.direction === 'horizontal';
    }
    isVertical() {
        return this.params.direction === 'vertical';
    }
    cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(slides[0]);
        return (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(slideEl) - (firstSlideIndex ?? 0);
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const { slidesEl: slidesEl, params: params } = this;
        this.slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    /**
     * Enable Swiper (if it was disabled)
     */ enable() {
        if (this.enabled) return;
        this.enabled = true;
        if (this.params.grabCursor) this.setGrabCursor();
        this.emit('enable');
    }
    /**
     * Disable Swiper (if it was enabled). When Swiper is disabled, it will hide all navigation elements and won't respond to any events and interactions
     */ disable() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.params.grabCursor) this.unsetGrabCursor();
        this.emit('disable');
    }
    /**
     * Set Swiper translate progress (from 0 to 1). Where 0 - its initial position (offset) on first slide, and 1 - its maximum position (offset) on last slide
     *
     * @param progress Swiper translate progress (from 0 to 1).
     * @param speed Transition duration (in ms).
     */ setProgress(progress, speed) {
        progress = Math.min(Math.max(progress, 0), 1);
        const min = this.minTranslate();
        const max = this.maxTranslate();
        const current = (max - min) * progress + min;
        this.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        this.updateActiveIndex();
        this.updateSlidesClasses();
    }
    emitContainerClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const cls = this.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(this.params.containerModifierClass) === 0;
        });
        this.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        if (this.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(this.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const updates = [];
        this.slides.forEach((slideEl)=>{
            const classNames = this.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            this.emit('_slideClass', slideEl, classNames);
        });
        this.emit('_slideClasses', updates);
    }
    /**
     * Get dynamically calculated amount of slides per view, useful only when slidesPerView set to `auto`
     */ slidesPerViewDynamic(view = 'current', exact = false) {
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = this;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        // container not measured yet — centered branch below would never break and return ~slides.length (#7586)
        if (!swiperSize) return spv;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize ?? 0) : 0;
            let breakLoop = false;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize ?? 0);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize ?? 0;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
            const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) spv += 1;
        }
        else // previous
        for(let i = activeIndex - 1; i >= 0; i -= 1){
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
            if (slideInView) spv += 1;
        }
        return spv;
    }
    /**
     * You should call it after you add/remove slides
     * manually, or after you hide/show it, or do any
     * custom DOM modifications with Swiper
     * This method also includes subcall of the following
     * methods which you can use separately:
     */ update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode?.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slidesLength = swiper.virtual && params.virtual?.enabled ? swiper.virtual.slides.length : swiper.slides.length;
                translated = swiper.slideTo(slidesLength - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    /**
     * Changes slider direction from horizontal to vertical and back.
     *
     * @param direction New direction. If not specified, then will automatically changed to opposite direction
     * @param needUpdate Will call swiper.update(). Default true
     */ changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    /**
     * Changes slider language
     *
     * @param direction New direction. Should be `rtl` or `ltr`
     */ changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // No DOM (SSR / Node) — nothing to mount to.
        if (typeof document === 'undefined') return false;
        // Find el (params.el can be a CSSSelector, HTMLElement, or undefined)
        const initialEl = element ?? swiper.params.el;
        let el = null;
        if (typeof initialEl === 'string') el = document.querySelector(initialEl);
        else if (initialEl instanceof HTMLElement) el = initialEl;
        if (!el) return false;
        el.swiper = swiper;
        const parent = el.parentNode;
        if (parent && parent.host && parent.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        const host = swiper.isElement ? el.parentNode.host : null;
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !host.slideSlots ? host : wrapperEl,
            hostEl: swiper.isElement ? host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    /**
     * Initialize slider
     */ init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) swiper.slideTo((swiper.params.initialSlide ?? 0) + (swiper.virtual.slidesBefore ?? 0), 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
            });
        });
        $029bc59d811a92d7$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $029bc59d811a92d7$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    /**
     * Destroy slider instance and detach all events listeners
     *
     * @param deleteInstance Set it to false (by default it is true) to not to delete Swiper instance
     * @param cleanStyles Set it to true (by default it is true) and all custom styles will be removed from slides, wrapper and container.
     * Useful if you need to destroy Swiper and to init again with new options or in different direction
     */ destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
    }
    static installModule(mod) {
        if (!$029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__) $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$029bc59d811a92d7$export$25ce5a424b770e84.installModule(m));
            return $029bc59d811a92d7$export$25ce5a424b770e84;
        }
        $029bc59d811a92d7$export$25ce5a424b770e84.installModule(module);
        return $029bc59d811a92d7$export$25ce5a424b770e84;
    }
}
Object.defineProperty($029bc59d811a92d7$export$25ce5a424b770e84, 'extendedDefaults', {
    get () {
        return $029bc59d811a92d7$var$extendedDefaults;
    }
});
Object.defineProperty($029bc59d811a92d7$export$25ce5a424b770e84, 'defaults', {
    get () {
        return $029bc59d811a92d7$export$4368d992c4eafac0;
    }
});
// Attach prototype-mixin method groups onto Swiper.prototype. Each group is a
// plain record of method-name → function; we copy them across as-is.
const $029bc59d811a92d7$var$prototypeRecord = $029bc59d811a92d7$var$prototypes;
const $029bc59d811a92d7$var$swiperProto = $029bc59d811a92d7$export$25ce5a424b770e84.prototype;
Object.keys($029bc59d811a92d7$var$prototypeRecord).forEach((prototypeGroup)=>{
    const group = $029bc59d811a92d7$var$prototypeRecord[prototypeGroup];
    Object.keys(group).forEach((protoMethod)=>{
        $029bc59d811a92d7$var$swiperProto[protoMethod] = group[protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);



const $33834d902fe381ab$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    // Methods (appendSlide/prependSlide/removeSlide/removeAllSlides/update) are
    // attached via Object.assign below once they're defined. Cast through
    // Partial<> so the initial state-only literal can be assigned without
    // pretending the methods exist yet.
    swiper.virtual = {
        cache: {},
        from: 0,
        // -1 marks "nothing rendered yet": no real update can produce to < from,
        // so the first update() never mistakes slide 0 for an already-rendered
        // slide and always appends the full [from, to] window (#8202).
        to: -1,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function getParams() {
        return swiper.params.virtual;
    }
    // Created lazily so module init does not touch the DOM (SSR / Node safe).
    let tempDOM;
    const getTempDOM = ()=>tempDOM ??= document.createElement('div');
    function renderSlide(slide, index) {
        const params = getParams();
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        let slideEl;
        if (params.renderSlide) {
            const rendered = params.renderSlide.call(swiper, slide, index);
            if (typeof rendered === 'string') {
                const el = getTempDOM();
                (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(el, rendered);
                slideEl = el.children[0];
            } else slideEl = rendered;
        } else if (swiper.isElement) slideEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('swiper-slide');
        else slideEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', String(index));
        if (!params.renderSlide) (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && (initialSlide ?? 0) > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = getParams();
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView ?? 1;
        const groupSize = slidesPerGroup ?? 1;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (groupSize - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : groupSize) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        const virtualParams = getParams();
        if (virtualParams.renderExternal) {
            const slidesToRender = [];
            for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
            virtualParams.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: slidesToRender
            });
            if (virtualParams.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (slides !== null && typeof slides === 'object' && 'length' in slides) {
            const arr = slides;
            for(let i = 0; i < arr.length; i += 1)if (arr[i]) swiper.virtual.slides.push(arr[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (getParams().cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[Number(cachedIndex)];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', String(parseInt(cachedElIndex, 10) + numberOfNewSlides));
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        const shiftCacheDownFrom = (removedIndex)=>{
            Object.keys(swiper.virtual.cache).forEach((key)=>{
                const numericKey = Number(key);
                if (numericKey > removedIndex) {
                    const shifted = swiper.virtual.cache[numericKey];
                    swiper.virtual.cache[numericKey - 1] = shifted;
                    shifted.setAttribute('data-swiper-slide-index', String(numericKey - 1));
                    delete swiper.virtual.cache[numericKey];
                }
            });
        };
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                shiftCacheDownFrom(slidesIndexes[i]);
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes];
                shiftCacheDownFrom(slidesIndexes);
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (getParams().cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        let domSlidesAssigned = false;
        const passedVirtual = swiper.passedParams.virtual;
        const passedSlidesUndefined = !passedVirtual || typeof passedVirtual !== 'object' || passedVirtual.slides === undefined;
        if (passedSlidesUndefined) {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', String(slideIndex));
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = getParams().slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode) (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
};



const $52e509fb8653e0d9$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function getParams() {
        return swiper.params.keyboard;
    }
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        const e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        const kc = e.keyCode || e.charCode;
        const params = getParams();
        const pageUpDown = !!params.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.isContentEditable || activeElement.nodeName && (activeElement.nodeName.toLowerCase() === 'input' || activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (params.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $36f917fbf2efdd6b$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $36f917fbf2efdd6b$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue;
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = params.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.cancelable) e.preventDefault();
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.cancelable) e.preventDefault();
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    swiper.keyboard = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
};



const $05e7c97b57a34c96$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    let timeout;
    let lastScrollTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
    let lastEventBeforeSnap;
    let mouseEntered = false;
    const recentWheelEvents = [];
    function getParams() {
        return swiper.params.mousewheel;
    }
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        const ev = e;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if (ev.detail !== undefined) sY = ev.detail;
        if (ev.wheelDelta !== undefined) sY = -ev.wheelDelta / 120;
        if (ev.wheelDeltaY !== undefined) sY = -ev.wheelDeltaY / 120;
        if (ev.wheelDeltaX !== undefined) sX = -ev.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if (ev.axis !== undefined && ev.HORIZONTAL_AXIS !== undefined && ev.axis === ev.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if (ev.deltaY !== undefined) pY = ev.deltaY;
        if (ev.deltaX !== undefined) pX = ev.deltaX;
        if (ev.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && ev.deltaMode) {
            if (ev.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        mouseEntered = false;
    }
    function animateSlider(newEvent) {
        const params = getParams();
        if (params.thresholdDelta && newEvent.delta < params.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (params.thresholdTime && (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)() - lastScrollTime < params.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)() - lastScrollTime < 60) // Return false as a default
        return true;
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = getParams();
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event) {
        let e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        let disableParentSwiper = true;
        if (!swiper.enabled) return false;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        const params = getParams();
        if (event.target.closest(`.${params.noMousewheelClass}`)) return false;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        const freeModeParams = swiper.params.freeMode;
        if (!swiper.params.freeMode || !freeModeParams?.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (freeModeParams?.sticky) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && firstEvent && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) timeout = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                const autoplayParams = swiper.params.autoplay;
                if (swiper.params.autoplay && autoplayParams?.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.cancelable) e.preventDefault();
        return false;
    }
    function events(method) {
        const params = getParams();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener('wheel', handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        const params = getParams();
        if (!params.enabled && swiper.params.cssMode) disable();
        if (params.enabled) enable();
    });
    swiper.mousewheel = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
};



function $756cc3b72a05f628$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    const target = params ?? {};
    const original = originalParams ?? {};
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!target[key] && target.auto === true) {
            let element = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            target[key] = element;
            original[key] = element;
        }
    });
    return target;
}



const $9dcb69c205fd1703$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
const $9dcb69c205fd1703$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    // Initialized as a partial; remaining methods (update, init, destroy,
    // enable, disable) attach after their definitions below.
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $9dcb69c205fd1703$var$arrowSvg
    };
    function getParams() {
        return swiper.params.navigation;
    }
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        return res;
    }
    function toggleEl(el, disabled) {
        const params = getParams();
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        swiper.params.navigation = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        const params = getParams();
        if (!(params.nextEl || params.prevEl)) return;
        const nextEl = getEl(params.nextEl);
        const prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(tempEl, $9dcb69c205fd1703$var$arrowSvg);
                    const svgEl = tempEl.querySelector('svg');
                    if (svgEl) el.appendChild(svgEl);
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEls.forEach((el)=>initButton(el, 'next'));
        prevEls.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...params.disabledClass.split(' '));
        };
        nextEls.forEach((el)=>destroyButton(el, 'next'));
        prevEls.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEls,
            ...prevEls
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(params.lockClass));
    });
    on('click', (_s, e)=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEls.includes(targetEl) || nextEls.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.composedPath ? e.composedPath() : [];
            if (path.length) targetIsButton = path.find((pathEl)=>nextEls.includes(pathEl) || prevEls.includes(pathEl));
        }
        if (params.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEls.length) isHidden = nextEls[0].classList.contains(params.hiddenClass);
            else if (prevEls.length) isHidden = prevEls[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEls,
                ...prevEls
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...params.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...params.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
};


function $781a64a6db1a7446$export$db3b6bfb95261072(classes = '') {
    return `.${classes.trim().replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1').replace(/ /g, '.')}`;
}




const $69d1e0b9767b27dd$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $69d1e0b9767b27dd$var$isFreeModeEnabled = (swiper)=>!!swiper.params.freeMode?.enabled;
// Slides count for bullets/fraction/progressbar totals: with grid rows the
// slides that share a column collapse into one snap position.
const $69d1e0b9767b27dd$var$getSlidesLength = (swiper)=>{
    if ($69d1e0b9767b27dd$var$isVirtualEnabled(swiper)) return swiper.virtual.slides.length;
    const gridRows = swiper.params.grid?.rows;
    if (swiper.grid && gridRows && gridRows > 1) return swiper.slides.length / Math.ceil(gridRows);
    return swiper.slides.length;
};
const $69d1e0b9767b27dd$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    // Initialized as a partial; remaining methods (render, update, init,
    // destroy, enable, disable) attach after their definitions below.
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function getParams() {
        return swiper.params.pagination;
    }
    function isPaginationDisabled() {
        const elParam = getParams().el;
        return !elParam || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = getParams();
        if (!bulletEl) return;
        let current = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (current) {
            current.classList.add(`${bulletActiveClass}-${position}`);
            current = current[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (current) current.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return undefined;
    }
    function onBulletClick(e) {
        const targetEl = e.target;
        const bulletEl = targetEl.closest((0, $781a64a6db1a7446$export$db3b6bfb95261072)(getParams().bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = ((0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(bulletEl) ?? 0) * (swiper.params.slidesPerGroup ?? 1);
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = getParams();
        if (isPaginationDisabled()) return;
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = $69d1e0b9767b27dd$var$getSlidesLength(swiper);
        const total = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = (swiper.params.slidesPerGroup ?? 1) > 1 ? Math.floor(swiper.realIndex / (swiper.params.slidesPerGroup ?? 1)) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex = 0;
            let lastIndex = 0;
            let midIndex = 0;
            if (params.dynamicBullets) {
                bulletSize = (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
                const dim = swiper.isHorizontal() ? 'width' : 'height';
                els.forEach((subEl)=>{
                    subEl.style[dim] = `${(bulletSize ?? 0) * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).flatMap((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : [
                        s
                    ]);
                bulletEl.classList.remove(...classesToRemove);
            });
            if (els.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets && bulletIndex !== undefined) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = ((bulletSize ?? 0) * dynamicBulletsLength - (bulletSize ?? 0)) / 2 - midIndex * (bulletSize ?? 0);
                const offsetProp = rtl ? 'right' : 'left';
                const positionDim = swiper.isHorizontal() ? offsetProp : 'top';
                bullets.forEach((bullet)=>{
                    bullet.style[positionDim] = `${bulletsOffset}px`;
                });
            }
        }
        els.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = String(params.formatFractionCurrent(current + 1));
                });
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = String(params.formatFractionTotal(total));
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = getParams();
        if (isPaginationDisabled()) return;
        const slidesLength = $69d1e0b9767b27dd$var$getSlidesLength(swiper);
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
            if (swiper.params.freeMode && $69d1e0b9767b27dd$var$isFreeModeEnabled(swiper) && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // oxfmt-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        els.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...Array.from(subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.bulletClass))));
        });
        if (params.type !== 'custom') emit('paginationRender', els[0]);
    }
    function init() {
        swiper.params.pagination = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || Array.isArray(el) && el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) {
                const found = el.find((subEl)=>{
                    if ((0, $36f917fbf2efdd6b$export$35e795649ee09318)(subEl, '.swiper')[0] !== swiper.el) return false;
                    return true;
                });
                if (found) el = found;
            }
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = getParams();
        if (isPaginationDisabled()) return;
        const el = swiper.pagination.el;
        if (el) {
            const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = getParams();
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.pagination;
        if (el) {
            const params = getParams();
            const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](params.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
        const params = getParams();
        if (params.el && params.hideOnClick && els && els.length > 0 && !targetEl.classList.contains(params.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = els[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            els.forEach((subEl)=>subEl.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList.remove(params.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList.add(params.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
};





const $c7252c6c2cf4bba7$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos = 0;
    let dragSize = 0;
    let trackSize = 0;
    let divider = 0;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    // Initialized as a partial; remaining methods (updateSize, setTranslate,
    // init, destroy, enable, disable) attach after their definitions below.
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function getParams() {
        return swiper.params.scrollbar;
    }
    function setTranslate() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop ?? 0 : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            if (timeout) clearTimeout(timeout);
            el.style.opacity = '1';
            timeout = setTimeout(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!getParams().el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + (swiper.params.slidesOffsetBefore ?? 0) - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (params.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(String(params.dragSize), 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (params.hide) el.style.opacity = '0';
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.clientX ?? e.touches?.[0]?.clientX ?? 0;
        return e.clientY ?? e.touches?.[0]?.clientY ?? 0;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        if (dragTimeout) clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = '1';
        if (swiper.params.cssMode) swiper.wrapperEl.style.scrollSnapType = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.cancelable) e.preventDefault();
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            if (dragTimeout) clearTimeout(dragTimeout);
            dragTimeout = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        el[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        const elTyped = el;
        elTyped.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl = null;
        if (elTyped) {
            dragEl = elTyped.querySelector((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.dragClass));
            if (!dragEl) {
                dragEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', params.dragClass);
                elTyped.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: elTyped,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (elTyped) elTyped.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(params.lockClass));
    }
    function destroy() {
        const params = getParams();
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = getParams();
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.scrollbar.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(getParams().lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $36f917fbf2efdd6b$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
};



const $c36b71b742710ea0$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        parallax: {
            enabled: false
        }
    });
    function getParams() {
        return swiper.params.parallax;
    }
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${Number(x) * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${Number(y) * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const opacityNum = Number(opacity);
            const currentOpacity = opacityNum - (opacityNum - 1) * (1 - Math.abs(progress));
            el.style.opacity = String(currentOpacity);
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const scaleNum = Number(scale);
            const currentScale = scaleNum - (scaleNum - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = Number(rotate) * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        const elements = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress ?? 0;
            const slidesPerGroup = swiper.params.slidesPerGroup ?? 1;
            if (slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed ?? 300)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            const attr = parallaxEl.getAttribute('data-swiper-parallax-duration');
            let parallaxDuration = (attr ? parseInt(attr, 10) : 0) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!getParams().enabled) return;
        setTransition(duration);
    });
};



const $401de11e8a126d45$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    function getParams() {
        return swiper.params.zoom;
    }
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched = false;
    let fakeGestureMoved = false;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = getParams();
        const attr = gesture.imageWrapEl?.getAttribute('data-swiper-zoom');
        const maxRatio = attr != null ? Number(attr) : params.maxRatio;
        const imageEl = gesture.imageEl;
        if (params.limitToOriginalSize && imageEl && imageEl.naturalWidth) {
            const imageMaxRatio = imageEl.naturalWidth / imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2 || !gesture.imageEl) return [
            null,
            null
        ];
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        const target = e.target;
        if (!target) return false;
        if (target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${getParams().containerClass}`;
        const target = e.target;
        if (!target) return false;
        if (target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            const target = e.target;
            gesture.slideEl = target?.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX ?? 0;
            gesture.originY = originY ?? 0;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / (gesture.scaleStart ?? 1) * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        if (allowTouchMoveTimeout !== undefined) clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (image.isTouched) return;
        // Record the position before the imageEl guard, it is unset until the first pinch or zoom
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
        if (!gesture.imageEl) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && getParams().panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - (image.touchesStart.x ?? 0)), Math.abs(image.touchesCurrent.y - (image.touchesStart.y ?? 0)));
        if (touchesDiff > 5) swiper.allowClick = false;
        const startX = image.startX ?? 0;
        const startY = image.startY ?? 0;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(startX) && image.touchesCurrent.x < (image.touchesStart.x ?? 0) || Math.floor(image.maxX) === Math.floor(startX) && image.touchesCurrent.x > (image.touchesStart.x ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(startY) && image.touchesCurrent.y < (image.touchesStart.y ?? 0) || Math.floor(image.maxY) === Math.floor(startY) && image.touchesCurrent.y > (image.touchesStart.y ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - getParams().minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - (image.touchesStart.x ?? 0) + startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - (image.touchesStart.y ?? 0) + startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const velocityX = velocity.x ?? 0;
        const velocityY = velocity.y ?? 0;
        const momentumDistanceX = velocityX * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocityY * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocityX !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocityX);
        if (velocityY !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocityY);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${getParams().zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            if (e && typeof e !== 'number' && 'target' in e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) {
                const virtual = swiper.params.virtual;
                if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        const eventIsPointer = e && typeof e !== 'number';
        if (typeof image.touchesStart.x === 'undefined' && eventIsPointer) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - (touchX ?? 0);
            diffY = offsetY + slideHeight / 2 - (touchY ?? 0);
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            const virtual = swiper.params.virtual;
            if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (params.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', ()=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && getParams().enabled && swiper.zoom.enabled && getParams().toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && getParams().enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && getParams().enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
};



class $411c83a941bc1076$var$LinearSpline {
    x;
    y;
    lastIndex;
    binarySearch;
    constructor(x, y){
        let maxIndex;
        let minIndex;
        let guess;
        this.binarySearch = (array, val)=>{
            minIndex = -1;
            maxIndex = array.length;
            while(maxIndex - minIndex > 1){
                guess = maxIndex + minIndex >> 1;
                if (array[guess] <= val) minIndex = guess;
                else maxIndex = guess;
            }
            return maxIndex;
        };
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
    }
    interpolate(x2) {
        if (!x2) return 0;
        const i3 = this.binarySearch(this.x, x2);
        const i1 = i3 - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    }
}
const $411c83a941bc1076$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function getParams() {
        return swiper.params.controller;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new $411c83a941bc1076$var$LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $411c83a941bc1076$var$LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const SwiperCtor = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            const controllerParams = getParams();
            if (controllerParams.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            } else controlledTranslate = 0;
            if (!controlledTranslate || controllerParams.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (controllerParams.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTranslate(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const SwiperCtor = swiper.constructor;
        const controlled = swiper.controller.control;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(()=>{
                    c.updateAutoHeight();
                });
                (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTransition(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        const controllerParam = getParams().control;
        if (typeof window !== 'undefined' && (typeof controllerParam === 'string' || controllerParam instanceof HTMLElement)) {
            const controlElements = typeof controllerParam === 'string' ? [
                ...document.querySelectorAll(controllerParam)
            ] : [
                controllerParam
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                const list = swiper.controller.control;
                if (controlElement && controlElement.swiper) list.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        const detail = e.detail;
                        if (detail && detail[0]) list.push(detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        // After this point control is either Swiper or Swiper[] (or null/undefined),
        // never the string/HTMLElement forms that the public option accepts.
        swiper.controller.control = controllerParam;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    // Event payloads come typed against the legacy public Swiper class
    // (src/types/swiper-class.d.ts) until Phase 5 deletes src/types/; cast the
    // forwarded byController back to the core Swiper so it lines up with the
    // controller-internal signatures.
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
};




const $9649bf9a787c3914$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $9649bf9a787c3914$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler = false;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function getParams() {
        return swiper.params.a11y;
    }
    function notify(message) {
        const notification = liveRegion;
        if (!notification || !message) return;
        (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', 'true');
        });
    }
    function enableEl(el) {
        const els = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = getParams();
        const paginationParams = swiper.params.pagination;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(targetEl))) {
            if (!targetEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(paginationParams?.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.navigation.prevEl);
            const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(paginationParams?.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return !!(swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length);
    }
    function hasClickablePagination() {
        const paginationParams = swiper.params.pagination;
        return hasPagination() && !!paginationParams?.clickable;
    }
    function updatePagination() {
        const params = getParams();
        if (!hasPagination()) return;
        const paginationParams = swiper.params.pagination;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (paginationParams.clickable) {
                makeElFocusable(bulletEl);
                if (!paginationParams.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, String(((0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(bulletEl) ?? 0) + 1)));
                }
            }
            if (bulletEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(paginationParams.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, _wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (_e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        const params = getParams();
        if (swiper.a11y.clicked || !params.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const target = e.target;
        const slideEl = target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = $9649bf9a787c3914$var$isVirtualEnabled(swiper);
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        const sourceCapabilities = e.sourceCapabilities;
        if (sourceCapabilities && sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = getParams();
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        const slideLabelMessage = params.slideLabelMessage;
        if (slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : index;
            const ariaLabelMessage = slideLabelMessage.replace(/\{\{index\}\}/, String(slideIndex + 1)).replace(/\{\{slidesLength\}\}/, String(slidesLength));
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = getParams();
        if (liveRegion) swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = String(params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`);
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const autoplayParams = swiper.params.autoplay;
            const live = swiper.params.autoplay && autoplayParams?.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nav.nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEls) prevEls.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nav.nextEl);
        const prevEls = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEls) prevEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('span', getParams().notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!getParams().enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!getParams().enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!getParams().enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!getParams().enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!getParams().enabled) return;
        destroy();
    });
};


const $38bb61499ef50fab$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {
        key: undefined,
        value: undefined
    };
    function getParams() {
        return swiper.params.history;
    }
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const isVirtualEnabled = !!swiper.params.virtual?.enabled;
        const slide = swiper.virtual && isVirtualEnabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        if (!slide) return;
        let value = slugify(slide.getAttribute('data-history') || '');
        const root = params.root;
        if (root.length > 0) {
            const trimmedRoot = root[root.length - 1] === '/' ? root.slice(0, root.length - 1) : root;
            value = `${trimmedRoot}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key || '')) value = `${key ? `${key}/` : ''}${value}`;
        if (params.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (params.replaceState) window.history.replaceState({
            value: value
        }, '', value);
        else window.history.pushState({
            value: value
        }, '', value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history') || '');
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const params = swiper.params.history;
        if (!params) return;
        if (!window.history || !window.history.pushState) {
            params.enabled = false;
            const hashParams = swiper.params.hashNavigation;
            if (hashParams) hashParams.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        if (!getParams().replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(getParams().key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(getParams().key, swiper.activeIndex);
    });
};



const $87b0baa371d09db8$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $87b0baa371d09db8$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, on: on })=>{
    let initialized = false;
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if ($87b0baa371d09db8$var$isVirtualEnabled(swiper)) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index') || '0', 10);
                    return index;
                }
                const matched = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0];
                return matched ? swiper.getSlideIndex(matched) : 0;
            }
        }
    });
    function getParams() {
        return swiper.params.hashNavigation;
    }
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = $87b0baa371d09db8$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = getParams().getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        const activeSlideEl = $87b0baa371d09db8$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (params.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        const params = getParams();
        const historyParams = swiper.params.history;
        if (!params.enabled || historyParams && historyParams.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = params.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (params.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (getParams().watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
};


const $c1783ac9556c9fef$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params })=>{
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function getParams() {
        return swiper.params.autoplay;
    }
    // params here is the user-supplied passedParams; extendParams hasn't yet
    // merged the defaults into swiper.params.autoplay at this point.
    const initialAutoplayDelay = typeof params.autoplay === 'object' && params.autoplay && typeof params.autoplay.delay === 'number' ? params.autoplay.delay : 3000;
    let timeout;
    let raf;
    let autoplayDelayTotal = initialAutoplayDelay;
    let autoplayDelayCurrent = initialAutoplayDelay;
    let autoplayTimeLeft = 0;
    let autoplayStartTime = new Date().getTime();
    let wasPaused = false;
    let isTouched = false;
    let pausedByTouch = false;
    let touchStartTimeout;
    let pausedByInteraction = false;
    let pausedByPointerEnter = false;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        const detail = e.detail;
        if (pausedByPointerEnter || detail && detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        const virtualEnabled = !!swiper.params.virtual?.enabled;
        if (swiper.virtual && virtualEnabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const attr = activeSlideEl.getAttribute('data-swiper-autoplay');
        if (attr == null) return undefined;
        return parseInt(attr, 10);
    };
    const getTotalDelay = ()=>{
        let totalDelay = getParams().delay;
        const currentSlideDelay = getSlideDelay();
        if (typeof currentSlideDelay === 'number' && !Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return 0;
        if (raf !== undefined) cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            const autoplayParams = getParams();
            if (autoplayParams.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            if (timeout !== undefined) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
        return true;
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        if (timeout !== undefined) clearTimeout(timeout);
        if (raf !== undefined) cancelAnimationFrame(raf);
        emit('autoplayStop');
        return true;
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (timeout !== undefined) clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (getParams().waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || getParams().delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (getParams().pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (getParams().enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, _speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (getParams().disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        if (touchStartTimeout !== undefined) clearTimeout(touchStartTimeout);
        if (timeout !== undefined) clearTimeout(timeout);
        if (getParams().disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
};



const $21e2f533778c20f0$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function getParams() {
        return swiper.params.thumbs;
    }
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        const virtual = thumbsSwiper.params.virtual;
        return !!virtual && !!virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        const thumbsParams = getParams();
        if (clickedSlide && clickedSlide.classList.contains(thumbsParams.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
            const attr = thumbsSwiper.clickedSlide?.getAttribute('data-swiper-slide-index');
            slideToIndex = attr == null ? clickedIndex : parseInt(attr, 10);
        } else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const thumbsParams = getParams();
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            const thumbsSwiper = thumbsParams.swiper;
            swiper.thumbs.swiper = thumbsSwiper;
            Object.assign(thumbsSwiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(thumbsSwiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            thumbsSwiper.update();
        } else if ((0, $36f917fbf2efdd6b$export$43caf9889c228507)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return false;
        thumbsSwiper.el.classList.add(thumbsParams.thumbsContainerClass);
        thumbsSwiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) thumbsSwiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbsParams = getParams();
        const thumbActiveClass = thumbsParams.slideThumbActiveClass;
        const slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === 'number' && slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = slidesPerView;
        if (!thumbsParams.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $36f917fbf2efdd6b$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else for(let i = 0; i < thumbsToActivate; i += 1){
            const slide = thumbsSwiper.slides[swiper.realIndex + i];
            if (slide) slide.classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const thumbsSlidesPerView = thumbsSwiper.params.slidesPerView;
        const slidesPerView = thumbsSlidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSlidesPerView ?? 1;
        const autoScrollOffset = getParams().autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = newThumbsSlide ? thumbsSwiper.slides.indexOf(newThumbsSlide) : -1;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        const detail = e.detail;
                        thumbs.swiper = detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
};



const $49f3fa363ac09256$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, once: once })=>{
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function getParams() {
        return swiper.params.freeMode;
    }
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime ?? (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)()
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        const params = swiper.params;
        const freeModeParams = getParams();
        // Time diff
        const touchEndTime = (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)();
        const timeDiff = touchEndTime - (data.touchStartTime ?? touchEndTime);
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (freeModeParams.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < freeModeParams.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= freeModeParams.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * freeModeParams.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * freeModeParams.momentumBounceRatio;
            let needsLoopFix = false;
            if (newPosition < swiper.maxTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (freeModeParams.sticky) {
                let nextSlide = 0;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs((snapGrid[nextSlide - 1] ?? snapGrid[nextSlide]) - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (freeModeParams.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    const speed = params.speed;
                    if (moveDistance < currentSlideSize) momentumDuration = speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = speed * 1.5;
                    else momentumDuration = speed * 2.5;
                }
            } else if (freeModeParams.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (freeModeParams.momentumBounce && doBounce && afterBouncePosition !== undefined) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (freeModeParams.sticky) {
            swiper.slideToClosest();
            return;
        } else emit('_freeModeNoMomentumRelease');
        if (!freeModeParams.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    swiper.freeMode = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};


const $3e2c28ea1ae0e231$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    function getParams() {
        return swiper.params.grid;
    }
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween ?? 0;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const isVirtualEnabled = ()=>{
        const virtualParams = swiper.params.virtual;
        return !!swiper.virtual && typeof virtualParams === 'object' && virtualParams !== null && !!virtualParams.enabled;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView ?? 1) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            const gridSlide = slide;
            if (gridSlide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style.setProperty(swiper.getDirectionLabel('margin-top'), '');
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && (slidesPerGroup ?? 1) > 1) {
            const groupsPer = slidesPerGroup ?? 1;
            const groupIndex = Math.floor(i / (groupsPer * rows));
            const slideIndexInGroup = i - rows * groupsPer * groupIndex;
            const columnsInGroup = groupIndex === 0 ? groupsPer : Math.min(Math.ceil((slidesLength - groupIndex * rows * groupsPer) / rows), groupsPer);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * groupsPer;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = String(newSlideOrderIndex);
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        const gridSlide = slide;
        gridSlide.row = row;
        gridSlide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style.setProperty(swiper.getDirectionLabel('margin-top'), row !== 0 && spaceBetween ? `${spaceBetween}px` : '');
        gridSlide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = getParams();
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style.setProperty(swiper.getDirectionLabel('width'), `${swiper.virtualSize + spaceBetween}px`);
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        const gridParams = swiper.params.grid;
        wasMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const gridParams = params.grid;
        const isMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (gridParams.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
};



function $eb2d45639f1e8538$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        if (!currentSlide) continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) slidesEl.append(slide);
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.append(child);
            (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (Array.isArray(slides)) for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        if (slide) appendElement(slide);
    }
    else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $eb2d45639f1e8538$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.prepend(child);
            (0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $eb2d45639f1e8538$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            const indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        const indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
const $eb2d45639f1e8538$export$2e2bcd8739ae039 = ({ swiper: swiper })=>{
    Object.assign(swiper, {
        appendSlide: $eb2d45639f1e8538$var$appendSlide.bind(swiper),
        prependSlide: $eb2d45639f1e8538$var$prependSlide.bind(swiper),
        addSlide: $eb2d45639f1e8538$var$addSlide.bind(swiper),
        removeSlide: $eb2d45639f1e8538$var$removeSlide.bind(swiper),
        removeAllSlides: $eb2d45639f1e8538$var$removeAllSlides.bind(swiper)
    });
};


function $6be88bfc4d238db6$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            const effectParams = getEffectParams ? getEffectParams() : undefined;
            if (!effectParams || !effectParams.slideShadows) return;
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual = false;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b32fc4882a084e0d$export$f1e1789686576879(_effectParams, slideEl) {
    const transformEl = (0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style.setProperty('-webkit-backface-visibility', 'hidden');
    }
    return transformEl;
}



function $8cd9c8d5770c3e4b$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) // assume shadow root
        return swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
        if (el.parentElement instanceof HTMLElement) return el.parentElement;
        return undefined;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return !!el && swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



const $5d17e4afe2f572c9$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    function getParams() {
        return swiper.params.fadeEffect;
    }
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = getParams();
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const offset = slideEl.swiperSlideOffset ?? 0;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideProgress = slideEl.progress ?? 0;
            const slideOpacity = params.crossFade ? Math.max(1 - Math.abs(slideProgress), 0) : 1 + Math.min(Math.max(slideProgress, -1), 0);
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = String(slideOpacity);
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};




const $7a34974922f14d54$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    function getParams() {
        return swiper.params.cubeEffect;
    }
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize } = swiper;
        const r = (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(swiper);
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = !!(swiper.virtual && swiper.params.virtual?.enabled);
        let wrapperRotate = 0;
        let cubeShadowEl = null;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') ?? '0', 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style.setProperty('-webkit-transform-origin', `50% 50% -${swiperSize / 2}px`);
        if (params.shadow && cubeShadowEl) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        wrapperEl.style.transform = `translate3d(0px,0,0px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', '0px');
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect?.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
};



function $fab3d8cd791e5fc7$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl);
    const selector = `.${shadowClass.split(' ').join('.')}`;
    const existing = shadowContainer.querySelector(selector);
    if (existing) return existing;
    const created = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)('div', shadowClass.split(' '));
    shadowContainer.append(created);
    return created;
}






const $68ca3c9f22027c47$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    function getParams() {
        return swiper.params.flipEffect;
    }
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = getParams();
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const rotateFix = (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = String(-Math.abs(Math.round(progress)) + slides.length);
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};






const $983c76c349961a02$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    function getParams() {
        return swiper.params.coverflowEffect;
    }
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset ?? 0;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = typeof params.stretch === 'string' && params.stretch.indexOf('%') !== -1 ? parseFloat(params.stretch) / 100 * slideSize : params.stretch;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = String(-Math.abs(Math.round(offsetMultiplier)) + 1);
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = String(offsetMultiplier > 0 ? offsetMultiplier : 0);
                if (shadowAfterEl) shadowAfterEl.style.opacity = String(-offsetMultiplier > 0 ? -offsetMultiplier : 0);
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
};







const $ed2173e49aa32019$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    function getParams() {
        return swiper.params.creativeEffect;
    }
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - (swiper.params.slidesOffsetBefore ?? 0);
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress ?? 0, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((_value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = String(Math.min(Math.max(Math.abs(shadowOpacity), 0), 1));
                }
            }
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = String(opacityString);
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>getParams().perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};







const $e7abdc2d61949d3e$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    function getParams() {
        return swiper.params.cardsEffect;
    }
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset ?? 0;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset ?? 0;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual?.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) < (startTranslate ?? 0);
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) > (startTranslate ?? 0);
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = String(Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1));
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: getParams().rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};


// Swiper Class
const $203e13e0cf52b934$var$modules = [
    (0, $33834d902fe381ab$export$2e2bcd8739ae039),
    (0, $52e509fb8653e0d9$export$2e2bcd8739ae039),
    (0, $05e7c97b57a34c96$export$2e2bcd8739ae039),
    (0, $9dcb69c205fd1703$export$2e2bcd8739ae039),
    (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039),
    (0, $c7252c6c2cf4bba7$export$2e2bcd8739ae039),
    (0, $c36b71b742710ea0$export$2e2bcd8739ae039),
    (0, $401de11e8a126d45$export$2e2bcd8739ae039),
    (0, $411c83a941bc1076$export$2e2bcd8739ae039),
    (0, $9649bf9a787c3914$export$2e2bcd8739ae039),
    (0, $38bb61499ef50fab$export$2e2bcd8739ae039),
    (0, $87b0baa371d09db8$export$2e2bcd8739ae039),
    (0, $c1783ac9556c9fef$export$2e2bcd8739ae039),
    (0, $21e2f533778c20f0$export$2e2bcd8739ae039),
    (0, $49f3fa363ac09256$export$2e2bcd8739ae039),
    (0, $3e2c28ea1ae0e231$export$2e2bcd8739ae039),
    (0, $eb2d45639f1e8538$export$2e2bcd8739ae039),
    (0, $5d17e4afe2f572c9$export$2e2bcd8739ae039),
    (0, $7a34974922f14d54$export$2e2bcd8739ae039),
    (0, $68ca3c9f22027c47$export$2e2bcd8739ae039),
    (0, $983c76c349961a02$export$2e2bcd8739ae039),
    (0, $ed2173e49aa32019$export$2e2bcd8739ae039),
    (0, $e7abdc2d61949d3e$export$2e2bcd8739ae039)
];
(0, $029bc59d811a92d7$export$25ce5a424b770e84).use($203e13e0cf52b934$var$modules);


// Swup replaces the DOM on each transition, so instances must be
// destroyed and re-created (with freshly queried elements) every time.
let $67d17622a38f5e17$var$carousel = null;
let $67d17622a38f5e17$var$galleryThumbs = null;
let $67d17622a38f5e17$var$galleryMain = null;
const $67d17622a38f5e17$var$destroySwiper = ()=>{
    if ($67d17622a38f5e17$var$carousel) {
        $67d17622a38f5e17$var$carousel.destroy(true, true);
        $67d17622a38f5e17$var$carousel = null;
    }
    if ($67d17622a38f5e17$var$galleryMain) {
        $67d17622a38f5e17$var$galleryMain.destroy(true, true);
        $67d17622a38f5e17$var$galleryMain = null;
    }
    if ($67d17622a38f5e17$var$galleryThumbs) {
        $67d17622a38f5e17$var$galleryThumbs.destroy(true, true);
        $67d17622a38f5e17$var$galleryThumbs = null;
    }
};
const $67d17622a38f5e17$var$initSwiper = ()=>{
    $67d17622a38f5e17$var$destroySwiper();
    const carouselEl = document.querySelector(".carousel");
    const galleryThumbsEl = document.querySelector(".gallery-thumbs");
    const galleryMainEl = document.querySelector(".gallery");
    if (carouselEl) $67d17622a38f5e17$var$carousel = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(carouselEl, {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            type: "dots"
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });
    if (galleryThumbsEl) $67d17622a38f5e17$var$galleryThumbs = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(galleryThumbsEl, {
        spaceBetween: 12,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true
    });
    if (galleryMainEl) {
        $67d17622a38f5e17$var$galleryMain = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(galleryMainEl, {
            spaceBetween: 12,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            thumbs: {
                swiper: $67d17622a38f5e17$var$galleryThumbs
            }
        });
        const updateActiveThumb = ()=>{
            if (!$67d17622a38f5e17$var$galleryThumbs) return;
            $67d17622a38f5e17$var$galleryThumbs.slides.forEach((slide)=>{
                slide.classList.remove("border-blue");
            });
            $67d17622a38f5e17$var$galleryThumbs.slides[$67d17622a38f5e17$var$galleryMain.activeIndex]?.classList.add("border-blue");
        };
        $67d17622a38f5e17$var$galleryMain.on("slideChange", updateActiveThumb);
        updateActiveThumb();
        const variantButtons = document.querySelectorAll('button[id^="variant-"]');
        // Function to set the active variant button based on the currently active slide.
        const setActiveVariant = (activeButton)=>{
            variantButtons.forEach((variantButton)=>{
                const isActive = variantButton === activeButton;
                variantButton.classList.toggle("bg-blue", isActive);
                variantButton.classList.toggle("text-white", isActive);
                variantButton.setAttribute("aria-pressed", isActive ? "true" : "false");
            });
        };
        // Each variant's slides are prefixed with its button id, e.g. "variant-x-1".
        const updateActiveVariant = ()=>{
            const currentSlide = $67d17622a38f5e17$var$galleryMain.slides[$67d17622a38f5e17$var$galleryMain.activeIndex];
            if (!currentSlide) return;
            const activeButton = Array.from(variantButtons).find((variantButton)=>currentSlide.id.startsWith(`${variantButton.id}-`));
            if (activeButton) setActiveVariant(activeButton);
        };
        $67d17622a38f5e17$var$galleryMain.on("slideChange", updateActiveVariant);
        updateActiveVariant();
        // Handle variant button clicks to navigate to the corresponding slide and set the active variant.
        variantButtons.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const firstImage = document.getElementById(`${button.id}-1`);
                const slideIndex = $67d17622a38f5e17$var$galleryMain.slides.indexOf(firstImage);
                if (slideIndex >= 0) $67d17622a38f5e17$var$galleryMain.slideTo(slideIndex);
                setActiveVariant(button);
            });
        });
    }
};
var $67d17622a38f5e17$export$2e2bcd8739ae039 = $67d17622a38f5e17$var$initSwiper;




const $8c7533bcfafc73a8$var$selectors = [
    ":is(figure, img, svg, video, iframe):not(.background-image)",
    ":is(h1, h2, h3, h4, h5, h6, p, li, a:not(.edit))",
    ":is(blockquote, form, table, details)",
    ":is(.button, .breadcrumb, .filter, .pagination, .item, .card, .swiper:not(.carousel), .richtext)"
].join(", ");
// Viewport detection functions
function $8c7533bcfafc73a8$var$isInViewport(targets) {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return targets.filter((el)=>{
        const rect = el.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < viewportHeight * 0.9;
    });
}
function $8c7533bcfafc73a8$var$isAboveViewport(targets) {
    return targets.filter((el)=>{
        const rect = el.getBoundingClientRect();
        return rect.bottom <= 0;
    });
}
// Set the initial state of targets that are above the viewport
// to be visible and in their final position.
function $8c7533bcfafc73a8$var$showAboveViewportTargets(targets) {
    const aboveViewportTargets = $8c7533bcfafc73a8$var$isAboveViewport(targets);
    if (!aboveViewportTargets.length) return;
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(aboveViewportTargets, {
        autoAlpha: 1,
        y: 0
    });
}
// Animate targets that are currently in the viewport on page load
function $8c7533bcfafc73a8$var$animateViewportTargets(targets) {
    const viewportTargets = $8c7533bcfafc73a8$var$isInViewport(targets);
    if (!viewportTargets.length) return;
    (0, $f3bc927f09a8d458$export$99ee26438460406a).to(viewportTargets, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.12,
        duration: 0.7,
        ease: "power2.out"
    });
}
// Animate the remaining targets as they enter the viewport on scroll
function $8c7533bcfafc73a8$var$animateScrollTargets(targets) {
    const scrollTargets = targets;
    if (!scrollTargets.length) return;
    (0, $ae5f928ed8e7c926$export$875bcbe48555930).batch(scrollTargets, {
        start: "top 90%",
        onEnter: (batch)=>(0, $f3bc927f09a8d458$export$99ee26438460406a).to(batch, {
                autoAlpha: 1,
                y: 0,
                stagger: 0.12,
                duration: 0.7,
                ease: "power2.out"
            }),
        onLeaveBack: (batch)=>(0, $f3bc927f09a8d458$export$99ee26438460406a).to(batch, {
                autoAlpha: 0,
                y: 24,
                stagger: 0.12,
                duration: 0.7,
                ease: "power2.out"
            })
    });
}
function $8c7533bcfafc73a8$var$initAnimateOnScroll() {
    const main = document.querySelector("main");
    if (!main) return;
    // Get all animation targets, filtering out any that
    // are nested inside other targets.
    const targets = (0, $f3bc927f09a8d458$export$99ee26438460406a).utils.toArray(main.querySelectorAll($8c7533bcfafc73a8$var$selectors)).filter((el)=>!el.parentElement?.closest($8c7533bcfafc73a8$var$selectors));
    if (!targets.length) return;
    // Set initial state for all targets
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(targets, {
        autoAlpha: 0,
        y: 24
    });
    $8c7533bcfafc73a8$var$showAboveViewportTargets(targets);
    $8c7533bcfafc73a8$var$animateViewportTargets(targets);
    $8c7533bcfafc73a8$var$animateScrollTargets(targets);
    (0, $ae5f928ed8e7c926$export$875bcbe48555930).refresh();
}
var $8c7533bcfafc73a8$export$2e2bcd8739ae039 = $8c7533bcfafc73a8$var$initAnimateOnScroll;


(0, $f3bc927f09a8d458$export$99ee26438460406a).registerPlugin((0, $ae5f928ed8e7c926$export$875bcbe48555930));
const $089c40fcbb903d20$var$prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $089c40fcbb903d20$var$initAll = ()=>{
    (0, $edad02cabd4239fa$export$2e2bcd8739ae039)();
    (0, $67d17622a38f5e17$export$2e2bcd8739ae039)();
    if (!$089c40fcbb903d20$var$prefersReducedMotion) (0, $8c7533bcfafc73a8$export$2e2bcd8739ae039)();
};
$089c40fcbb903d20$var$initAll();
const $089c40fcbb903d20$var$swupContainer = document.querySelector("#swup");
if ($089c40fcbb903d20$var$swupContainer) {
    const swup = new (0, $d756dbc053e9c131$export$2e2bcd8739ae039)({
        containers: [
            "#swup"
        ],
        linkToSelf: "navigate",
        plugins: [
            new (0, $ad959d4ee38cbe75$export$2e2bcd8739ae039)({
                awaitAssets: true,
                persistTags: true
            }),
            new (0, $6e909e2c194aa611$export$2e2bcd8739ae039)(),
            new (0, $45a279ded9626458$export$2e2bcd8739ae039)({
                animateScroll: {
                    betweenPages: false,
                    samePageWithHash: !$089c40fcbb903d20$var$prefersReducedMotion,
                    samePage: false
                }
            })
        ]
    });
    swup.hooks.on("page:view", ()=>{
        $089c40fcbb903d20$var$initAll();
        (0, $d5f992f8158b4022$export$a3faa35d33130f1f)();
    });
    swup.hooks.on("visit:start", ()=>{
        (0, $d5f992f8158b4022$export$c9e788aaf7edc9f8)();
        (0, $ae5f928ed8e7c926$export$875bcbe48555930).killAll();
    });
}

})();
//# sourceMappingURL=main.js.map
